webpackJsonp([1],{

/***/ 178:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

var _reactStatic = __webpack_require__(114);

var _NewFooterV = __webpack_require__(544);

var _NewFooterV2 = _interopRequireDefault(_NewFooterV);

var _DemoForm = __webpack_require__(542);

var _DemoForm2 = _interopRequireDefault(_DemoForm);

var _LazyYouTube = __webpack_require__(580);

var _LazyYouTube2 = _interopRequireDefault(_LazyYouTube);

var _StatsStripV = __webpack_require__(640);

var _StatsStripV2 = _interopRequireDefault(_StatsStripV);

var _NewMenu = __webpack_require__(551);

var _NewMenu2 = _interopRequireDefault(_NewMenu);

var _HomeSolutionsTabsV6Test = __webpack_require__(681);

var _HomeSolutionsTabsV6Test2 = _interopRequireDefault(_HomeSolutionsTabsV6Test);

var _IndustriesAndDistributorsTest = __webpack_require__(685);

var _IndustriesAndDistributorsTest2 = _interopRequireDefault(_IndustriesAndDistributorsTest);

var _CommercialRepsV = __webpack_require__(687);

var _CommercialRepsV2 = _interopRequireDefault(_CommercialRepsV);

var _ClientLogosSliderTest = __webpack_require__(642);

var _ClientLogosSliderTest2 = _interopRequireDefault(_ClientLogosSliderTest);

var _TestimonialsVideoCardsV5Test = __webpack_require__(689);

var _TestimonialsVideoCardsV5Test2 = _interopRequireDefault(_TestimonialsVideoCardsV5Test);

var _FinalCTACard = __webpack_require__(569);

var _FinalCTACard2 = _interopRequireDefault(_FinalCTACard);

var _FAQV6Test = __webpack_require__(690);

var _FAQV6Test2 = _interopRequireDefault(_FAQV6Test);

var _CardsEstrategiasHomeV = __webpack_require__(691);

var _CardsEstrategiasHomeV2 = _interopRequireDefault(_CardsEstrategiasHomeV);

var _CompoundTitle = __webpack_require__(693);

var _CompoundTitle2 = _interopRequireDefault(_CompoundTitle);

__webpack_require__(695);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var videoObjectSchema = {
  "@context": "https://schema.org",
  "@type": "VideoObject",
  "name": "Mercos: o sistema de vendas completo para indústrias, distribuidoras e representantes",
  "description": "Conheça o Mercos, sistema de vendas líder de mercado feito para indústrias, distribuidoras e representantes. O vídeo apresenta a jornada comercial completa da plataforma: CRM com gestão de carteira, prospecção, roteiro de visitas e histórico de clientes; Força de Vendas com aplicativo para emissão de pedidos offline, inteligência artificial e automações; E-commerce B2B para escalar operações com catálogo personalizado, preços e condições por cliente; além de múltiplas integrações com ERP, Mercos Pay e mais de 25 relatórios e indicadores. Tudo integrado em um único sistema, sem complicação.",
  "thumbnailUrl": ["https://img.youtube.com/vi/6M5mFpZTxII/maxresdefault.jpg"],
  "uploadDate": "2026-04-09T19:00:00-03:00",
  "duration": "PT2M42S",
  "contentUrl": "https://www.youtube.com/watch?v=6M5mFpZTxII",
  "embedUrl": "https://www.youtube.com/embed/6M5mFpZTxII",
  "url": "https://mercos.com/",
  "inLanguage": "pt-BR",
  "keywords": ["sistema de vendas", "CRM de vendas", "força de vendas", "e-commerce B2B", "automação de vendas"],
  "about": {
    "@type": "SoftwareApplication",
    "name": "Mercos",
    "applicationCategory": "BusinessApplication",
    "operatingSystem": "Web, Android, iOS",
    "url": "https://mercos.com/"
  },
  "publisher": {
    "@type": "Organization",
    "name": "Mercos",
    "url": "https://www.mercos.com/",
    "logo": {
      "@type": "ImageObject",
      "url": "https://mercos.com/images/site/logo-mercos-colored.svg"
    }
  },
  "author": {
    "@type": "Organization",
    "name": "Mercos",
    "url": "https://www.mercos.com/"
  },
  "copyrightHolder": {
    "@type": "Organization",
    "name": "Mercos"
  },
  "isFamilyFriendly": true,
  "potentialAction": {
    "@type": "WatchAction",
    "target": "https://www.youtube.com/watch?v=6M5mFpZTxII"
  }
};

var organizationSchema = {
  "@context": "https://schema.org",
  "@type": "Organization",
  "@id": "https://mercos.com/#organization",
  "name": "Mercos",
  "description": "Mercos é o sistema de venda que reúne, em um só lugar: IA, automação de pedidos, gestão, CRM, e-commerce B2B, solução de pagamento e integração com ERPs.",
  "taxID": "12.496.510/0001-80",
  "email": "contato@mercos.com",
  "telephone": "(47) 3481-8050",
  "logo": "https://simplest-marketing.s3.amazonaws.com/imagens/logo-mercos-colored.png",
  "url": "https://mercos.com/",
  "address": {
    "@type": "PostalAddress",
    "addressLocality": "Joinville",
    "addressRegion": "Santa Catarina",
    "postalCode": "89223-005",
    "streetAddress": "Av. Rolf Wiest, 277",
    "addressCountry": {
      "@type": "Country",
      "name": "BR"
    }
  }
};

var NewHomev6 = function (_Component) {
  _inherits(NewHomev6, _Component);

  function NewHomev6(props) {
    _classCallCheck(this, NewHomev6);

    var _this = _possibleConstructorReturn(this, (NewHomev6.__proto__ || Object.getPrototypeOf(NewHomev6)).call(this, props));

    _this.handleScroll = function () {
      // If mobile menu is open, do not hide the nav bar
      if (document.body.classList.contains("mobile-menu-is-open")) {
        return;
      }

      var currentScrollTop = window.pageYOffset || document.documentElement.scrollTop;

      // Detect scroll direction (with small threshold to avoid jitter)
      if (Math.abs(currentScrollTop - _this.scrollDirection.lastScrollTop) > 5) {
        _this.scrollDirection.isScrollingDown = currentScrollTop > _this.scrollDirection.lastScrollTop;
        _this.scrollDirection.lastScrollTop = currentScrollTop;

        // Update menu visibility based on scroll direction
        // Hide menu when scrolling down after leaving top, show when scrolling up
        var menuVisible = currentScrollTop <= 100 || !_this.scrollDirection.isScrollingDown;
        _this.setState({ menuVisible: menuVisible });
      }
    };

    _this.state = {
      menuVisible: true
    };

    // Initialize scroll direction tracking
    _this.scrollDirection = {
      lastScrollTop: 0,
      isScrollingDown: false
    };
    return _this;
  }

  _createClass(NewHomev6, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      // Add scroll listener for menu hide/show
      window.addEventListener("scroll", this.handleScroll, { passive: true });
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      window.removeEventListener("scroll", this.handleScroll);
    }
  }, {
    key: "render",
    value: function render() {
      var menuVisible = this.state.menuVisible;

      return _react2.default.createElement(
        _react.Fragment,
        null,
        _react2.default.createElement(
          "div",
          { className: "new-home new-home-v3 new-home-v6-preview new-layout" },
          _react2.default.createElement(_NewMenu2.default, { transparentOnTop: true, pixelsToShowMenuWhite: 50, mutableMenu: true, hideOnScroll: true, menuVisible: menuVisible }),
          _react2.default.createElement(
            _reactStatic.Head,
            null,
            _react2.default.createElement(
              "title",
              null,
              "Mercos: sistema de vendas n\xB01 que atua da prospec\xE7\xE3o ao p\xF3s-venda"
            ),
            _react2.default.createElement("meta", { name: "description", content: "Mercos \xE9 o sistema de venda que re\xFAne, em um s\xF3 lugar: IA, automa\xE7\xE3o de pedidos, gest\xE3o, CRM, e-commerce B2B, solu\xE7\xE3o de pagamento e integra\xE7\xE3o com ERPs" }),
            _react2.default.createElement("meta", { property: "og:title", content: "Mercos: sistema de vendas n\xB01 que atua da prospec\xE7\xE3o ao p\xF3s-venda" }),
            _react2.default.createElement("meta", { property: "og:description", content: "Mercos \xE9 o sistema de venda que re\xFAne, em um s\xF3 lugar: IA, automa\xE7\xE3o de pedidos, gest\xE3o, CRM, e-commerce B2B, solu\xE7\xE3o de pagamento e integra\xE7\xE3o com ERPs" }),
            _react2.default.createElement("meta", { name: "twitter:title", content: "Mercos: sistema de vendas n\xB01 que atua da prospec\xE7\xE3o ao p\xF3s-venda" }),
            _react2.default.createElement("meta", { name: "twitter:description", content: "Mercos \xE9 o sistema de venda que re\xFAne, em um s\xF3 lugar: IA, automa\xE7\xE3o de pedidos, gest\xE3o, CRM, e-commerce B2B, solu\xE7\xE3o de pagamento e integra\xE7\xE3o com ERPs" }),
            _react2.default.createElement("link", { rel: "canonical", href: "https://mercos.com" }),
            _react2.default.createElement(
              "script",
              { type: "application/ld+json" },
              JSON.stringify(organizationSchema)
            ),
            _react2.default.createElement(
              "script",
              { type: "application/ld+json" },
              JSON.stringify(videoObjectSchema)
            ),
            _react2.default.createElement(
              "script",
              { type: "application/ld+json" },
              JSON.stringify(_FAQV6Test.FAQV6_SCHEMA)
            )
          ),
          _react2.default.createElement(
            "section",
            { className: "hero-section-v6" },
            _react2.default.createElement(
              "div",
              { className: "container" },
              _react2.default.createElement(
                "div",
                { className: "hero-content" },
                _react2.default.createElement(
                  "h1",
                  { className: "hero-title" },
                  "O sistema de vendas ",
                  _react2.default.createElement(
                    "span",
                    { className: "gradient-text" },
                    "l\xEDder"
                  ),
                  " para Ind\xFAstrias, Distribuidoras e Representantes"
                ),
                _react2.default.createElement(
                  "h2",
                  { className: "hero-description" },
                  "Descubra a plataforma que re\xFAne Intelig\xEAncia Artificial, automa\xE7\xE3o de pedidos, gest\xE3o de vendas e produtos, CRM, e-commerce B2B, solu\xE7\xE3o de pagamentos e integra\xE7\xE3o com ERP: tudo em um s\xF3 lugar"
                ),
                _react2.default.createElement(
                  "div",
                  { className: "hero-cta" },
                  _react2.default.createElement(_DemoForm2.default, null)
                )
              ),
              _react2.default.createElement(
                "div",
                { className: "hero-video" },
                _react2.default.createElement(_LazyYouTube2.default, {
                  videoId: "6M5mFpZTxII",
                  coverImage: "/images/site/new-home/v6/hero-video.png",
                  title: "Video institucional Mercos",
                  width: 980,
                  height: 551,
                  playerParams: "rel=0&modestbranding=1&playsinline=1",
                  useNoCookie: true
                })
              )
            )
          ),
          _react2.default.createElement(
            "section",
            { className: "results-section-v6" },
            _react2.default.createElement(_StatsStripV2.default, null)
          ),
          _react2.default.createElement(
            "section",
            { className: "results-logos-section-v6" },
            _react2.default.createElement(
              "div",
              { className: "container" },
              _react2.default.createElement(_ClientLogosSliderTest2.default, { className: "home-results-logos-slider" })
            )
          ),
          _react2.default.createElement(
            "section",
            { className: "solutions-tabs-section-v6" },
            _react2.default.createElement(_HomeSolutionsTabsV6Test2.default, null)
          ),
          _react2.default.createElement(
            "section",
            { className: "single-title-section-v6" },
            _react2.default.createElement(
              "div",
              { className: "container" },
              _react2.default.createElement(
                _CompoundTitle2.default,
                { center: true, tag: "h3" },
                "Para quem \xE9 o sistema de vendas da Mercos?"
              )
            )
          ),
          _react2.default.createElement(
            "section",
            { className: "industries-distributors-section-v6 accordion-section-v6" },
            _react2.default.createElement(_IndustriesAndDistributorsTest2.default, {
              imageSrc: "/images/site/new-home/v6/section-industries-distributors.png",
              imageAlt: "Sistema Mercos na aba de pol\xEDticas comerciais, mostrando como a gest\xE3o de uma ind\xFAstria ou distribuidora pode criar regras comerciais personalizadas para as necessidades da opera\xE7\xE3o. A tela exibe o bot\xE3o \"nova condi\xE7\xE3o de pagamento\", pol\xEDticas j\xE1 criadas com valor m\xEDnimo, forma de pagamento e n\xFAmero de parcelas, al\xE9m de op\xE7\xF5es de navega\xE7\xE3o para indicadores, funis de vendas, pedidos, clientes, produtos, e-commerce B2B, tarefas e Mercos IA.",
              titleTag: "h4"
            })
          ),
          _react2.default.createElement(
            "section",
            { className: "commercial-reps-section-v6 accordion-section-v6" },
            _react2.default.createElement(_CommercialRepsV2.default, {
              imageSrc: "/images/site/new-home/v6/section-representatives.png",
              imageAlt: "Celular mostrando a Mercos IA, a intelig\xEAncia artificial da Mercos, capaz de criar pedidos, responder perguntas sobre a opera\xE7\xE3o comercial de uma ind\xFAstria, distribuidora ou equipe de vendas e trazer insights valiosos para a gest\xE3o comercial e representa\xE7\xE3o. Na tela aparecem sugest\xF5es de perguntas, como \"como est\xE3o minhas vendas este m\xEAs?\", \"qual \xE9 o ranking de vendedores?\", \"quais s\xE3o meus principais clientes?\" e \"qual o valor vendido por estado do cliente ABC?\", al\xE9m de exemplos de a\xE7\xF5es, como marcar um pedido como vendido e emitir um pedido.",
              featureCopy: [{
                title: "App de vendas com IA",
                description: "Emita pedidos com IA de qualquer lugar pelo celular ou tablet, mesmo offline (Android e iOS)"
              }, {
                title: "E-commerce para representantes",
                description: "Destaque seus produtos por representada, com as condições específicas de cada cliente"
              }, {
                title: "CRM diretamente no WhatsApp",
                description: "Consulte informações dos clientes, como histórico e pedidos, sem sair da conversa"
              }, {
                title: "Agenda e Roteirização",
                description: "Planeje visitas e organize o tempo de trabalho, otimizando deslocamento e produtividade"
              }],
              titleTag: "h4"
            })
          ),
          _react2.default.createElement(
            "section",
            { className: "strategies-section-v6" },
            _react2.default.createElement(_CardsEstrategiasHomeV2.default, {
              titleTag: "h3",
              cards: [{
                imgSrc: "/images/site/new-home/update/solucoes-ia.png",
                imgAlt: "Homem sorrindo e olhando para o celular, feliz por atender o cliente com as soluções com IA da Mercos. Ao seu lado aparece, com zoom na tela, que ele faturou um pedido com facilidade.",
                title: _react2.default.createElement(
                  "span",
                  { className: "ia-card-title" },
                  "Solu\xE7\xF5es com IA",
                  _react2.default.createElement("img", {
                    src: "/images/site/recursos/sparkle.svg",
                    alt: "",
                    "aria-hidden": "true",
                    className: "ia-card-title-sparkle"
                  })
                ),
                description: "Com o Mercos IA, você automatiza pedidos, responde dúvidas pelo WhatsApp, cria indicadores, resume históricos e acelera decisões",
                link: '/recursos/mercos-ia/'
              }, {
                imgSrc: "/images/site/new-home/update/suporte.png",
                imgAlt: 'Imagem do chat em tempo real do sistema de vendas, mostrando a pergunta "Olá, estou com uma dúvida, pode me ajudar?" e a resposta "Claro! Como posso lhe ajudar?"',
                title: _react2.default.createElement(
                  _react.Fragment,
                  null,
                  "Suporte",
                  _react2.default.createElement("br", null),
                  " em tempo real"
                ),
                description: "Respondemos em até 20 segundos no chat e WhatsApp ou por telefone e e-mail, em horário comercial"
              }, {
                imgSrc: "/images/site/new-home/update/indicadores.png",
                imgAlt: 'Imagem de alguns exemplos de indicadores em um sistema de vendas. Em foco, é possível ver "Top clientes", "Positivação de Clientes", "Curva ABC de Clientes", "Painel financeiro", com bonificação e "Faturamento", todos disponíveis na aba "Indicadores" do Mercos',
                title: _react2.default.createElement(
                  _react.Fragment,
                  null,
                  "Indicadores",
                  _react2.default.createElement("br", null),
                  " personaliz\xE1veis"
                ),
                description: "Acesse +25 indicadores prontos ou crie qualquer indicador com IA, com segurança e confiabilidade",
                link: '/recursos/indicadores-performance/'
              }, {
                imgSrc: "/images/site/new-home/update/apoio.png",
                imgAlt: "Tela com código representando a tecnologia e a automação de vendas B2B para indústrias e distribuidoras, com apoio para a equipe de TI.",
                title: _react2.default.createElement(
                  _react.Fragment,
                  null,
                  "Apoio integral para",
                  _react2.default.createElement("br", null),
                  " sua equipe de TI"
                ),
                description: "Equipe profissional e preparada para tirar dúvidas do time de TI"
              }, {
                imgSrc: "/images/site/new-home/update/mercos-pay.png",
                imgAlt: 'Imagem de um pedido feito na solução de pagamentos Mercos Pay. É possível ver que o comprador montou um carrinho, passou pela etapa de entrega e agora está na etapa de pagamento. A imagem mostra um pagamento sendo feito por boleto bancário, com quantidade de parcelas e detalhes do parcelamento.',
                title: "Mercos Pay",
                description: "A solução de pagamentos da Mercos permite recebimentos por cartão, boleto, link de pagamento ou Pix, direto do sistema",
                link: '/mercos-pay/'
              }, {
                imgSrc: "/images/site/new-home/update/e-commerce.png",
                imgAlt: 'Imagem do E-commerce B2B Mercos com Videochamada, mostrando um site que vende canecas B2B, ou seja, para outras empresas. É possível ver uma caneca preta com a base bege, outra caneca preta com o topo cinza e uma jarra preta com cabo bege à venda, para que os clientes comprem diretamente do site, com o vendedor podendo acompanhar de perto por vídeo.',
                title: _react2.default.createElement(
                  _react.Fragment,
                  null,
                  "E-commerce B2B",
                  _react2.default.createElement("br", null),
                  " com Videochamada"
                ),
                description: "Clientes compram e tiram dúvidas online com os vendedores, com uma experiência próxima do atendimento presencial",
                link: '/e-commerce-b2b/'
              }]
            })
          ),
          _react2.default.createElement(
            "section",
            { className: "testimonials-section-v6" },
            _react2.default.createElement(_TestimonialsVideoCardsV5Test2.default, {
              showClientLogos: false,
              customTestimonials: [{
                testimonial: _react2.default.createElement(
                  _react.Fragment,
                  null,
                  "\"Com o Mercos, os vendedores geram or\xE7amentos e emitem pedidos sem complica\xE7\xE3o e sem controles manuais. Isso reduz erros, economiza tempo e acaba com a necessidade de levar trabalho para casa, j\xE1 que o sistema resolve tudo na hora\""
                ),
                author: "Mauricio Perin",
                company: "Flach Equipamentos Inteligentes",
                stars: 5,
                img: "mauricio-perin",
                imgAlt: "Mauricio Perin, Flach Equipamentos Inteligentes"
              }, {
                testimonial: _react2.default.createElement(
                  _react.Fragment,
                  null,
                  "\"Hoje, com o Mercos, nosso time comercial fecha vendas e calcula or\xE7amentos em tempo real, com agilidade, sem erros e em um s\xF3 lugar. J\xE1 o time interno foca demandas mais estrat\xE9gicas, j\xE1 que n\xE3o h\xE1 mais retrabalho na digita\xE7\xE3o de pedidos\""
                ),
                author: "Natália Costa",
                company: "Vouga Decor",
                stars: 5,
                img: "natalia-costa",
                imgAlt: "Natália Costa, Vouga Decor"
              }, {
                testimonial: _react2.default.createElement(
                  _react.Fragment,
                  null,
                  "\"Com o e-commerce B2B, nossos clientes ampliam o mix de compras e nos veem como uma empresa mais atualizada e acess\xEDvel. Utilizamos a plataforma de forma estrat\xE9gica e aumentamos vendas, fideliza\xE7\xE3o e a liberdade dos clientes de comprar a qualquer hora\""
                ),
                author: "Eduarda Berwanger",
                company: "Berwanger Abrasivos",
                stars: 5
              }]
            })
          ),
          _react2.default.createElement(_FAQV6Test2.default, { useSemanticHeadings: true }),
          _react2.default.createElement(_FinalCTACard2.default, {
            buttonVariant: "white",
            title: "+ 9 mil empresas j\xE1 usam o sistema l\xEDder de mercado",
            description: "Proteja suas pol\xEDticas comerciais e deixe o Mercos automatizar sua opera\xE7\xE3o de ponta a ponta, garantindo que cada venda siga as regras do seu neg\xF3cio"
          }),
          _react2.default.createElement(_NewFooterV2.default, null)
        )
      );
    }
  }]);

  return NewHomev6;
}(_react.Component);

exports.default = (0, _reactStatic.withSiteData)(NewHomev6);

/***/ }),

/***/ 530:
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
  Copyright (c) 2018 Jed Watson.
  Licensed under the MIT License (MIT), see
  http://jedwatson.github.io/classnames
*/
/* global define */

(function () {
	'use strict';

	var hasOwn = {}.hasOwnProperty;

	function classNames() {
		var classes = [];

		for (var i = 0; i < arguments.length; i++) {
			var arg = arguments[i];
			if (!arg) continue;

			var argType = typeof arg;

			if (argType === 'string' || argType === 'number') {
				classes.push(arg);
			} else if (Array.isArray(arg)) {
				if (arg.length) {
					var inner = classNames.apply(null, arg);
					if (inner) {
						classes.push(inner);
					}
				}
			} else if (argType === 'object') {
				if (arg.toString === Object.prototype.toString) {
					for (var key in arg) {
						if (hasOwn.call(arg, key) && arg[key]) {
							classes.push(key);
						}
					}
				} else {
					classes.push(arg.toString());
				}
			}
		}

		return classes.join(' ');
	}

	if (typeof module !== 'undefined' && module.exports) {
		classNames.default = classNames;
		module.exports = classNames;
	} else if (true) {
		// register as 'classnames', consistent with npm package name
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = (function () {
			return classNames;
		}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else {
		window.classNames = classNames;
	}
}());


/***/ }),

/***/ 531:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var Picture = function Picture(_ref) {
    var src = _ref.src,
        webpSrc = _ref.webpSrc,
        mobileSrc = _ref.mobileSrc,
        alt = _ref.alt,
        className = _ref.className,
        desktop = _ref.desktop,
        mobile = _ref.mobile,
        noWebp = _ref.noWebp,
        fetchPriority = _ref.fetchPriority,
        width = _ref.width,
        height = _ref.height,
        style = _ref.style,
        loading = _ref.loading,
        onLoad = _ref.onLoad,
        srcSet = _ref.srcSet,
        sizes = _ref.sizes,
        decoding = _ref.decoding,
        imgProps = _objectWithoutProperties(_ref, ['src', 'webpSrc', 'mobileSrc', 'alt', 'className', 'desktop', 'mobile', 'noWebp', 'fetchPriority', 'width', 'height', 'style', 'loading', 'onLoad', 'srcSet', 'sizes', 'decoding']);

    // Detect external URLs - if src starts with http:// or https://, it's external
    var isExternal = src && (src.startsWith('http://') || src.startsWith('https://'));
    // Skip WebP for external URLs or when noWebp prop is explicitly set
    var shouldSkipWebp = noWebp || isExternal;

    var extension = src.split('.').pop();
    var isSvg = extension.toLowerCase() === 'svg';
    var webpSource = webpSrc || src.replace('.' + extension, '.webp');
    var desktopClass = desktop ? 'desktop-only' : '';
    var mobileClass = mobile ? 'mobile-only' : '';
    var loadingValue = loading || (fetchPriority ? "eager" : "lazy");

    // Common img props to pass through
    var commonImgProps = _extends({
        className: className + ' ' + desktopClass + ' ' + mobileClass,
        src: '' + src,
        alt: '' + alt,
        loading: loadingValue,
        width: width,
        height: height,
        style: style,
        onLoad: onLoad,
        srcSet: srcSet,
        sizes: sizes,
        decoding: decoding,
        fetchpriority: fetchPriority }, imgProps);

    // For SVG files, just return a simple img tag without picture/source elements
    if (isSvg) {
        return _react2.default.createElement('img', commonImgProps);
    }

    return _react2.default.createElement(
        'picture',
        null,
        mobileSrc && _react2.default.createElement(
            _react.Fragment,
            null,
            !shouldSkipWebp && _react2.default.createElement('source', {
                srcSet: webpSource + ', ' + mobileSrc.replace('.' + extension, '.webp') + ' 2x',
                media: '(max-width: 990px)',
                type: 'image/webp'
            }),
            _react2.default.createElement('source', {
                srcSet: src + ', ' + mobileSrc + ' 2x',
                media: '(max-width: 990px)',
                type: 'image/' + extension
            })
        ),
        !shouldSkipWebp && _react2.default.createElement('source', { srcSet: '' + webpSource, type: 'image/webp' }),
        _react2.default.createElement('img', commonImgProps)
    );
};

exports.default = Picture;

/***/ }),

/***/ 532:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.createUrlsParamBasedOnCookies = createUrlsParamBasedOnCookies;
exports.redirectWithCookies = redirectWithCookies;

var _jsCookie = __webpack_require__(174);

var _jsCookie2 = _interopRequireDefault(_jsCookie);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function createUrlsParamBasedOnCookies() {
	var campain = _jsCookie2.default.get('mutm_campaign');
	var medium = _jsCookie2.default.get('mutm_medium');
	var source = _jsCookie2.default.get('mutm_source');
	var term = _jsCookie2.default.get('mutm_term');
	var content = _jsCookie2.default.get('mutm_content');
	var fbclid = _jsCookie2.default.get('mfbclid');
	var gclid = _jsCookie2.default.get('mgclid');
	var gad_campaignid = _jsCookie2.default.get('madscampaignid');
	if (campain || medium || source) {
		var params = campain ? '&utm_campaign=' + campain : '';
		params += medium ? '&utm_medium=' + medium : '';
		params += source ? '&utm_source=' + source : '';
		params += term ? '&utm_term=' + term : '';
		params += content ? '&utm_content=' + content : '';
		params += fbclid ? '&fbclid=' + fbclid : '';
		params += gclid ? '&gclid=' + gclid : '';
		params += gad_campaignid ? '&gad_campaignid=' + gad_campaignid : '';
		return '?' + params.slice(1);
	}
	return '';
}

function redirectWithCookies(url) {
	var paramsCookie = createUrlsParamBasedOnCookies();
	var currentURL = window.location.href;

	_jsCookie2.default.set('trial_page_ref', currentURL, { domain: '.mercos.com' });
	window.location = '' + url + paramsCookie;
}

/***/ }),

/***/ 533:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(9);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(530);

var _classnames2 = _interopRequireDefault(_classnames);

__webpack_require__(536);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Button = function Button(_ref) {
    var ariaLabel = _ref.ariaLabel,
        children = _ref.children,
        className = _ref.className,
        disabled = _ref.disabled,
        model = _ref.model,
        onClick = _ref.onClick,
        purple = _ref.purple,
        radius = _ref.radius,
        size = _ref.size,
        _ref$type = _ref.type,
        type = _ref$type === undefined ? 'button' : _ref$type,
        shake = _ref.shake;
    return _react2.default.createElement(
        'button',
        { className: (0, _classnames2.default)('button', model, size, radius, className, purple && 'purple', shake && 'shake'),
            type: type,
            onClick: onClick,
            'aria-label': ariaLabel,
            disabled: disabled },
        children
    );
};

Button.propTypes = {
    className: _propTypes2.default.string,
    ariaLabel: _propTypes2.default.string,
    onClick: _propTypes2.default.func,
    children: _propTypes2.default.any,
    model: _propTypes2.default.oneOf(['alert', 'outline', 'no-borders', 'secondary', 'success', 'warning']),
    size: _propTypes2.default.string,
    type: _propTypes2.default.oneOf(['button', 'submit']),
    radius: _propTypes2.default.oneOf(['right-bottom-only', 'half-rounded', 'all-rounded', 'left-rounded', 'right-rounded', 'not-rounded', 'italic'])
};

exports.default = Button;

/***/ }),

/***/ 534:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 535:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(530);

var _classnames2 = _interopRequireDefault(_classnames);

var _CloseButton = __webpack_require__(538);

var _CloseButton2 = _interopRequireDefault(_CloseButton);

__webpack_require__(540);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getCloseButton = function getCloseButton(callbackCloseModal, hasImage) {
  return _react2.default.createElement(
    'div',
    { className: 'site-close-modal-button' },
    hasImage,
    _react2.default.createElement(_CloseButton2.default, { outlineOnly: !hasImage, onClickButton: callbackCloseModal })
  );
};

var Modal = function Modal(_ref) {
  var className = _ref.className,
      overlayColor = _ref.overlayColor,
      imageURL = _ref.imageURL,
      callbackCloseModal = _ref.callbackCloseModal,
      children = _ref.children,
      video = _ref.video,
      overlayStyles = _ref.overlayStyles,
      hideCloseButton = _ref.hideCloseButton;

  var hasImage = Boolean(imageURL);

  return _react2.default.createElement(
    'div',
    { className: (0, _classnames2.default)('site-modal-container', className) },
    _react2.default.createElement(
      'div',
      {
        className: (0, _classnames2.default)({ 'site-modal-with-image': hasImage, 'site-simple-modal': !hasImage }, video ? 'video' : '', overlayStyles ? overlayStyles : '')
      },
      _react2.default.createElement(
        'div',
        { className: (0, _classnames2.default)('site-modal-content text-left', video ? 'video' : '') },
        children
      ),
      hasImage && _react2.default.createElement('div', {
        className: 'site-modal-image',
        style: { background: 'url(\'' + imageURL + '\') no-repeat center' }
      }),
      !hideCloseButton && getCloseButton(callbackCloseModal, hasImage)
    ),
    _react2.default.createElement('div', {
      className: (0, _classnames2.default)('site-modal-overlay', video ? 'video' : '', overlayColor ? overlayColor : ''),
      onClick: callbackCloseModal
    })
  );
};

exports.default = Modal;

/***/ }),

/***/ 536:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 537:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var telephoneMask = exports.telephoneMask = function telephoneMask(value) {
    var cleanTelephone = value ? value.replace(/\D/g, "") : '';
    var numberLength = cleanTelephone.length;

    if (numberLength > 10) {
        cleanTelephone = cleanTelephone.slice(0, 7) + '-' + cleanTelephone.slice(7);
    } else if (numberLength > 6 && numberLength < 11) {
        cleanTelephone = cleanTelephone.slice(0, 6) + '-' + cleanTelephone.slice(6);
    }

    if (numberLength > 2) {
        cleanTelephone = cleanTelephone.slice(0, 2) + ') ' + cleanTelephone.slice(2);
    }

    if (numberLength > 0) {
        cleanTelephone = '(' + cleanTelephone.slice(0);
    }

    return cleanTelephone;
};

/***/ }),

/***/ 538:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(530);

var _classnames2 = _interopRequireDefault(_classnames);

__webpack_require__(539);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CloseButton = function CloseButton(_ref) {
    var onClickButton = _ref.onClickButton,
        _ref$outlineOnly = _ref.outlineOnly,
        outlineOnly = _ref$outlineOnly === undefined ? false : _ref$outlineOnly;
    return _react2.default.createElement('button', { className: (0, _classnames2.default)({
            'site-close-button-outline': outlineOnly,
            'site-close-button': !outlineOnly
        }), onClick: onClickButton });
};

exports.default = CloseButton;

/***/ }),

/***/ 539:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 540:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 541:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(9);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(530);

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Input = function Input(_ref) {
    var placeholder = _ref.placeholder,
        inputPlaceholder = _ref.inputPlaceholder,
        onChange = _ref.onChange,
        id = _ref.id,
        error = _ref.error,
        value = _ref.value,
        ariaLabel = _ref.ariaLabel,
        _ref$maxLength = _ref.maxLength,
        maxLength = _ref$maxLength === undefined ? '' : _ref$maxLength,
        model = _ref.model,
        autoFocus = _ref.autoFocus,
        size = _ref.size,
        _ref$radius = _ref.radius,
        radius = _ref$radius === undefined ? 'all-rounded' : _ref$radius,
        _ref$type = _ref.type,
        type = _ref$type === undefined ? 'text' : _ref$type,
        name = _ref.name;
    return _react2.default.createElement(
        'div',
        { className: 'floating-label-wrapper' },
        _react2.default.createElement('input', { className: (0, _classnames2.default)('input', error && 'error', model, size, radius),
            'aria-label': ariaLabel,
            autoFocus: autoFocus,
            id: id,
            maxLength: maxLength,
            onChange: onChange,
            placeholder: inputPlaceholder,
            type: type,
            value: value,
            name: name || id,
            required: true
        }),
        _react2.default.createElement(
            'span',
            { className: 'floating-label' },
            placeholder
        )
    );
};

Input.propTypes = {
    id: _propTypes2.default.string,
    placeholder: _propTypes2.default.string,
    inputPlaceholder: _propTypes2.default.string,
    error: _propTypes2.default.bool,
    value: _propTypes2.default.string,
    ariaLabel: _propTypes2.default.string,
    maxLength: _propTypes2.default.string,
    onChange: _propTypes2.default.func,
    autoFocus: _propTypes2.default.bool,
    model: _propTypes2.default.oneOf(['outline', 'no-borders', 'secondary', 'success', 'alert', 'warning']),
    size: _propTypes2.default.string,
    radius: _propTypes2.default.oneOf(['half-rounded', 'all-rounded', 'left-rounded', 'right-rounded', 'not-rounded'])
};

exports.default = Input;

/***/ }),

/***/ 542:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

var _jsCookie = __webpack_require__(174);

var _jsCookie2 = _interopRequireDefault(_jsCookie);

var _propTypes = __webpack_require__(9);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Picture = __webpack_require__(531);

var _Picture2 = _interopRequireDefault(_Picture);

var _Button = __webpack_require__(533);

var _Button2 = _interopRequireDefault(_Button);

var _Modal = __webpack_require__(535);

var _Modal2 = _interopRequireDefault(_Modal);

var _Input = __webpack_require__(546);

var _Input2 = _interopRequireDefault(_Input);

var _RDGateway = __webpack_require__(175);

var _RDGateway2 = _interopRequireDefault(_RDGateway);

var _masks = __webpack_require__(537);

var _Utm = __webpack_require__(532);

var _ModalTestimonials = __webpack_require__(552);

var _ModalTestimonials2 = _interopRequireDefault(_ModalTestimonials);

var _InputFloatingLabel = __webpack_require__(541);

var _InputFloatingLabel2 = _interopRequireDefault(_InputFloatingLabel);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var FIELDS = ['name', 'email', 'telephone', 'activity', 'users'];

var ACTIVITY = {
    industria: 'Indústria',
    distribuicao: 'Distribuição',
    rep: 'Representação Comercial',
    outra: 'Outro'
};

var USERS = {
    um: '1',
    cinco: '2-5',
    vinte: '6-20',
    cinquenta: '21-50',
    cinquentaum: '51 ou mais'
};

var DemoForm = function (_Component) {
    _inherits(DemoForm, _Component);

    function DemoForm(props) {
        _classCallCheck(this, DemoForm);

        var _this = _possibleConstructorReturn(this, (DemoForm.__proto__ || Object.getPrototypeOf(DemoForm)).call(this, props));

        _this.handleActivityDropdownClick = function (e) {
            var dropdown = e.currentTarget.nextElementSibling;
            var button = e.currentTarget;

            dropdown.classList.toggle('show');
            button.classList.toggle('expanded');
        };

        _this.handleUsersDropdownClick = function (e) {
            var dropdown = e.currentTarget.nextElementSibling;
            var button = e.currentTarget;

            dropdown.classList.toggle('show');
            button.classList.toggle('expanded');
        };

        _this.handleActivityOptionClick = function (activity) {
            var button = document.activeElement.closest('.activity-wrapper').querySelector('.activity-dropdown-button');
            var dropdown = document.activeElement.closest('.activity-wrapper').querySelector('.activity-dropdown');

            dropdown.classList.remove('show');
            button.classList.remove('expanded');
            button.classList.add('option-selected');
            button.textContent = activity;

            _this.handlerEnterpriseActivity(activity);
        };

        _this.handleUsersOptionClick = function (users) {
            var wrapper = document.activeElement.closest('.activity-wrapper');
            var button = wrapper.querySelector('.activity-dropdown-button');
            var dropdown = wrapper.querySelector('.activity-dropdown');

            dropdown.classList.remove('show');
            button.classList.remove('expanded');
            button.classList.add('option-selected');
            button.textContent = users;

            _this.handlerUsers(users);
        };

        _this.rdGateway = new _RDGateway2.default();
        _this.state = _this.getInitialState(props);

        globalThis.optimizeOpenPopup = function () {
            _this.setState({ showDemoModal: true });
        };
        return _this;
    }

    _createClass(DemoForm, [{
        key: 'getInitialState',
        value: function getInitialState(props) {
            var initialObject = {
                showDemoModal: false,
                company: '',
                name: '',
                email: '',
                telephone: '',
                activity: '',
                users: '',
                typingTimeout: 0,
                partnerId: props.partnerId,
                rdWhatsappLauncherReady: false
            };
            FIELDS.forEach(function (campo) {
                initialObject[campo + 'Error'] = false;
                initialObject[campo + 'Typing'] = false;
            });
            return initialObject;
        }
    }, {
        key: 'setDataByCookie',
        value: function setDataByCookie() {
            this.setState({
                partnerId: _jsCookie2.default.get('leaderPartnerId') || this.state.partnerId || ''
            });
        }
    }, {
        key: 'openDemoModal',
        value: function openDemoModal(e) {
            e.preventDefault();

            this.setState({
                showDemoModal: true
            });
        }
    }, {
        key: 'closeDemoModal',
        value: function closeDemoModal() {
            this.setState({
                showDemoModal: false
            });
        }
    }, {
        key: 'handleChange',
        value: function handleChange(e) {
            var _this2 = this,
                _setState;

            var name = e.target.id;
            var value = e.target.value;
            var company = this.state.name + ' - ' + this.state.email;

            if (name === 'telephone') {
                value = this.telephoneMask(value);
            } else if (name === 'name') {
                company = value + ' - ' + this.state.email;
            } else if (name === 'email') {
                value = value.trim();
                company = this.state.name + ' - ' + value;
            }

            if (this.state.typingTimeout) {
                clearTimeout(this.state.typingTimeout);
            }

            this.setState((_setState = {}, _defineProperty(_setState, name, value), _defineProperty(_setState, 'company', company), _defineProperty(_setState, name + 'Error', false), _defineProperty(_setState, name + 'Typing', true), _defineProperty(_setState, 'typingTimeout', setTimeout(function () {
                if (name === 'email' && _this2.validateEmail(_this2.state.email)) {}
            }, 3000)), _setState));
        }
    }, {
        key: 'handlerEnterpriseActivity',
        value: function handlerEnterpriseActivity(tipo) {
            this.setState({ 'activity': tipo });
        }
    }, {
        key: 'getSelectedActivity',
        value: function getSelectedActivity(selected) {
            return this.state.activity === selected ? 'active' : '';
        }
    }, {
        key: 'handlerUsers',
        value: function handlerUsers(tipo) {
            this.setState({ 'users': tipo });
        }
    }, {
        key: 'getSelectedUsers',
        value: function getSelectedUsers(selected) {
            return this.state.users === selected ? 'active' : '';
        }
    }, {
        key: 'validation',
        value: function validation() {
            var _this3 = this;

            var newState = {};
            var fieldsToValidate = FIELDS;

            var regexTelephone = /^\([1-9]{2}\) [2-9][0-9]{3,4}\-[0-9]{4}$/;
            fieldsToValidate.forEach(function (campo) {
                newState[campo + 'Error'] = !_this3.state[campo];
                switch (campo) {
                    case 'email':
                        {
                            newState[campo + 'Error'] = !_this3.validateEmail(_this3.state[campo]);
                            break;
                        }
                    case 'telephone':
                        {
                            newState[campo + 'Error'] = !regexTelephone.test(_this3.state[campo]);
                            break;
                        }
                }
            });
            this.setState(newState);
            var lista = Object.values(newState);
            return lista.every(function (value) {
                return !value;
            });
        }
    }, {
        key: 'validateEmail',
        value: function validateEmail(email) {
            if (!email) return false;
            var trimmedEmail = email.trim();
            var regexEmail = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            return regexEmail.test(trimmedEmail.toLowerCase());
        }
    }, {
        key: 'submitForm',
        value: function submitForm(e) {
            e.preventDefault();
            if (this.validation()) {
                var data = {
                    conversion_identifier: 'solicite-uma-demonstracao-do-meus-pedidos',
                    'cf_tipo_de_conversao': 'Solicitou demonstração',
                    company_name: this.state.company,
                    name: this.state.name,
                    email: this.state.email,
                    personal_phone: this.state.telephone,
                    'cf_atividade_da_empresa': this.state.activity,
                    event_action: 'solicitou_demo',
                    event_label: 'forca_de_vendas'
                };

                data['cf_numero_de_vendedores'] = this.state.users;

                if (this.state.partnerId) {
                    data.conversion_identifier = 'canais-lp';
                    data['cf_codigo_do_parceiro_meus_pedidos'] = this.state.partnerId;
                }

                var redirectLink = 'https://mercos.com/tp/solicitou-demo-fv/';
                if (this.state.activity === ACTIVITY.outra) redirectLink = 'https://materiais.mercos.com/tp-smb-solicitou-demo';else if (this.state.activity === ACTIVITY.rep) redirectLink = 'https://materiais.mercos.com/tp-reps-solicitou-demo';

                this.rdGateway.sendToRDStation(data, redirectLink);
            }
        }
    }, {
        key: 'componentDidMount',
        value: function componentDidMount() {
            this.setDataByCookie();
            if (this.props.replaceTrialWithWhatsapp) {
                this.watchRDWhatsappLauncher();
            }
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            this.stopRDWhatsappPoll();
            if (this.rdWhatsappFallbackTimer) {
                clearTimeout(this.rdWhatsappFallbackTimer);
            }
        }
    }, {
        key: 'isRDWhatsappLauncherReady',
        value: function isRDWhatsappLauncherReady() {
            if (typeof document === 'undefined') return false;
            return Boolean(document.querySelector('.bricks--floating--button.rdstation-popup-js-floating-button'));
        }
    }, {
        key: 'stopRDWhatsappPoll',
        value: function stopRDWhatsappPoll() {
            if (this.rdWhatsappPollTimer) {
                clearInterval(this.rdWhatsappPollTimer);
                this.rdWhatsappPollTimer = null;
            }
        }
    }, {
        key: 'watchRDWhatsappLauncher',
        value: function watchRDWhatsappLauncher() {
            var _this4 = this;

            if (this.isRDWhatsappLauncherReady()) {
                this.setState({ rdWhatsappLauncherReady: true });
                return;
            }

            if (typeof document === 'undefined') return;

            this.rdWhatsappPollTimer = setInterval(function () {
                if (!_this4.isRDWhatsappLauncherReady()) return;
                _this4.setState({ rdWhatsappLauncherReady: true });
                _this4.stopRDWhatsappPoll();
            }, 300);

            this.rdWhatsappFallbackTimer = setTimeout(function () {
                _this4.stopRDWhatsappPoll();
            }, 7000);
        }
    }, {
        key: 'openRDWhatsappLauncher',
        value: function openRDWhatsappLauncher(e) {
            e.preventDefault();

            if (typeof window !== 'undefined' && typeof window.__mercosOpenRDWhatsappLauncher === 'function') {
                if (window.__mercosOpenRDWhatsappLauncher()) return;
            }

            var launcher = typeof document !== 'undefined' ? document.querySelector('.bricks--floating--button.rdstation-popup-js-floating-button') : null;

            if (launcher) {
                launcher.click();
                return;
            }

            (0, _Utm.redirectWithCookies)('https://app.mercos.com/cadastro/');
        }
    }, {
        key: 'getDemoModal',
        value: function getDemoModal() {
            var _this5 = this;

            if (this.props.minimalStyle) {
                return _react2.default.createElement(
                    _Modal2.default,
                    { callbackCloseModal: function callbackCloseModal() {
                            return _this5.closeDemoModal();
                        }, className: this.props.formHeroStyle ? 'form-hero-demo-modal' : undefined },
                    _react2.default.createElement(
                        'div',
                        { className: 'container-form-modal modal-context' },
                        this.getInlineForm()
                    )
                );
            } else if (this.props.modalSmall) {
                return this.getDemoModalSmall();
            } else {
                return _react2.default.createElement(
                    _Modal2.default,
                    { callbackCloseModal: function callbackCloseModal() {
                            return _this5.closeDemoModal();
                        }, className: 'site-simple-modal-testimonials' },
                    _react2.default.createElement(
                        'div',
                        { className: 'modal-header-logo' },
                        _react2.default.createElement('div', { className: 'logo-mercos-new-home' })
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: 'container-form-modal' },
                        _react2.default.createElement(
                            'h4',
                            null,
                            'Solicite uma demonstra\xE7\xE3o'
                        ),
                        this.getForm()
                    ),
                    _react2.default.createElement(_ModalTestimonials2.default, null)
                );
            }
        }
    }, {
        key: 'getDemoModalSmall',
        value: function getDemoModalSmall() {
            var _this6 = this;

            return _react2.default.createElement(
                _Modal2.default,
                { callbackCloseModal: function callbackCloseModal() {
                        return _this6.closeDemoModal();
                    } },
                _react2.default.createElement(
                    'div',
                    { className: 'new-form-wrapper' },
                    _react2.default.createElement(
                        'div',
                        { className: 'container-form-modal' },
                        this.getFormFloatingLabel()
                    )
                )
            );
        }
    }, {
        key: 'telephoneMask',
        value: function telephoneMask(value) {
            var cleanTelephone = value ? value.replace(/\D/g, '') : '';
            var numberLength = cleanTelephone.length;

            if (numberLength > 10) {
                cleanTelephone = cleanTelephone.slice(0, 7) + '-' + cleanTelephone.slice(7);
            } else if (numberLength > 6 && numberLength < 11) {
                cleanTelephone = cleanTelephone.slice(0, 6) + '-' + cleanTelephone.slice(6);
            }

            if (numberLength > 2) {
                cleanTelephone = cleanTelephone.slice(0, 2) + ') ' + cleanTelephone.slice(2);
            }

            if (numberLength > 0) {
                cleanTelephone = '(' + cleanTelephone.slice(0);
            }

            return cleanTelephone;
        }
    }, {
        key: 'getForm',
        value: function getForm() {
            var _this7 = this;

            return _react2.default.createElement(
                'form',
                { action: '.', method: 'POST', className: 'form-rounded-inputs', onSubmit: function onSubmit(e) {
                        return _this7.submitForm(e);
                    } },
                _react2.default.createElement('input', { type: 'hidden', name: 'company', value: this.state.company }),
                _react2.default.createElement(
                    'label',
                    { htmlFor: 'name' },
                    'Nome'
                ),
                _react2.default.createElement(_Input2.default, { id: 'name', value: this.state.name, onChange: function onChange(e) {
                        return _this7.handleChange(e);
                    }, error: this.state.nameError, autoFocus: true }),
                _react2.default.createElement(
                    'label',
                    { htmlFor: 'email' },
                    'E-mail'
                ),
                _react2.default.createElement(_Input2.default, { id: 'email', value: this.state.email, onChange: function onChange(e) {
                        return _this7.handleChange(e);
                    }, error: this.state.emailError }),
                _react2.default.createElement(
                    'label',
                    { htmlFor: 'telephone' },
                    'Telefone'
                ),
                _react2.default.createElement(_Input2.default, { id: 'telephone', value: this.state.telephone, onChange: function onChange(e) {
                        return _this7.handleChange(e);
                    }, error: this.state.telephoneError, maxLength: '15' }),
                _react2.default.createElement(
                    'label',
                    null,
                    'Qual \xE9 a atividade da sua empresa?'
                ),
                _react2.default.createElement(
                    'div',
                    { className: 'group-buttons' },
                    _react2.default.createElement(
                        _Button2.default,
                        { model: 'outline', className: this.getSelectedActivity(ACTIVITY.industria), onClick: function onClick() {
                                return _this7.handlerEnterpriseActivity(ACTIVITY.industria);
                            } },
                        'Ind\xFAstria'
                    ),
                    _react2.default.createElement(
                        _Button2.default,
                        { model: 'outline', className: this.getSelectedActivity(ACTIVITY.distribuicao), onClick: function onClick() {
                                return _this7.handlerEnterpriseActivity(ACTIVITY.distribuicao);
                            } },
                        'Distribui\xE7\xE3o'
                    ),
                    _react2.default.createElement(
                        _Button2.default,
                        { model: 'outline', className: this.getSelectedActivity(ACTIVITY.rep), onClick: function onClick() {
                                return _this7.handlerEnterpriseActivity(ACTIVITY.rep);
                            } },
                        'Representante comercial'
                    ),
                    _react2.default.createElement(
                        _Button2.default,
                        { model: 'outline', className: this.getSelectedActivity(ACTIVITY.outra), onClick: function onClick() {
                                return _this7.handlerEnterpriseActivity(ACTIVITY.outra);
                            } },
                        'Outra'
                    ),
                    this.state.activityError ? _react2.default.createElement(
                        'div',
                        { style: { color: 'red' } },
                        'Oops! Voc\xEA esqueceu de escolher uma op\xE7\xE3o.'
                    ) : null
                ),
                _react2.default.createElement(
                    'label',
                    null,
                    'Qual \xE9 o n\xFAmero de vendedores da sua empresa?'
                ),
                _react2.default.createElement(
                    'div',
                    { className: 'group-buttons' },
                    _react2.default.createElement(
                        _Button2.default,
                        { model: 'outline', className: this.getSelectedUsers(USERS.um), onClick: function onClick() {
                                return _this7.handlerUsers(USERS.um);
                            } },
                        '1'
                    ),
                    _react2.default.createElement(
                        _Button2.default,
                        { model: 'outline', className: this.getSelectedUsers(USERS.cinco), onClick: function onClick() {
                                return _this7.handlerUsers(USERS.cinco);
                            } },
                        '2-5'
                    ),
                    _react2.default.createElement(
                        _Button2.default,
                        { model: 'outline', className: this.getSelectedUsers(USERS.vinte), onClick: function onClick() {
                                return _this7.handlerUsers(USERS.vinte);
                            } },
                        '6-20'
                    ),
                    _react2.default.createElement(
                        _Button2.default,
                        { model: 'outline', className: this.getSelectedUsers(USERS.cinquenta), onClick: function onClick() {
                                return _this7.handlerUsers(USERS.cinquenta);
                            } },
                        '21-50'
                    ),
                    _react2.default.createElement(
                        _Button2.default,
                        { model: 'outline', className: this.getSelectedUsers(USERS.cinquentaum), onClick: function onClick() {
                                return _this7.handlerUsers(USERS.cinquentaum);
                            } },
                        '51 ou mais'
                    ),
                    this.state.usersError ? _react2.default.createElement(
                        'div',
                        { style: { color: 'red' } },
                        'Oops! Voc\xEA esqueceu de escolher uma op\xE7\xE3o.'
                    ) : null
                ),
                _react2.default.createElement(
                    'div',
                    { className: 'submit-demo-modal' },
                    _react2.default.createElement(
                        _Button2.default,
                        { type: 'submit', radius: this.props.contaAzul ? 'all-rounded' : 'half-rounded', className: this.props.contaAzul && 'conta-azul' },
                        this.props.children || 'SOLICITAR'
                    )
                )
            );
        }
    }, {
        key: 'getFormFloatingLabel',
        value: function getFormFloatingLabel() {
            var _this8 = this;

            return _react2.default.createElement(
                _react.Fragment,
                null,
                _react2.default.createElement(
                    'div',
                    { className: 'new-form new-form-floating-inputs' },
                    _react2.default.createElement(
                        'p',
                        { className: 'new-form-title' },
                        'Solicite uma demonstra\xE7\xE3o'
                    ),
                    _react2.default.createElement(
                        'p',
                        { className: 'new-form-subtitle' },
                        'Um de nossos consultores entrar\xE1 em contato.'
                    ),
                    _react2.default.createElement(
                        'form',
                        { action: '.', method: 'POST', className: 'new-form', onSubmit: function onSubmit(e) {
                                return _this8.submitForm(e);
                            } },
                        _react2.default.createElement(_Input2.default, { type: 'hidden', name: 'company', value: this.state.company }),
                        _react2.default.createElement(_InputFloatingLabel2.default, { id: 'name', value: this.state.name, onChange: function onChange(e) {
                                return _this8.handleChange(e);
                            }, error: this.state.nameError, placeholder: 'Nome' }),
                        _react2.default.createElement(_InputFloatingLabel2.default, { id: 'email', value: this.state.email, onChange: function onChange(e) {
                                return _this8.handleChange(e);
                            }, error: this.state.emailError, placeholder: 'E-mail profissional' }),
                        _react2.default.createElement(_InputFloatingLabel2.default, { id: 'telephone', value: this.state.telephone, onChange: function onChange(e) {
                                return _this8.handleChange(e);
                            }, error: this.state.telephoneError, maxLength: '15', placeholder: 'Telefone' }),
                        _react2.default.createElement(
                            'div',
                            { className: 'activity-wrapper' },
                            _react2.default.createElement(
                                'div',
                                { className: 'activity-dropdown-button', onClick: this.handleActivityDropdownClick },
                                'Selecione uma op\xE7\xE3o'
                            ),
                            _react2.default.createElement(
                                'div',
                                { className: 'activity-dropdown' },
                                _react2.default.createElement(
                                    _Button2.default,
                                    { className: this.getSelectedActivity(ACTIVITY.industria), onClick: function onClick() {
                                            return _this8.handleActivityOptionClick(ACTIVITY.industria);
                                        } },
                                    _react2.default.createElement(_Picture2.default, { src: '/images/icon-industrias.svg' }),
                                    'Ind\xFAstrias'
                                ),
                                _react2.default.createElement(
                                    _Button2.default,
                                    { className: this.getSelectedActivity(ACTIVITY.distribuicao), onClick: function onClick() {
                                            return _this8.handleActivityOptionClick(ACTIVITY.distribuicao);
                                        } },
                                    _react2.default.createElement(_Picture2.default, { src: '/images/icon-distribuidoras.svg' }),
                                    'Distribuidoras'
                                ),
                                _react2.default.createElement(
                                    _Button2.default,
                                    { className: this.getSelectedActivity(ACTIVITY.rep), onClick: function onClick() {
                                            return _this8.handleActivityOptionClick(ACTIVITY.rep);
                                        } },
                                    _react2.default.createElement(_Picture2.default, { src: '/images/icon-representates.svg' }),
                                    'Representantes'
                                ),
                                _react2.default.createElement(
                                    _Button2.default,
                                    { className: this.getSelectedActivity(ACTIVITY.outra), onClick: function onClick() {
                                            return _this8.handleActivityOptionClick(ACTIVITY.outra);
                                        } },
                                    _react2.default.createElement(_Picture2.default, { src: '/images/icon-outros.svg' }),
                                    'Outra'
                                )
                            ),
                            _react2.default.createElement(
                                'span',
                                { className: 'floating-label' },
                                'Qual \xE9 a atividade da sua empresa?'
                            ),
                            _react2.default.createElement(
                                'div',
                                { className: 'wrapper-input-vendedores' },
                                _react2.default.createElement(
                                    'p',
                                    { className: 'label' },
                                    'Qual \xE9 o n\xFAmero de vendedores da sua empresa?'
                                ),
                                _react2.default.createElement(
                                    'div',
                                    { className: 'group-buttons' },
                                    _react2.default.createElement(
                                        _Button2.default,
                                        { model: 'outline', className: this.getSelectedUsers(USERS.um), onClick: function onClick() {
                                                return _this8.handlerUsers(USERS.um);
                                            } },
                                        '1'
                                    ),
                                    _react2.default.createElement(
                                        _Button2.default,
                                        { model: 'outline', className: this.getSelectedUsers(USERS.cinco), onClick: function onClick() {
                                                return _this8.handlerUsers(USERS.cinco);
                                            } },
                                        '2-5'
                                    ),
                                    _react2.default.createElement(
                                        _Button2.default,
                                        { model: 'outline', className: this.getSelectedUsers(USERS.vinte), onClick: function onClick() {
                                                return _this8.handlerUsers(USERS.vinte);
                                            } },
                                        '6-20'
                                    ),
                                    _react2.default.createElement(
                                        _Button2.default,
                                        { model: 'outline', className: this.getSelectedUsers(USERS.cinquenta), onClick: function onClick() {
                                                return _this8.handlerUsers(USERS.cinquenta);
                                            } },
                                        '21-50'
                                    ),
                                    _react2.default.createElement(
                                        _Button2.default,
                                        { model: 'outline', className: this.getSelectedUsers(USERS.cinquentaum), onClick: function onClick() {
                                                return _this8.handlerUsers(USERS.cinquentaum);
                                            } },
                                        '51 ou mais'
                                    ),
                                    this.state.usersError ? _react2.default.createElement(
                                        'div',
                                        { style: { color: 'red' } },
                                        'Oops! Voc\xEA esqueceu de escolher uma op\xE7\xE3o.'
                                    ) : null
                                )
                            ),
                            this.state.activityError ? _react2.default.createElement(
                                'div',
                                { style: { color: 'red' } },
                                'Oops! Voc\xEA esqueceu de escolher uma op\xE7\xE3o.'
                            ) : null
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: 'submit-demo-modal' },
                            _react2.default.createElement(
                                _Button2.default,
                                { type: 'submit', className: 'new-submit new-button' },
                                'solicitar demonstra\xE7\xE3o'
                            )
                        )
                    )
                )
            );
        }
    }, {
        key: 'getNewForm',
        value: function getNewForm() {
            var _this9 = this;

            return _react2.default.createElement(
                _react.Fragment,
                null,
                _react2.default.createElement(
                    'div',
                    { className: 'form-container' },
                    this.props.title === false ? null : _react2.default.createElement(
                        'div',
                        { className: 'form-title' },
                        this.props.title ? this.props.title : 'Preencha o formulário abaixo e solicite uma demonstração'
                    ),
                    _react2.default.createElement(
                        'form',
                        { action: '.', method: 'POST', className: 'new-form', onSubmit: function onSubmit(e) {
                                return _this9.submitForm(e);
                            } },
                        _react2.default.createElement(_Input2.default, { type: 'hidden', name: 'company', value: this.state.company }),
                        _react2.default.createElement(_Input2.default, { id: 'name', value: this.state.name, onChange: function onChange(e) {
                                return _this9.handleChange(e);
                            }, error: this.state.nameError, placeholder: 'Nome' }),
                        _react2.default.createElement(_Input2.default, { id: 'email', value: this.state.email, onChange: function onChange(e) {
                                return _this9.handleChange(e);
                            }, error: this.state.emailError, placeholder: 'E-mail profissional' }),
                        _react2.default.createElement(_Input2.default, { id: 'telephone', value: this.state.telephone, onChange: function onChange(e) {
                                return _this9.handleChange(e);
                            }, error: this.state.telephoneError, maxLength: '15', placeholder: 'Telefone' }),
                        _react2.default.createElement(
                            'div',
                            { className: 'activity-wrapper' },
                            _react2.default.createElement(
                                'div',
                                { className: 'activity-dropdown-button', onClick: this.handleActivityDropdownClick },
                                'Selecione uma op\xE7\xE3o'
                            ),
                            _react2.default.createElement(
                                'div',
                                { className: 'activity-dropdown' },
                                _react2.default.createElement(
                                    _Button2.default,
                                    { className: this.getSelectedActivity(ACTIVITY.industria), onClick: function onClick() {
                                            return _this9.handleActivityOptionClick(ACTIVITY.industria);
                                        } },
                                    _react2.default.createElement(_Picture2.default, { src: '/images/icon-industrias.svg' }),
                                    'Ind\xFAstrias'
                                ),
                                _react2.default.createElement(
                                    _Button2.default,
                                    { className: this.getSelectedActivity(ACTIVITY.distribuicao), onClick: function onClick() {
                                            return _this9.handleActivityOptionClick(ACTIVITY.distribuicao);
                                        } },
                                    _react2.default.createElement(_Picture2.default, { src: '/images/icon-distribuidoras.svg' }),
                                    'Distribuidoras'
                                ),
                                _react2.default.createElement(
                                    _Button2.default,
                                    { className: this.getSelectedActivity(ACTIVITY.rep), onClick: function onClick() {
                                            return _this9.handleActivityOptionClick(ACTIVITY.rep);
                                        } },
                                    _react2.default.createElement(_Picture2.default, { src: '/images/icon-representates.svg' }),
                                    'Representantes'
                                ),
                                _react2.default.createElement(
                                    _Button2.default,
                                    { className: this.getSelectedActivity(ACTIVITY.outra), onClick: function onClick() {
                                            return _this9.handleActivityOptionClick(ACTIVITY.outra);
                                        } },
                                    _react2.default.createElement(_Picture2.default, { src: '/images/icon-outros.svg' }),
                                    'Outra'
                                )
                            ),
                            _react2.default.createElement(
                                'span',
                                { className: 'floating-label' },
                                'Qual \xE9 a atividade da sua empresa?'
                            ),
                            this.state.activityError ? _react2.default.createElement(
                                'div',
                                { style: { color: 'red' } },
                                'Oops! Voc\xEA esqueceu de escolher uma op\xE7\xE3o.'
                            ) : null
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: 'submit-demo-modal' },
                            _react2.default.createElement(
                                _Button2.default,
                                { type: 'submit', className: 'new-submit new-button' },
                                'solicitar demonstra\xE7\xE3o'
                            )
                        )
                    )
                )
            );
        }
    }, {
        key: 'getInlineForm',
        value: function getInlineForm() {
            var _this10 = this;

            return _react2.default.createElement(
                _react.Fragment,
                null,
                _react2.default.createElement(
                    'div',
                    { className: 'form-container' },
                    !this.props.hideTitle && this.props.title === false ? null : !this.props.hideTitle ? _react2.default.createElement(
                        'div',
                        { className: 'form-title' },
                        this.props.title ? this.props.title : 'Preencha o formulário abaixo e solicite uma demonstração'
                    ) : null,
                    _react2.default.createElement(
                        'form',
                        { action: '.', method: 'POST', className: 'new-form', onSubmit: function onSubmit(e) {
                                return _this10.submitForm(e);
                            } },
                        _react2.default.createElement(_Input2.default, { type: 'hidden', name: 'company', value: this.state.company }),
                        _react2.default.createElement(_InputFloatingLabel2.default, { id: 'name', value: this.state.name, onChange: function onChange(e) {
                                return _this10.handleChange(e);
                            }, error: this.state.nameError, placeholder: this.props.formHeroStyle ? 'Nome completo' : 'Nome', inputPlaceholder: this.props.formHeroStyle ? 'Seu nome completo' : undefined }),
                        _react2.default.createElement(_InputFloatingLabel2.default, { id: 'email', value: this.state.email, onChange: function onChange(e) {
                                return _this10.handleChange(e);
                            }, error: this.state.emailError, placeholder: this.props.formHeroStyle ? 'E-mail profissional' : 'Seu e-mail', inputPlaceholder: this.props.formHeroStyle ? 'seu@empresa.com.br' : undefined }),
                        _react2.default.createElement(_InputFloatingLabel2.default, { id: 'telephone', value: this.state.telephone, onChange: function onChange(e) {
                                return _this10.handleChange(e);
                            }, error: this.state.telephoneError, maxLength: '15', placeholder: this.props.formHeroStyle ? 'Telefone / WhatsApp' : 'Telefone', inputPlaceholder: this.props.formHeroStyle ? '(00) 00000-0000' : undefined }),
                        _react2.default.createElement(
                            'div',
                            { className: 'activity-wrapper' },
                            _react2.default.createElement(
                                'div',
                                { className: 'activity-dropdown-button', onClick: this.handleActivityDropdownClick },
                                'Selecione uma op\xE7\xE3o'
                            ),
                            _react2.default.createElement(
                                'div',
                                { className: 'activity-dropdown' },
                                _react2.default.createElement(
                                    _Button2.default,
                                    { className: this.getSelectedActivity(ACTIVITY.industria), onClick: function onClick() {
                                            return _this10.handleActivityOptionClick(ACTIVITY.industria);
                                        } },
                                    _react2.default.createElement(_Picture2.default, { src: '/images/icon-industrias.svg' }),
                                    'Ind\xFAstrias'
                                ),
                                _react2.default.createElement(
                                    _Button2.default,
                                    { className: this.getSelectedActivity(ACTIVITY.distribuicao), onClick: function onClick() {
                                            return _this10.handleActivityOptionClick(ACTIVITY.distribuicao);
                                        } },
                                    _react2.default.createElement(_Picture2.default, { src: '/images/icon-distribuidoras.svg' }),
                                    'Distribuidoras'
                                ),
                                _react2.default.createElement(
                                    _Button2.default,
                                    { className: this.getSelectedActivity(ACTIVITY.rep), onClick: function onClick() {
                                            return _this10.handleActivityOptionClick(ACTIVITY.rep);
                                        } },
                                    _react2.default.createElement(_Picture2.default, { src: '/images/icon-representates.svg' }),
                                    'Representantes'
                                ),
                                _react2.default.createElement(
                                    _Button2.default,
                                    { className: this.getSelectedActivity(ACTIVITY.outra), onClick: function onClick() {
                                            return _this10.handleActivityOptionClick(ACTIVITY.outra);
                                        } },
                                    _react2.default.createElement(_Picture2.default, { src: '/images/icon-outros.svg' }),
                                    'Outra'
                                )
                            ),
                            _react2.default.createElement(
                                'span',
                                { className: 'floating-label' },
                                this.props.formHeroStyle ? 'Atividade da sua empresa' : 'Qual é a atividade da sua empresa?'
                            ),
                            this.state.activityError ? _react2.default.createElement(
                                'div',
                                { style: { color: 'red' } },
                                'Oops! Voc\xEA esqueceu de escolher uma op\xE7\xE3o.'
                            ) : null
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: 'activity-wrapper' },
                            _react2.default.createElement(
                                'div',
                                { className: 'activity-dropdown-button', onClick: this.handleUsersDropdownClick },
                                'Selecione uma op\xE7\xE3o'
                            ),
                            _react2.default.createElement(
                                'div',
                                { className: 'activity-dropdown' },
                                _react2.default.createElement(
                                    _Button2.default,
                                    { className: this.getSelectedUsers(USERS.um), onClick: function onClick() {
                                            return _this10.handleUsersOptionClick(USERS.um);
                                        } },
                                    '1'
                                ),
                                _react2.default.createElement(
                                    _Button2.default,
                                    { className: this.getSelectedUsers(USERS.cinco), onClick: function onClick() {
                                            return _this10.handleUsersOptionClick(USERS.cinco);
                                        } },
                                    '2-5'
                                ),
                                _react2.default.createElement(
                                    _Button2.default,
                                    { className: this.getSelectedUsers(USERS.vinte), onClick: function onClick() {
                                            return _this10.handleUsersOptionClick(USERS.vinte);
                                        } },
                                    '6-20'
                                ),
                                _react2.default.createElement(
                                    _Button2.default,
                                    { className: this.getSelectedUsers(USERS.cinquenta), onClick: function onClick() {
                                            return _this10.handleUsersOptionClick(USERS.cinquenta);
                                        } },
                                    '21-50'
                                ),
                                _react2.default.createElement(
                                    _Button2.default,
                                    { className: this.getSelectedUsers(USERS.cinquentaum), onClick: function onClick() {
                                            return _this10.handleUsersOptionClick(USERS.cinquentaum);
                                        } },
                                    '51 ou mais'
                                )
                            ),
                            _react2.default.createElement(
                                'span',
                                { className: 'floating-label' },
                                'Quantidade de vendedores da sua empresa'
                            ),
                            this.state.usersError ? _react2.default.createElement(
                                'div',
                                { style: { color: 'red' } },
                                'Oops! Voc\xEA esqueceu de escolher uma op\xE7\xE3o.'
                            ) : null
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: 'submit-demo-modal' },
                            _react2.default.createElement(
                                _Button2.default,
                                { type: 'submit', className: 'new-submit new-button' },
                                this.props.submitButtonText || 'solicitar demonstração'
                            )
                        ),
                        this.props.formHeroStyle && _react2.default.createElement(
                            'div',
                            { className: 'form-hero-footer' },
                            _react2.default.createElement(
                                'span',
                                null,
                                'Especialista dedicado'
                            ),
                            _react2.default.createElement('span', { className: 'form-hero-footer__dot', 'aria-hidden': 'true' }),
                            _react2.default.createElement(
                                'span',
                                null,
                                'Demonstra\xE7\xE3o personalizada'
                            )
                        ),
                        this.props.showTrialLink && _react2.default.createElement(
                            'div',
                            { className: 'trial-link-wrapper' },
                            _react2.default.createElement(
                                'span',
                                { className: 'trial-link-text' },
                                'ou '
                            ),
                            _react2.default.createElement(
                                'a',
                                {
                                    href: 'https://app.mercos.com/cadastro/',
                                    className: 'trial-link',
                                    onClick: function onClick(e) {
                                        e.preventDefault();
                                        (0, _Utm.redirectWithCookies)('https://app.mercos.com/cadastro/');
                                    }
                                },
                                'Fa\xE7a um teste gr\xE1tis \u203A'
                            )
                        ),
                        !this.props.showTrialLink && _react2.default.createElement(
                            'div',
                            { className: 'inline-trial-link modal-hide' },
                            _react2.default.createElement(
                                'a',
                                {
                                    href: '#',
                                    onClick: function onClick() {
                                        return (0, _Utm.redirectWithCookies)('https://app.mercos.com/cadastro/');
                                    },
                                    title: 'Fa\xE7a um teste gr\xE1tis'
                                },
                                _react2.default.createElement(
                                    'span',
                                    { className: 'ou-text' },
                                    'ou'
                                ),
                                ' fa\xE7a um teste gr\xE1tis \u203A'
                            ),
                            _react2.default.createElement(
                                'p',
                                { className: 'inline-trial-info' },
                                'Teste gr\xE1tis por 7 dias | Sem cobran\xE7a ao terminar o per\xEDodo gr\xE1tis'
                            )
                        ),
                        this.props.showTrialLink && _react2.default.createElement(
                            'p',
                            { className: 'inline-form-trial-info' },
                            'Teste gr\xE1tis por 7 dias | Sem cobran\xE7a autom\xE1tica'
                        )
                    )
                )
            );
        }
    }, {
        key: 'getCTA',
        value: function getCTA() {
            return _react2.default.createElement(
                _react.Fragment,
                null,
                _react2.default.createElement(
                    'div',
                    { className: 'cta-text' },
                    _react2.default.createElement(
                        'p',
                        { className: 'font-light font-12' },
                        'explore todos os recursos ',
                        _react2.default.createElement(
                            'span',
                            { className: 'cta-text-separator' },
                            '| '
                        ),
                        'n\xE3o precisa de cart\xE3o de cr\xE9dito ',
                        _react2.default.createElement(
                            'span',
                            { className: 'cta-text-separator' },
                            '| '
                        ),
                        'simples de usar'
                    )
                )
            );
        }
    }, {
        key: 'getModalButton',
        value: function getModalButton() {
            var _this11 = this;

            return _react2.default.createElement(
                'button',
                {
                    href: '.',
                    className: this.props.buttonShadow ? 'btn-white-shadow btn-modal ' : 'new-button button-secondary btn-modal ' + (this.props.darkBg ? 'button-secondary' : 'button-secondary-black') + ' button-cta',
                    onClick: function onClick(e) {
                        return _this11.openDemoModal(e);
                    },
                    title: 'Pe\xE7a uma demonstra\xE7\xE3o aos nossos especialistas.'
                },
                this.props.fixedBottomBar ? 'pedir demonstração' : this.props.modalButtonText || 'peça uma demonstração'
            );
        }
    }, {
        key: 'getModalLink',
        value: function getModalLink() {
            var _this12 = this;

            return _react2.default.createElement(
                'div',
                { className: 'or-demo-wrapper' },
                this.props.showOr && _react2.default.createElement(
                    'span',
                    { style: { textDecoration: 'none' } },
                    ' ou '
                ),
                _react2.default.createElement(
                    'a',
                    {
                        href: '.',
                        className: 'button-txt btn-modal ' + (this.props.darkBg ? 'button-txt-white' : ''),
                        onClick: function onClick(e) {
                            return _this12.openDemoModal(e);
                        },
                        title: 'Pe\xE7a uma demonstra\xE7\xE3o aos nossos especialistas.'
                    },
                    this.props.modalButtonText || 'peça uma demonstração ›'
                )
            );
        }
    }, {
        key: 'getTrialButton',
        value: function getTrialButton() {
            return _react2.default.createElement(
                'button',
                {
                    className: this.props.buttonShadow ? 'btn-green-shadow btn-trial' : 'new-button button-primary btn-trial button-cta button-trial ' + (this.props.darkBg ? 'dark-bg' : ''),
                    onClick: function onClick() {
                        return (0, _Utm.redirectWithCookies)('https://app.mercos.com/cadastro/');
                    },
                    href: '#',
                    title: 'Cadastre-se no Mercos!'
                },
                this.props.trialAndDemo ? this.props.trialAndDemo : 'teste grátis'
            );
        }
    }, {
        key: 'getTrialAndDemo',
        value: function getTrialAndDemo() {
            var _this13 = this;

            if (this.props.minimalStyle) {
                var demoButtonClass = this.props.invertButtons ? 'button-primary' : 'button-secondary';
                var trialButtonClass = this.props.invertButtons ? 'button-secondary' : 'button-primary';

                return _react2.default.createElement(
                    'div',
                    { className: 'wrapper-trial-and-demo mobile-only' },
                    _react2.default.createElement(
                        'button',
                        {
                            className: 'new-button ' + demoButtonClass + ' ' + (this.props.darkBg ? 'dark-bg' : ''),
                            onClick: function onClick(e) {
                                return _this13.openDemoModal(e);
                            },
                            title: 'Pe\xE7a uma demonstra\xE7\xE3o aos nossos especialistas.'
                        },
                        this.props.modalButtonText || 'peça uma demonstração'
                    ),
                    !this.props.hideTrialButton && _react2.default.createElement(
                        'button',
                        {
                            className: 'new-button ' + trialButtonClass + ' ' + (this.props.darkBg ? 'dark-bg' : ''),
                            onClick: function onClick() {
                                return (0, _Utm.redirectWithCookies)('https://app.mercos.com/cadastro/');
                            },
                            href: '#',
                            title: 'Cadastre-se no Mercos!'
                        },
                        this.props.trialAndDemo || 'Faça um teste grátis'
                    ),
                    this.props.invertButtons && _react2.default.createElement(
                        'p',
                        { className: 'trial-info-text' },
                        'Teste gr\xE1tis por 7 dias | Sem cobran\xE7a autom\xE1tica'
                    )
                );
            }

            return _react2.default.createElement(
                _react.Fragment,
                null,
                _react2.default.createElement(
                    'div',
                    { className: 'wrapper-trial-and-demo ' + (this.props.reverseButtons ? 'reverse-buttons' : '') },
                    !this.props.hideTrialButton && this.getTrialButton(),
                    this.props.modalLink ? this.getModalLink() : this.getModalButton()
                ),
                this.props.ctaText ? this.getCTA() : ''
            );
        }
    }, {
        key: 'getNewFormButtons',
        value: function getNewFormButtons() {
            var _this14 = this;

            var _props = this.props,
                buttonVariant = _props.buttonVariant,
                textAlign = _props.textAlign,
                ctaButtonText = _props.ctaButtonText,
                demoButtonText = _props.demoButtonText,
                bottomText = _props.bottomText;


            var isWhiteVariant = buttonVariant === 'white' || buttonVariant === 'inverted-white';
            var isInverted = buttonVariant === 'inverted' || buttonVariant === 'inverted-white';

            // Determine outline color (white or green)
            var outlineClass = isWhiteVariant ? 'new-form-btn-bordered-white' : 'new-form-btn-bordered-green';

            // Default: Faça=solid, Peça=outline
            // Inverted: Peça=solid, Faça=outline
            var trialButtonClass = isInverted ? 'new-form-btn ' + outlineClass : 'new-form-btn new-form-btn-solid-green';
            var demoButtonClass = isInverted ? 'new-form-btn new-form-btn-solid-green' : 'new-form-btn ' + outlineClass;

            var trialButton = _react2.default.createElement(
                'button',
                {
                    className: trialButtonClass,
                    onClick: function onClick() {
                        return (0, _Utm.redirectWithCookies)('https://app.mercos.com/cadastro/');
                    },
                    title: 'Cadastre-se no Mercos!'
                },
                ctaButtonText || 'Faça um teste grátis'
            );

            var whatsappButton = _react2.default.createElement(
                'button',
                {
                    className: trialButtonClass + ' new-form-whatsapp-btn',
                    onClick: function onClick(e) {
                        return _this14.openRDWhatsappLauncher(e);
                    },
                    title: 'Fale conosco no WhatsApp'
                },
                _react2.default.createElement(
                    'span',
                    { className: 'new-form-whatsapp-icon', 'aria-hidden': 'true' },
                    _react2.default.createElement(_Picture2.default, { src: '/images/site/whatsapp.png', alt: '' })
                ),
                this.props.whatsappButtonText || 'Fale conosco no WhatsApp'
            );

            var demoButton = _react2.default.createElement(
                'button',
                {
                    className: demoButtonClass,
                    onClick: function onClick(e) {
                        return _this14.openDemoModal(e);
                    },
                    title: 'Pe\xE7a uma demonstra\xE7\xE3o aos nossos especialistas.'
                },
                demoButtonText || 'Peça uma demonstração'
            );

            var primaryButton = this.props.replaceTrialWithWhatsapp && this.state.rdWhatsappLauncherReady ? whatsappButton : trialButton;
            var currentBottomText = this.props.replaceTrialWithWhatsapp && this.state.rdWhatsappLauncherReady ? this.props.whatsappBottomText : bottomText;

            return _react2.default.createElement(
                _react.Fragment,
                null,
                _react2.default.createElement(
                    'div',
                    { className: 'new-form-buttons-wrapper text-align-' + textAlign },
                    _react2.default.createElement(
                        'div',
                        { className: 'new-form-buttons-container' },
                        isInverted ? _react2.default.createElement(
                            _react.Fragment,
                            null,
                            demoButton,
                            primaryButton
                        ) : _react2.default.createElement(
                            _react.Fragment,
                            null,
                            primaryButton,
                            demoButton
                        )
                    ),
                    currentBottomText && _react2.default.createElement(
                        'p',
                        { className: 'new-form-bottom-text' },
                        currentBottomText.includes('|') ? _react2.default.createElement(
                            _react.Fragment,
                            null,
                            _react2.default.createElement(
                                'span',
                                { className: 'desktop-text' },
                                currentBottomText
                            ),
                            _react2.default.createElement(
                                'span',
                                { className: 'mobile-text' },
                                currentBottomText.split('|').map(function (part, index) {
                                    return _react2.default.createElement(
                                        _react.Fragment,
                                        { key: index },
                                        part.trim(),
                                        index < currentBottomText.split('|').length - 1 && _react2.default.createElement('br', null)
                                    );
                                })
                            )
                        ) : currentBottomText
                    )
                )
            );
        }
    }, {
        key: 'render',
        value: function render() {
            var _this15 = this;

            // Only show buttons WITH form when minimalStyle + showForm + modalButtonText (final CTA case)
            // Otherwise follow normal logic (buttons only when !showForm)
            var shouldShowButtons = this.props.minimalStyle && this.props.showForm && this.props.modalButtonText ? true : !this.props.showForm;

            return _react2.default.createElement(
                _react.Fragment,
                null,
                _react2.default.createElement(
                    'div',
                    { className: 'new-form-wrapper ' + (this.props.inline || this.props.minimalStyle ? 'new-form-wrapper-b2b' : '') + ' ' + (this.props.ctaText ? 'same-width-buttons' : '') + ' ' + (this.props.darkBg ? 'dark-bg' : '') + ' ' + (this.props.fixedBottomBar ? 'demo-fixed-bottom' : '') + ' ' + (this.props.inlineBtns ? 'inline' : '') + ' ' + (this.props.newForm ? 'new-form-variant' : '') + ' ' + (this.props.buttonVariant === 'white' || this.props.buttonVariant === 'inverted-white' ? 'variant-white' : '') + ' ' + (this.props.className ? this.props.className : '') },
                    shouldShowButtons && this.props.newForm ? this.getNewFormButtons() : shouldShowButtons && this.props.trialButtonOnly ? _react2.default.createElement(
                        'button',
                        {
                            className: 'btn-green-shadow btn-modal',
                            onClick: function onClick(e) {
                                return _this15.openDemoModal(e);
                            },
                            title: 'Pe\xE7a uma demonstra\xE7\xE3o aos nossos especialistas.'
                        },
                        this.props.modalButtonText || 'quero contratar'
                    ) : shouldShowButtons ? this.getTrialAndDemo() : null,
                    this.props.showForm ? _react2.default.createElement(
                        'div',
                        { className: 'show-full-form' },
                        this.props.inline || this.props.minimalStyle ? this.getInlineForm() : this.getForm()
                    ) : '',
                    this.state.showDemoModal && this.getDemoModal()
                )
            );
        }
    }]);

    return DemoForm;
}(_react.Component);

DemoForm.propTypes = {
    b2b: _propTypes2.default.bool,
    className: _propTypes2.default.string,
    color: _propTypes2.default.string,
    contaAzul: _propTypes2.default.bool,
    partnerId: _propTypes2.default.string,
    modalSmall: _propTypes2.default.bool,
    trialButtonOnly: _propTypes2.default.bool,
    inline: _propTypes2.default.bool,
    newForm: _propTypes2.default.bool,
    buttonVariant: _propTypes2.default.oneOf(['default', 'inverted', 'white', 'inverted-white']),
    textAlign: _propTypes2.default.oneOf(['left', 'center', 'right']),
    ctaButtonText: _propTypes2.default.string,
    demoButtonText: _propTypes2.default.string,
    bottomText: _propTypes2.default.string,
    minimalStyle: _propTypes2.default.bool,
    showTrialLink: _propTypes2.default.bool,
    invertButtons: _propTypes2.default.bool,
    hideTitle: _propTypes2.default.bool,
    formHeroStyle: _propTypes2.default.bool,
    replaceTrialWithWhatsapp: _propTypes2.default.bool,
    whatsappButtonText: _propTypes2.default.string,
    whatsappBottomText: _propTypes2.default.string
};
DemoForm.defaultProps = {
    b2b: false,
    contaAzul: false,
    trialButtonOnly: false,
    inline: false,
    newForm: true,
    buttonVariant: 'default',
    textAlign: 'center',
    ctaButtonText: 'Faça um teste grátis',
    demoButtonText: 'Peça uma demonstração',
    bottomText: 'Teste grátis por 7 dias | Sem cobrança automática',
    minimalStyle: false,
    showTrialLink: false,
    invertButtons: false,
    hideTitle: false,
    formHeroStyle: false,
    replaceTrialWithWhatsapp: false,
    whatsappButtonText: 'Fale conosco no WhatsApp',
    whatsappBottomText: ''
};
exports.default = DemoForm;

/***/ }),

/***/ 543:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(530);

var _classnames2 = _interopRequireDefault(_classnames);

__webpack_require__(534);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Paragraph = function Paragraph(_ref) {
    var center = _ref.center,
        children = _ref.children,
        className = _ref.className,
        gray = _ref.gray,
        italic = _ref.italic,
        left = _ref.left,
        _onClick = _ref.onClick,
        small = _ref.small,
        white = _ref.white;
    return _react2.default.createElement(
        'p',
        { className: (0, _classnames2.default)('paragraph', className, center && 'text-center', gray && 'heading-gray', italic && 'italic', left && 'text-left', small && 'small', white && 'heading-white'),
            onClick: function onClick(e) {
                return _onClick ? _onClick(e) : null;
            } },
        children
    );
};

exports.default = Paragraph;

/***/ }),

/***/ 544:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = NewFooter;

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

__webpack_require__(545);

var _Utm = __webpack_require__(532);

var _Picture = __webpack_require__(531);

var _Picture2 = _interopRequireDefault(_Picture);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function NewFooter() {
    var accessLinks = [{ name: 'Entrar', url: 'https://app.mercos.com/login/', redirect: true }, { name: 'Cadastre-se', url: 'https://app.mercos.com/cadastro/', redirect: true }];

    var footerRows = [[{
        title: 'Soluções',
        links: [{ name: 'Força de vendas', url: '/forca-vendas/' }, { name: 'E-commerce B2B', url: '/e-commerce-b2b/' }, { name: 'CRM', url: '/crm-de-vendas' }, { name: 'Mercos Pay', url: '/mercos-pay' }, { name: 'Videochamada', url: '/videochamada/' }]
    }, {
        title: 'Recursos',
        links: [{ name: 'Aplicativo de vendas', url: '/aplicativo-vendas/' }, { name: 'Indicadores de vendas', url: '/recursos/indicadores-performance/' }, { name: 'Políticas comerciais', url: '/recursos/politica-comercial-vendas/' }, { name: 'Mercos IA', url: '/recursos/mercos-ia/' }]
    }, {
        title: 'Conteúdo',
        links: [{ name: 'Blog', url: 'https://blog.mercos.com/', external: true }, { name: 'Mercoscast', url: 'https://www.youtube.com/playlist?list=PLjAquKgGC5hWUNcPIdp4bntu9zcQLwTYI', external: true }, { name: _react2.default.createElement(
                _react2.default.Fragment,
                null,
                'E-commerce B2B: O',
                _react2.default.createElement('br', null),
                'que \xE9?'
            ), url: 'https://blog.mercos.com/e-commerce-b2b-o-que-e', target: '_blank', external: true }]
    }, {
        title: 'Transparência',
        links: [{ name: 'Termos e Condições', url: '/termos-e-condicoes/', target: '_blank' }, { name: 'Aviso de privacidade', url: '/aviso-de-privacidade/', target: '_blank' }, { name: 'Portal da Privacidade', url: 'https://www.privacidade.com.br/portal-de-privacidade/?token=511f11a2aed639b807ca96fea6935b2a&site_url=https://mercos.com/', target: '_blank', external: true }, { name: 'Relatório da igualdade salarial', url: '/relatorio-igualdade-salarial/' }]
    }, {
        title: 'Suporte',
        links: [{ name: 'Central de ajuda', url: 'https://ajuda.mercos.com/portal/pt-br/kb', external: true }, {
            custom: true,
            content: _react2.default.createElement(
                'div',
                { className: 'support-info' },
                _react2.default.createElement(
                    'div',
                    { className: 'support-phone' },
                    '(47) 3481.8050'
                ),
                _react2.default.createElement(
                    'div',
                    { className: 'support-hours' },
                    'Atendimento de Segunda',
                    _react2.default.createElement('br', null),
                    'a Quinta das 9h \xE0s 17h.',
                    _react2.default.createElement('br', null),
                    'Sexta das 9h30 \xE0s 17h.'
                )
            )
        }]
    }], [{
        title: 'Segmentos',
        links: [{ name: 'Indústrias', url: '/industrias/' }, { name: 'Distribuidoras', url: '/distribuidoras/' }, { name: 'Representantes', url: '/representantes-comerciais/' }]
    }, {
        title: 'Planos e preços',
        links: [{ name: 'Indústrias e distribuidoras', url: '/planos-e-precos/industrias-e-distribuidoras/' }, { name: 'Representantes', url: '/planos-e-precos/representantes/' }]
    }, {
        title: 'Institucional',
        links: [{ name: 'Carreira', url: 'https://mercos.gupy.io/' }, { name: 'Sobre Nós', url: '/sobre/' }]
    }, {
        title: 'Integrações',
        links: [{ name: 'ERPs integrados', url: '/integracao-erp/' }, { name: 'Seja Parceiro', url: '/parceiros' }, { name: 'Documentação da API', url: 'https://docs.mercos.com/', external: true }]
    }, {
        title: 'Baixe o aplicativo',
        content: _react2.default.createElement(
            _react2.default.Fragment,
            null,
            _react2.default.createElement(
                'div',
                { className: 'app-buttons' },
                _react2.default.createElement(
                    'a',
                    { href: 'https://apps.apple.com/br/app/mercos-app-de-vendas/id485511628', target: '_blank', rel: 'noopener noreferrer', className: 'app-button' },
                    _react2.default.createElement(_Picture2.default, { loading: 'lazy', src: '/images/site/social/app-store.png', alt: 'Baixar na App Store' })
                ),
                _react2.default.createElement(
                    'a',
                    { href: 'https://play.google.com/store/apps/details?id=br.com.meuspedidos&hl=pt_BR', target: '_blank', rel: 'noopener noreferrer', className: 'app-button' },
                    _react2.default.createElement(_Picture2.default, { loading: 'lazy', src: '/images/site/social/google-play.png', alt: 'Dispon\xEDvel no Google Play' })
                )
            ),
            _react2.default.createElement(
                'p',
                { className: 'app-downloads' },
                _react2.default.createElement(
                    'strong',
                    null,
                    '+100 mil'
                ),
                ' downloads'
            )
        )
    }]];

    var renderLink = function renderLink(link) {
        var className = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'footer-link';

        if (link.custom) return link.content;
        var target = link.target || (link.external ? '_blank' : null);

        return _react2.default.createElement(
            'a',
            {
                className: className,
                href: link.redirect ? null : link.url,
                onClick: link.redirect ? function () {
                    return (0, _Utm.redirectWithCookies)(link.url);
                } : null,
                target: target,
                rel: target === '_blank' ? 'noopener noreferrer' : null
            },
            link.name,
            link.external && _react2.default.createElement(
                'span',
                { className: 'material-icons site-footer__external-icon', 'aria-hidden': 'true' },
                'north_east'
            )
        );
    };

    var socialLinks = [{ name: 'LinkedIn', url: 'https://www.linkedin.com/company/mercos/mycompany/', icon: '/images/site/social/linkedin.svg' }, { name: 'Instagram', url: 'https://www.instagram.com/mercosoficial/', icon: '/images/site/social/instagram.svg' }, { name: 'Facebook', url: 'https://www.facebook.com/mercosoficial', icon: '/images/site/social/facebook.svg' }, { name: 'YouTube', url: 'https://www.youtube.com/channel/UCBcUDhuM1--cYwhP39dbEFw', icon: '/images/site/social/youtube.svg' }, { name: 'Spotify', url: 'https://open.spotify.com/show/5HpzDJ8q32r29HoZtVzGi1', icon: '/images/site/social/spotify.svg' }];

    return _react2.default.createElement(
        'footer',
        { className: 'mercos-footer site-footer', 'aria-label': 'Rodap\xE9' },
        _react2.default.createElement(
            'div',
            { className: 'footer-content site-footer__inner' },
            _react2.default.createElement(
                'div',
                { className: 'site-footer__access' },
                _react2.default.createElement(
                    'p',
                    { className: 'site-footer__access-txt' },
                    'J\xE1 \xE9 cliente ou quer come\xE7ar?'
                ),
                _react2.default.createElement(
                    'div',
                    { className: 'site-footer__access-actions' },
                    accessLinks.map(function (link, index) {
                        return _react2.default.createElement(
                            _react2.default.Fragment,
                            { key: link.url },
                            renderLink(link, 'site-footer__access-btn site-footer__access-btn--' + (index === 0 ? 'login' : 'signup'))
                        );
                    })
                )
            ),
            _react2.default.createElement(
                'nav',
                { className: 'footer-main site-footer__nav', 'aria-label': 'Links do rodap\xE9' },
                footerRows.map(function (row, rowIndex) {
                    return _react2.default.createElement(
                        'div',
                        { className: 'site-footer__nav-row', key: rowIndex },
                        row.map(function (section) {
                            return _react2.default.createElement(
                                'section',
                                { className: 'footer-section site-footer__section', key: section.title },
                                _react2.default.createElement(
                                    'p',
                                    { className: 'section-title site-footer__col-title' },
                                    section.title
                                ),
                                section.content || _react2.default.createElement(
                                    'div',
                                    { className: 'section-links site-footer__links' },
                                    section.links.map(function (link, linkIndex) {
                                        return _react2.default.createElement(
                                            'div',
                                            { className: 'link-item', key: link.url || linkIndex },
                                            renderLink(link, 'footer-link site-footer__link')
                                        );
                                    })
                                )
                            );
                        })
                    );
                })
            )
        ),
        _react2.default.createElement(
            'div',
            { className: 'footer-bottom site-footer__bar' },
            _react2.default.createElement(
                'div',
                { className: 'footer-container site-footer__bar-inner' },
                _react2.default.createElement(
                    'div',
                    { className: 'logo-container' },
                    _react2.default.createElement(
                        'a',
                        { href: '/', className: 'mercos-logo site-footer__bar-logo-link' },
                        _react2.default.createElement(_Picture2.default, { loading: 'lazy', src: '/images/mercos-nuvini.svg', alt: 'Mercos - uma empresa nuvini' })
                    )
                ),
                _react2.default.createElement(
                    'div',
                    { className: 'company-info site-footer__legal' },
                    _react2.default.createElement(
                        'div',
                        null,
                        '\xA9 ',
                        new Date().getFullYear(),
                        ' Simplest Software Ltda. Todos os direitos reservados.'
                    ),
                    _react2.default.createElement(
                        'div',
                        null,
                        'CNPJ: 12.496.510/0001-80 \xB7 Av. Rolf Wiest, 277 (4\xBA andar) \xB7 Bom Retiro \u2014 Joinville/SC \xB7 CEP: 89223-005'
                    )
                ),
                _react2.default.createElement(
                    'div',
                    { className: 'social-links site-footer__social' },
                    socialLinks.map(function (social) {
                        return _react2.default.createElement(
                            'a',
                            {
                                key: social.name,
                                href: social.url,
                                target: '_blank',
                                rel: 'noopener noreferrer',
                                className: 'social-link site-footer__social-link',
                                'aria-label': social.name
                            },
                            _react2.default.createElement(_Picture2.default, { loading: 'lazy', src: social.icon, alt: 'Mercos no ' + social.name })
                        );
                    }),
                    _react2.default.createElement(
                        'span',
                        { className: 'feito-com-amor site-footer__made' },
                        'Feito com \uD83D\uDC9C'
                    )
                )
            )
        )
    );
}

/***/ }),

/***/ 545:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 546:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(9);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(530);

var _classnames2 = _interopRequireDefault(_classnames);

__webpack_require__(550);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Input = function Input(_ref) {
    var placeholder = _ref.placeholder,
        onChange = _ref.onChange,
        id = _ref.id,
        error = _ref.error,
        value = _ref.value,
        ariaLabel = _ref.ariaLabel,
        _ref$maxLength = _ref.maxLength,
        maxLength = _ref$maxLength === undefined ? '' : _ref$maxLength,
        model = _ref.model,
        autoFocus = _ref.autoFocus,
        size = _ref.size,
        _ref$radius = _ref.radius,
        radius = _ref$radius === undefined ? 'all-rounded' : _ref$radius,
        _ref$type = _ref.type,
        type = _ref$type === undefined ? 'text' : _ref$type,
        name = _ref.name;
    return _react2.default.createElement('input', { className: (0, _classnames2.default)('input', error && 'error', model, size, radius),
        'aria-label': ariaLabel,
        autoFocus: autoFocus,
        id: id,
        maxLength: maxLength,
        onChange: onChange,
        placeholder: placeholder,
        type: type,
        value: value,
        name: name || id
    });
};

Input.propTypes = {
    id: _propTypes2.default.string,
    placeholder: _propTypes2.default.string,
    error: _propTypes2.default.bool,
    value: _propTypes2.default.string,
    ariaLabel: _propTypes2.default.string,
    maxLength: _propTypes2.default.string,
    onChange: _propTypes2.default.func,
    autoFocus: _propTypes2.default.bool,
    model: _propTypes2.default.oneOf(['outline', 'no-borders', 'secondary', 'success', 'alert', 'warning']),
    size: _propTypes2.default.string,
    radius: _propTypes2.default.oneOf(['half-rounded', 'all-rounded', 'left-rounded', 'right-rounded', 'not-rounded'])
};

exports.default = Input;

/***/ }),

/***/ 547:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

var _reactStatic = __webpack_require__(114);

__webpack_require__(548);

var _Utm = __webpack_require__(532);

var _Picture = __webpack_require__(531);

var _Picture2 = _interopRequireDefault(_Picture);

var _siteNavData = __webpack_require__(549);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var renderItemTitle = function renderItemTitle(title) {
  if (typeof title === 'string') {
    return _react2.default.createElement(
      'h4',
      null,
      title
    );
  }
  return _react2.default.createElement(
    'h4',
    null,
    title
  );
};

var SiteNav = function SiteNav(_ref) {
  var _ref$hideOnScroll = _ref.hideOnScroll,
      hideOnScroll = _ref$hideOnScroll === undefined ? false : _ref$hideOnScroll,
      _ref$menuVisible = _ref.menuVisible,
      menuVisible = _ref$menuVisible === undefined ? true : _ref$menuVisible,
      _ref$pixelsToShowMenu = _ref.pixelsToShowMenuWhite,
      pixelsToShowMenuWhite = _ref$pixelsToShowMenu === undefined ? 50 : _ref$pixelsToShowMenu,
      _ref$transparentOnTop = _ref.transparentOnTop,
      transparentOnTop = _ref$transparentOnTop === undefined ? false : _ref$transparentOnTop,
      _ref$whiteBackground = _ref.whiteBackground,
      whiteBackground = _ref$whiteBackground === undefined ? false : _ref$whiteBackground,
      _ref$promoBarHeight = _ref.promoBarHeight,
      promoBarHeight = _ref$promoBarHeight === undefined ? 0 : _ref$promoBarHeight,
      _ref$loginOnly = _ref.loginOnly,
      loginOnly = _ref$loginOnly === undefined ? false : _ref$loginOnly,
      _ref$logoOnly = _ref.logoOnly,
      logoOnly = _ref$logoOnly === undefined ? false : _ref$logoOnly;

  var _useState = (0, _react.useState)(null),
      _useState2 = _slicedToArray(_useState, 2),
      activeMenu = _useState2[0],
      setActiveMenu = _useState2[1];

  var _useState3 = (0, _react.useState)(true),
      _useState4 = _slicedToArray(_useState3, 2),
      isAtTop = _useState4[0],
      setIsAtTop = _useState4[1];

  var _useState5 = (0, _react.useState)(false),
      _useState6 = _slicedToArray(_useState5, 2),
      mobileMenuOpen = _useState6[0],
      setMobileMenuOpen = _useState6[1];

  var _useState7 = (0, _react.useState)({}),
      _useState8 = _slicedToArray(_useState7, 2),
      mobileOpenSections = _useState8[0],
      setMobileOpenSections = _useState8[1];

  var closeTimerRef = (0, _react.useRef)(null);
  var dropdownRefs = (0, _react.useRef)([]);

  var showTransparentTop = transparentOnTop && isAtTop && !whiteBackground && !mobileMenuOpen;

  var closeMobileMenu = (0, _react.useCallback)(function () {
    setMobileMenuOpen(false);
    setMobileOpenSections({});
  }, []);

  var toggleMobileMenu = function toggleMobileMenu() {
    if (mobileMenuOpen) {
      closeMobileMenu();
    } else {
      setMobileMenuOpen(true);
    }
  };

  var toggleMobileSection = function toggleMobileSection(index) {
    setMobileOpenSections(function (prev) {
      return _extends({}, prev, _defineProperty({}, index, !prev[index]));
    });
  };

  var closeAllDropdowns = function closeAllDropdowns() {
    return setActiveMenu(null);
  };

  var handleNavItemEnter = function handleNavItemEnter(index) {
    clearTimeout(closeTimerRef.current);
    setActiveMenu(index);

    var dd = dropdownRefs.current[index];
    if (!dd) return;

    dd.style.left = '';
    dd.style.right = '';

    requestAnimationFrame(function () {
      var rect = dd.getBoundingClientRect();
      var vw = window.innerWidth;
      if (rect.right > vw - 8) {
        var overflow = rect.right - (vw - 8);
        var currentLeft = parseFloat(window.getComputedStyle(dd).left) || 0;
        if (dd.style.right === '') {
          dd.style.left = currentLeft - overflow + 'px';
        }
      }
      if (rect.left < 8) {
        dd.style.left = '0px';
      }
    });
  };

  var handleNavItemLeave = function handleNavItemLeave(index) {
    closeTimerRef.current = setTimeout(function () {
      setActiveMenu(function (current) {
        return current === index ? null : current;
      });
    }, 100);
  };

  (0, _react.useEffect)(function () {
    var handleScroll = function handleScroll() {
      var scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      setIsAtTop(scrollTop <= pixelsToShowMenuWhite);
    };

    window.addEventListener('scroll', handleScroll, { passive: true });
    handleScroll();

    return function () {
      window.removeEventListener('scroll', handleScroll);
    };
  }, [pixelsToShowMenuWhite]);

  (0, _react.useEffect)(function () {
    document.body.classList.toggle('mobile-menu-is-open', mobileMenuOpen);
    if (!mobileMenuOpen) {
      return undefined;
    }

    var onKeyDown = function onKeyDown(event) {
      if (event.key === 'Escape') {
        closeMobileMenu();
      }
    };

    document.addEventListener('keydown', onKeyDown);
    return function () {
      document.body.classList.remove('mobile-menu-is-open');
      document.removeEventListener('keydown', onKeyDown);
    };
  }, [mobileMenuOpen, closeMobileMenu]);

  (0, _react.useEffect)(function () {
    var onDocumentClick = function onDocumentClick(event) {
      if (!event.target.closest('.site-nav__item')) {
        closeAllDropdowns();
      }
    };

    var onEscape = function onEscape(event) {
      if (event.key === 'Escape') {
        closeAllDropdowns();
      }
    };

    document.addEventListener('click', onDocumentClick);
    document.addEventListener('keydown', onEscape);

    return function () {
      document.removeEventListener('click', onDocumentClick);
      document.removeEventListener('keydown', onEscape);
      clearTimeout(closeTimerRef.current);
    };
  }, []);

  var navClassName = ['site-nav', hideOnScroll ? 'hide-on-scroll' : '', hideOnScroll && !menuVisible ? 'menu-hidden' : 'menu-visible', showTransparentTop ? 'at-top' : 'scrolled', promoBarHeight > 0 ? 'has-promo-bar' : '', mobileMenuOpen ? 'mobile-open' : '', logoOnly ? 'logo-only' : ''].filter(Boolean).join(' ');

  var menuItems = loginOnly ? [] : _siteNavData.siteNavData;

  return _react2.default.createElement(
    _react.Fragment,
    null,
    _react2.default.createElement(
      _reactStatic.Head,
      null,
      _react2.default.createElement('link', { rel: 'stylesheet', href: 'https://fonts.googleapis.com/icon?family=Material+Icons' })
    ),
    _react2.default.createElement(
      'header',
      { className: navClassName, id: 'siteHeader' },
      _react2.default.createElement(
        'a',
        { href: '/', className: 'site-nav__logo', 'aria-label': 'Mercos' },
        _react2.default.createElement(_Picture2.default, {
          src: '/images/site/logo-mercos-colored.svg',
          alt: 'Mercos',
          className: 'site-nav__logo-img'
        })
      ),
      !loginOnly && !logoOnly && _react2.default.createElement(
        'nav',
        { className: 'site-nav__desktop', 'aria-label': 'Navega\xE7\xE3o principal' },
        _react2.default.createElement(
          'ul',
          { className: 'site-nav__menu' },
          menuItems.map(function (menuItem, idx) {
            return _react2.default.createElement(
              'li',
              {
                key: menuItem.label,
                className: 'site-nav__item' + (activeMenu === idx ? ' open' : ''),
                onMouseEnter: function onMouseEnter() {
                  return handleNavItemEnter(idx);
                },
                onMouseLeave: function onMouseLeave() {
                  return handleNavItemLeave(idx);
                }
              },
              _react2.default.createElement(
                'button',
                {
                  type: 'button',
                  className: 'site-nav__trigger',
                  'aria-haspopup': 'true',
                  'aria-expanded': activeMenu === idx
                },
                menuItem.label
              ),
              _react2.default.createElement(
                'div',
                {
                  ref: function ref(el) {
                    dropdownRefs.current[idx] = el;
                  },
                  className: 'site-nav__dropdown' + (menuItem.grid ? ' site-nav__dropdown--grid' : ''),
                  role: 'menu'
                },
                menuItem.items.map(function (item, subIdx) {
                  if (item.type === 'separator') {
                    return _react2.default.createElement(
                      'div',
                      { key: item.label + '-' + subIdx, className: 'site-nav__dd-label' },
                      item.label
                    );
                  }

                  return _react2.default.createElement(
                    'a',
                    {
                      key: item.link + '-' + subIdx,
                      href: item.link,
                      className: 'site-nav__dd-item',
                      role: 'menuitem',
                      target: item.target,
                      rel: item.target === '_blank' ? 'noopener noreferrer' : undefined
                    },
                    _react2.default.createElement(
                      'span',
                      { className: 'material-icons site-nav__dd-icon' },
                      item.icon
                    ),
                    _react2.default.createElement(
                      'div',
                      { className: 'site-nav__dd-text' },
                      renderItemTitle(item.title),
                      item.description ? _react2.default.createElement(
                        'p',
                        null,
                        item.description
                      ) : null
                    )
                  );
                })
              )
            );
          })
        )
      ),
      !logoOnly && _react2.default.createElement(
        'div',
        { className: 'site-nav__actions' },
        _react2.default.createElement(
          'button',
          {
            type: 'button',
            className: 'site-nav__cta',
            onClick: function onClick() {
              return (0, _Utm.redirectWithCookies)('https://app.mercos.com/cadastro/');
            }
          },
          'comece gr\xE1tis'
        ),
        _react2.default.createElement(
          'button',
          {
            type: 'button',
            className: 'site-nav__login',
            onClick: function onClick() {
              return (0, _Utm.redirectWithCookies)('https://app.mercos.com/login/');
            }
          },
          'Fazer login ',
          _react2.default.createElement(
            'span',
            { className: 'material-icons' },
            'chevron_right'
          )
        )
      ),
      !logoOnly && _react2.default.createElement(
        'button',
        {
          type: 'button',
          className: 'site-nav__mobile-cta',
          onClick: function onClick() {
            return (0, _Utm.redirectWithCookies)('https://app.mercos.com/cadastro/');
          }
        },
        'comece gr\xE1tis'
      ),
      !logoOnly && _react2.default.createElement(
        'button',
        {
          type: 'button',
          className: 'site-nav__hamburger' + (mobileMenuOpen ? ' active' : ''),
          id: 'headerHamburger',
          'aria-label': mobileMenuOpen ? 'Fechar menu' : 'Abrir menu',
          'aria-expanded': mobileMenuOpen,
          'aria-controls': 'mobileNav',
          onClick: toggleMobileMenu
        },
        _react2.default.createElement('span', null),
        _react2.default.createElement('span', null),
        _react2.default.createElement('span', null)
      )
    ),
    !logoOnly && _react2.default.createElement(
      'nav',
      {
        className: 'site-nav__mobile' + (mobileMenuOpen ? ' active' : ''),
        id: 'mobileNav',
        'aria-label': 'Menu mobile',
        'aria-hidden': !mobileMenuOpen
      },
      menuItems.map(function (menuItem, idx) {
        return _react2.default.createElement(
          'div',
          {
            key: menuItem.label,
            className: 'site-nav__mob-section' + (mobileOpenSections[idx] ? ' open' : '')
          },
          _react2.default.createElement(
            'button',
            {
              type: 'button',
              className: 'site-nav__mob-toggle',
              onClick: function onClick() {
                return toggleMobileSection(idx);
              }
            },
            menuItem.label,
            _react2.default.createElement(
              'span',
              { className: 'material-icons' },
              'expand_more'
            )
          ),
          _react2.default.createElement(
            'div',
            { className: 'site-nav__mob-items' },
            _react2.default.createElement(
              'div',
              { className: 'site-nav__mob-items-inner' },
              menuItem.items.map(function (item, subIdx) {
                if (item.type === 'separator') {
                  return _react2.default.createElement(
                    'div',
                    { key: item.label + '-' + subIdx, className: 'site-nav__mob-label' },
                    item.label
                  );
                }

                return _react2.default.createElement(
                  'a',
                  {
                    key: item.link + '-' + subIdx,
                    href: item.link,
                    className: 'site-nav__mob-item',
                    target: item.target,
                    rel: item.target === '_blank' ? 'noopener noreferrer' : undefined,
                    onClick: closeMobileMenu
                  },
                  _react2.default.createElement(
                    'span',
                    { className: 'material-icons' },
                    item.icon
                  ),
                  _react2.default.createElement(
                    'div',
                    null,
                    renderItemTitle(item.title),
                    item.description ? _react2.default.createElement(
                      'p',
                      null,
                      item.description
                    ) : null
                  )
                );
              })
            )
          )
        );
      }),
      _react2.default.createElement(
        'div',
        { className: 'site-nav__mob-actions' },
        _react2.default.createElement(
          'button',
          {
            type: 'button',
            className: 'site-nav__mob-actions-cta',
            onClick: function onClick() {
              return (0, _Utm.redirectWithCookies)('https://app.mercos.com/cadastro/');
            }
          },
          'comece gr\xE1tis'
        ),
        _react2.default.createElement(
          'button',
          {
            type: 'button',
            className: 'site-nav__mob-actions-login',
            onClick: function onClick() {
              return (0, _Utm.redirectWithCookies)('https://app.mercos.com/login/');
            }
          },
          'Fazer login ',
          _react2.default.createElement(
            'span',
            { className: 'material-icons' },
            'chevron_right'
          )
        )
      )
    )
  );
};

exports.default = SiteNav;

/***/ }),

/***/ 548:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 549:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.siteNavData = undefined;

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var siteNavData = exports.siteNavData = [{
  label: 'Soluções',
  items: [{
    title: 'Força de vendas',
    description: '+25 indicadores e +30 relatórios para gerenciar sua equipe',
    icon: 'bar_chart',
    link: '/forca-vendas/'
  }, {
    title: 'E-commerce B2B',
    description: 'Venda 24h por dia com a loja online de empresas para empresas',
    icon: 'shopping_cart',
    link: '/e-commerce-b2b'
  }, {
    type: 'separator',
    label: 'Outras Soluções'
  }, {
    title: 'CRM',
    description: 'Cuide da prospecção ao pós-venda dos clientes em um só lugar',
    icon: 'filter_alt',
    link: '/crm-de-vendas'
  }, {
    title: 'Mercos Pay',
    description: 'Receba pagamentos por pix, boleto e cartões de crédito',
    icon: 'credit_card',
    link: '/mercos-pay'
  }, {
    title: 'Videochamada',
    description: 'Venda por vídeo com experiência de visita presencial',
    icon: 'videocam',
    link: '/videochamada'
  }]
}, {
  label: 'Segmentos',
  items: [{
    title: 'Indústrias',
    description: 'Automatize vendas, conecte canais e escale seu negócio com inteligência',
    icon: 'factory',
    link: '/sistema-para-industria/'
  }, {
    title: 'Distribuidoras',
    description: 'Gerencie clientes e pedidos, vendas automatizadas e integração total',
    icon: 'home_work',
    link: '/sistema-distribuidora/'
  }, {
    title: 'Representantes',
    description: 'Crie e gerencie políticas comerciais para cada cliente e representada',
    icon: 'work',
    link: '/sistema-representante/'
  }]
}, {
  label: 'Planos e preços',
  items: [{
    title: _react2.default.createElement(
      _react.Fragment,
      null,
      'Planos para ',
      _react2.default.createElement(
        'strong',
        null,
        'Ind\xFAstrias e distribuidoras'
      )
    ),
    description: '',
    icon: 'factory',
    link: '/planos-e-precos/industrias-e-distribuidoras/'
  }, {
    title: _react2.default.createElement(
      _react.Fragment,
      null,
      'Planos para ',
      _react2.default.createElement(
        'strong',
        null,
        'Representantes'
      )
    ),
    description: '',
    icon: 'work',
    link: '/planos-e-precos/representantes/'
  }]
}, {
  label: 'Integrações',
  items: [{
    title: 'ERPs integrados',
    description: '+250 ERPs parceiros integrados ao Força de vendas e E-commerce B2B',
    icon: 'device_hub',
    link: '/integracao-erp'
  }, {
    title: 'Seja Parceiro',
    description: 'Seja um Mpartner e leve seu negócio ao próximo nível',
    icon: 'people',
    link: '/parceiros'
  }]
}, {
  label: 'Recursos',
  grid: true,
  items: [{
    title: 'Aplicativo de vendas',
    description: 'Emita pedidos até sem internet e agilize a rotina do seu time comercial.',
    icon: 'smartphone',
    link: '/recursos/aplicativo-vendas-externas/'
  }, {
    title: 'Mercos IA',
    description: 'Inteligência Artificial na palma da sua mão',
    icon: 'auto_awesome',
    link: '/recursos/mercos-ia/'
  }, {
    title: 'Indicadores de vendas',
    description: 'Visualize a performance do seu comercial em tempo real e tome decisões mais rápidas.',
    icon: 'show_chart',
    link: '/recursos/indicadores-performance/'
  }, {
    title: 'Materiais ricos',
    description: 'Ebooks e guias para turbinar sua estratégia de vendas B2B.',
    icon: 'menu_book',
    link: '/materiais/'
  }, {
    title: 'Políticas comerciais',
    description: 'Aplique regras de preço, desconto e acréscimo sem erro – tudo de forma automática.',
    icon: 'flag',
    link: '/recursos/politica-comercial-vendas/'
  }, {
    title: 'Cases',
    description: 'Veja cases de sucesso e inspire melhores resultados para sua empresa.',
    icon: 'rocket_launch',
    link: 'https://mercos.com/cases/'
  }]
}];

/***/ }),

/***/ 550:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 551:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _SiteNav = __webpack_require__(547);

var _SiteNav2 = _interopRequireDefault(_SiteNav);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _SiteNav2.default;

/***/ }),

/***/ 552:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

__webpack_require__(553);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var TESTIMONIALS = [{
    testimonial: "“Imagine a nossa felicidade em ganhar produtividade, se adaptar ao mercado e às tendências. Não tem jeito, quem não faz isso perde grandes oportunidades”",
    author: "Alexandre Santos",
    company: "Delícia Lanches"
}, {
    testimonial: "“Tínhamos o desafio de dobrar o faturamento em 12 meses e conseguimos atingir essa meta em apenas 10. O software da Mercos foi crucial para isto.”",
    author: "Rafael A. Krause",
    company: "Grupo Herbia"
}, {
    testimonial: "“Meu Foco é ajudar clientes a fazer negócios, para isso uso tanto o presencial quanto a tecnologia como aliados”",
    author: "Felipe Rodrigues",
    company: "IF Consultoria e Representação"
}, {
    testimonial: "“Essencial para qualquer representante que quer crescer. Toda minha equipe usa Mercos, melhoramos o atendimento e aumentarmos nosso volume de vendas.”",
    author: "Afonso Tonelli",
    company: "Musical Plus Representações"
}];
var TESTIMONIALS2 = [{
    testimonial: "“Desconheço software de vendas igual. Com Mercos elevamos o faturamento em mais 300% em menos de 3 anos.”",
    author: "Gustavo Ribeiro",
    company: "Impacttus Cosméticos"
}, {
    testimonial: "“Passamos a prospectar e vender, além do presencial, 24 horas e 7 dias da semana para os clientes! Nosso intuito era vender além do território que atingíamos com as vendas externas. E foi isso que começamos a fazer, em pouquíssimo tempo!”",
    author: "Alan Alves",
    company: "Almmati"
}, {
    testimonial: "“Minha melhor experiência com a Mercos, é a facilidade que ele me dá na rua. A dinâmica que eu tenho e o volume de informações que eu consigo, isso me facilita muito!”",
    author: "Cristiano Oliveira",
    company: "Representante Comercial Harman"
}];

var ModalTestimonials = function (_Component) {
    _inherits(ModalTestimonials, _Component);

    function ModalTestimonials() {
        _classCallCheck(this, ModalTestimonials);

        return _possibleConstructorReturn(this, (ModalTestimonials.__proto__ || Object.getPrototypeOf(ModalTestimonials)).apply(this, arguments));
    }

    _createClass(ModalTestimonials, [{
        key: 'render',
        value: function render() {
            return _react2.default.createElement(
                'div',
                { className: 'modal-testimonials' },
                _react2.default.createElement(
                    'div',
                    { className: 'testimonials-col' },
                    TESTIMONIALS.map(function (testimonial) {
                        return _react2.default.createElement(
                            'div',
                            { className: 'modal-testimonial-box' },
                            _react2.default.createElement(
                                'p',
                                { className: 'modal-testimonial-text' },
                                testimonial.testimonial
                            ),
                            _react2.default.createElement(
                                'p',
                                { className: 'modal-testimonial-name' },
                                testimonial.author
                            ),
                            _react2.default.createElement(
                                'p',
                                { className: 'modal-testimonial-company' },
                                testimonial.company
                            )
                        );
                    })
                ),
                _react2.default.createElement(
                    'div',
                    { className: 'testimonials-col testimonials-col2' },
                    TESTIMONIALS2.map(function (testimonial) {
                        return _react2.default.createElement(
                            'div',
                            { className: 'modal-testimonial-box' },
                            _react2.default.createElement(
                                'p',
                                { className: 'modal-testimonial-text' },
                                testimonial.testimonial
                            ),
                            _react2.default.createElement(
                                'p',
                                { className: 'modal-testimonial-name' },
                                testimonial.author
                            ),
                            _react2.default.createElement(
                                'p',
                                { className: 'modal-testimonial-company' },
                                testimonial.company
                            )
                        );
                    })
                )
            );
        }
    }]);

    return ModalTestimonials;
}(_react.Component);

exports.default = ModalTestimonials;

/***/ }),

/***/ 553:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 554:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

var _jsCookie = __webpack_require__(174);

var _jsCookie2 = _interopRequireDefault(_jsCookie);

var _propTypes = __webpack_require__(9);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Picture = __webpack_require__(531);

var _Picture2 = _interopRequireDefault(_Picture);

var _Button = __webpack_require__(533);

var _Button2 = _interopRequireDefault(_Button);

var _Modal = __webpack_require__(535);

var _Modal2 = _interopRequireDefault(_Modal);

var _InputFloatingLabel = __webpack_require__(541);

var _InputFloatingLabel2 = _interopRequireDefault(_InputFloatingLabel);

var _RDGateway = __webpack_require__(175);

var _RDGateway2 = _interopRequireDefault(_RDGateway);

var _masks = __webpack_require__(537);

var _Utm = __webpack_require__(532);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var FIELDS = ['name', 'email', 'telephone', 'activity'];

var ACTIVITY = {
    industria: 'Indústria',
    distribuicao: 'Distribuição',
    rep: 'Representação Comercial',
    outra: 'Outro'
};

var USERS = {
    um: '1',
    cinco: '2-5',
    vinte: '6-20',
    cinquenta: '21-50',
    cinquentaum: '51 ou mais'
};

var DemoFormB2B = function (_Component) {
    _inherits(DemoFormB2B, _Component);

    function DemoFormB2B(props) {
        _classCallCheck(this, DemoFormB2B);

        var _this = _possibleConstructorReturn(this, (DemoFormB2B.__proto__ || Object.getPrototypeOf(DemoFormB2B)).call(this, props));

        _this.handleActivityChange = function (activity) {
            _this.setState({ selectedActivity: activity });
        };

        _this.handleActivityDropdownClick = function (e) {
            var dropdown = e.currentTarget.nextElementSibling;
            var button = e.currentTarget;

            dropdown.classList.toggle('show');
            button.classList.toggle('expanded');
        };

        _this.handleUsersDropdownClick = function (e) {
            var dropdown = e.currentTarget.nextElementSibling;
            var button = e.currentTarget;

            dropdown.classList.toggle('show');
            button.classList.toggle('expanded');
        };

        _this.handleActivityOptionClick = function (activity) {
            var button = document.activeElement.closest('.activity-wrapper').querySelector('.activity-dropdown-button');
            var dropdown = document.activeElement.closest('.activity-wrapper').querySelector('.activity-dropdown');

            dropdown.classList.remove('show');
            button.classList.remove('expanded');
            button.classList.add('option-selected');
            button.textContent = activity;

            _this.handlerEnterpriseActivity(activity);
        };

        _this.handleUsersOptionClick = function (users) {
            var button = document.activeElement.closest('.activity-wrapper').querySelector('.activity-dropdown-button');
            var dropdown = document.activeElement.closest('.activity-wrapper').querySelector('.activity-dropdown');

            dropdown.classList.remove('show');
            button.classList.remove('expanded');
            button.classList.add('option-selected');
            button.textContent = users;

            _this.handlerUsers(users);
        };

        _this.rdGateway = new _RDGateway2.default();
        _this.state = _this.getInitialState(props);

        globalThis.optimizeOpenPopupB2B = function () {
            _this.setState({ showDemoModal: true });
        };
        return _this;
    }

    _createClass(DemoFormB2B, [{
        key: 'getInitialState',
        value: function getInitialState(props) {
            var initialObject = {
                showDemoModal: false,
                company: '',
                name: '',
                email: '',
                telephone: '',
                activity: '',
                users: '',
                partnerId: props.partnerId
            };
            var fields = props.showUsersField ? [].concat(FIELDS, ['users']) : FIELDS;
            fields.forEach(function (campo) {
                initialObject[campo + 'Error'] = false;
                initialObject[campo + 'Typing'] = false;
            });
            return initialObject;
        }
    }, {
        key: 'setDataByCookie',
        value: function setDataByCookie() {
            this.setState({
                partnerId: _jsCookie2.default.get('leaderPartnerId') || this.state.partnerId || ''
            });
        }
    }, {
        key: 'openDemoModal',
        value: function openDemoModal(e) {
            e.preventDefault();

            this.setState({
                showDemoModal: true
            });
        }
    }, {
        key: 'closeDemoModal',
        value: function closeDemoModal() {
            this.setState({
                showDemoModal: false
            });
        }
    }, {
        key: 'handleChange',
        value: function handleChange(e) {
            var _setState;

            var name = e.target.id;
            var value = e.target.value;
            var company = this.state.name + ' - ' + this.state.email;

            if (name === 'telephone') {
                value = (0, _masks.telephoneMask)(value);
            } else if (name === 'name') {
                company = value + ' - ' + this.state.email;
            } else if (name === 'email') {
                company = this.state.name + ' - ' + value;
            }

            this.setState((_setState = {}, _defineProperty(_setState, name, value), _defineProperty(_setState, 'company', company), _defineProperty(_setState, name + 'Error', false), _defineProperty(_setState, name + 'Typing', true), _setState));
        }
    }, {
        key: 'handlerEnterpriseActivity',
        value: function handlerEnterpriseActivity(tipo) {
            this.setState({ 'activity': tipo });
        }
    }, {
        key: 'handlerUsers',
        value: function handlerUsers(users) {
            this.setState({ 'users': users });
        }
    }, {
        key: 'getSelectedActivity',
        value: function getSelectedActivity(selected) {
            return this.state.activity === selected ? 'active' : '';
        }
    }, {
        key: 'getSelectedUsers',
        value: function getSelectedUsers(selected) {
            return this.state.users === selected ? 'active' : '';
        }
    }, {
        key: 'validation',
        value: function validation() {
            var _this2 = this;

            var newState = {};

            var regexTelephone = /^\([1-9]{2}\) [2-9][0-9]{3,4}\-[0-9]{4}$/;
            var fields = this.props.showUsersField ? [].concat(FIELDS, ['users']) : FIELDS;
            fields.forEach(function (campo) {
                newState[campo + 'Error'] = !_this2.state[campo];
                switch (campo) {
                    case 'email':
                        {
                            newState[campo + 'Error'] = !_this2.validateEmail(_this2.state[campo]);
                            break;
                        }
                    case 'telephone':
                        {
                            newState[campo + 'Error'] = !regexTelephone.test(_this2.state[campo]);
                            break;
                        }
                }
            });
            this.setState(newState);
            var lista = Object.values(newState);
            return lista.every(function (value) {
                return !value;
            });
        }
    }, {
        key: 'validateEmail',
        value: function validateEmail(email) {
            var regexEmail = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            return regexEmail.test(email.toLowerCase());
        }
    }, {
        key: 'submitForm',
        value: function submitForm(e) {
            e.preventDefault();
            if (this.validation()) {
                var data = {
                    conversion_identifier: 'fale-consultor-b2b',
                    'cf_tipo_de_conversao': 'Solicitou demonstração E-commerce B2B',
                    company_name: this.state.company,
                    name: this.state.name,
                    email: this.state.email,
                    personal_phone: this.state.telephone,
                    'cf_atividade_da_empresa': this.state.activity,
                    event_action: 'solicitou_demo',
                    event_label: 'ecommerce_b2b'
                };

                if (this.props.showUsersField) {
                    data['cf_numero_de_vendedores'] = this.state.users;
                }

                if (this.state.partnerId) {
                    data.conversion_identifier = 'canais-lp';
                    data['cf_codigo_do_parceiro_meus_pedidos'] = this.state.partnerId;
                }

                var redirectLink = 'https://mercos.com/tp/solicitou-demo-b2b/';
                if (this.state.activity === ACTIVITY.rep || this.state.activity === ACTIVITY.outra) {
                    redirectLink = 'https://materiais.mercos.com/tp-demo-b2b';
                } else if (this.props.euCommerce) {
                    redirectLink = 'https://mercos.com/tp/tp-parceria-mercos-eucommerce/';
                } else if (this.props.b2bPromo) {
                    redirectLink = 'https://materiais.mercos.com/tp-clientes-demo-b2b';
                }
                this.rdGateway.sendToRDStation(data, redirectLink);
            }
        }
    }, {
        key: 'componentDidMount',
        value: function componentDidMount() {
            this.setDataByCookie();
        }
    }, {
        key: 'getDemoModal',
        value: function getDemoModal() {
            var _this3 = this;

            return _react2.default.createElement(
                _Modal2.default,
                { callbackCloseModal: function callbackCloseModal() {
                        return _this3.closeDemoModal();
                    }, className: this.props.formHeroStyle ? 'form-hero-demo-modal' : undefined },
                _react2.default.createElement(
                    'div',
                    { className: 'container-form-modal' },
                    this.getForm()
                )
            );
        }
    }, {
        key: 'getForm',
        value: function getForm() {
            var _this4 = this;

            return _react2.default.createElement(
                _react.Fragment,
                null,
                _react2.default.createElement(
                    'div',
                    { className: 'form-container' },
                    !this.props.hideTitle && this.props.title === false ? null : !this.props.hideTitle ? _react2.default.createElement(
                        'div',
                        { className: 'form-title' },
                        this.props.title ? this.props.title : 'Preencha o formulário abaixo e solicite uma demonstração',
                        ' ',
                        this.props.euCommerce ? this.props.euCommerce : '',
                        ' ',
                        this.props.b2bPromo ? this.props.b2bPromo : ''
                    ) : null,
                    _react2.default.createElement(
                        'form',
                        { action: '.', method: 'POST', className: 'new-form', onSubmit: function onSubmit(e) {
                                return _this4.submitForm(e);
                            } },
                        this.props.formHeroStyle ? _react2.default.createElement('input', { type: 'hidden', name: 'company', value: this.state.company }) : _react2.default.createElement(_InputFloatingLabel2.default, { type: 'hidden', name: 'company', value: this.state.company }),
                        _react2.default.createElement(_InputFloatingLabel2.default, { id: 'name', value: this.state.name, onChange: function onChange(e) {
                                return _this4.handleChange(e);
                            }, error: this.state.nameError, placeholder: this.props.formHeroStyle ? 'Nome completo' : 'Nome', inputPlaceholder: this.props.formHeroStyle ? 'Seu nome completo' : undefined }),
                        _react2.default.createElement(_InputFloatingLabel2.default, { id: 'email', value: this.state.email, onChange: function onChange(e) {
                                return _this4.handleChange(e);
                            }, error: this.state.emailError, placeholder: 'E-mail profissional', inputPlaceholder: this.props.formHeroStyle ? 'seu@empresa.com.br' : undefined }),
                        _react2.default.createElement(_InputFloatingLabel2.default, { id: 'telephone', value: this.state.telephone, onChange: function onChange(e) {
                                return _this4.handleChange(e);
                            }, error: this.state.telephoneError, maxLength: '15', placeholder: this.props.formHeroStyle ? 'Telefone / WhatsApp' : 'Telefone', inputPlaceholder: this.props.formHeroStyle ? '(00) 00000-0000' : undefined }),
                        _react2.default.createElement(
                            'div',
                            { className: 'activity-wrapper' },
                            _react2.default.createElement(
                                'div',
                                { className: 'activity-dropdown-button', onClick: this.handleActivityDropdownClick },
                                'Selecione uma op\xE7\xE3o'
                            ),
                            _react2.default.createElement(
                                'div',
                                { className: 'activity-dropdown' },
                                _react2.default.createElement(
                                    _Button2.default,
                                    { className: this.getSelectedActivity(ACTIVITY.industria), onClick: function onClick() {
                                            return _this4.handleActivityOptionClick(ACTIVITY.industria);
                                        } },
                                    _react2.default.createElement(_Picture2.default, { src: '/images/icon-industrias.svg' }),
                                    'Ind\xFAstrias'
                                ),
                                _react2.default.createElement(
                                    _Button2.default,
                                    { className: this.getSelectedActivity(ACTIVITY.distribuicao), onClick: function onClick() {
                                            return _this4.handleActivityOptionClick(ACTIVITY.distribuicao);
                                        } },
                                    _react2.default.createElement(_Picture2.default, { src: '/images/icon-distribuidoras.svg' }),
                                    'Distribuidoras'
                                ),
                                _react2.default.createElement(
                                    _Button2.default,
                                    { className: this.getSelectedActivity(ACTIVITY.rep), onClick: function onClick() {
                                            return _this4.handleActivityOptionClick(ACTIVITY.rep);
                                        } },
                                    _react2.default.createElement(_Picture2.default, { src: '/images/icon-representates.svg' }),
                                    'Representantes'
                                ),
                                _react2.default.createElement(
                                    _Button2.default,
                                    { className: this.getSelectedActivity(ACTIVITY.outra), onClick: function onClick() {
                                            return _this4.handleActivityOptionClick(ACTIVITY.outra);
                                        } },
                                    _react2.default.createElement(_Picture2.default, { src: '/images/icon-outros.svg' }),
                                    'Outra'
                                )
                            ),
                            _react2.default.createElement(
                                'span',
                                { className: 'floating-label' },
                                this.props.formHeroStyle ? 'Atividade da sua empresa' : 'Qual é a atividade da sua empresa?'
                            ),
                            this.state.activityError ? _react2.default.createElement(
                                'div',
                                { style: { color: 'red' } },
                                'Oops! Voc\xEA esqueceu de escolher uma op\xE7\xE3o.'
                            ) : null
                        ),
                        this.props.showUsersField && _react2.default.createElement(
                            'div',
                            { className: 'activity-wrapper' },
                            _react2.default.createElement(
                                'div',
                                { className: 'activity-dropdown-button', onClick: this.handleUsersDropdownClick },
                                'Selecione uma op\xE7\xE3o'
                            ),
                            _react2.default.createElement(
                                'div',
                                { className: 'activity-dropdown' },
                                _react2.default.createElement(
                                    _Button2.default,
                                    { className: this.getSelectedUsers(USERS.um), onClick: function onClick() {
                                            return _this4.handleUsersOptionClick(USERS.um);
                                        } },
                                    '1'
                                ),
                                _react2.default.createElement(
                                    _Button2.default,
                                    { className: this.getSelectedUsers(USERS.cinco), onClick: function onClick() {
                                            return _this4.handleUsersOptionClick(USERS.cinco);
                                        } },
                                    '2-5'
                                ),
                                _react2.default.createElement(
                                    _Button2.default,
                                    { className: this.getSelectedUsers(USERS.vinte), onClick: function onClick() {
                                            return _this4.handleUsersOptionClick(USERS.vinte);
                                        } },
                                    '6-20'
                                ),
                                _react2.default.createElement(
                                    _Button2.default,
                                    { className: this.getSelectedUsers(USERS.cinquenta), onClick: function onClick() {
                                            return _this4.handleUsersOptionClick(USERS.cinquenta);
                                        } },
                                    '21-50'
                                ),
                                _react2.default.createElement(
                                    _Button2.default,
                                    { className: this.getSelectedUsers(USERS.cinquentaum), onClick: function onClick() {
                                            return _this4.handleUsersOptionClick(USERS.cinquentaum);
                                        } },
                                    '51 ou mais'
                                )
                            ),
                            _react2.default.createElement(
                                'span',
                                { className: 'floating-label' },
                                'Quantidade de vendedores da sua empresa'
                            ),
                            this.state.usersError ? _react2.default.createElement(
                                'div',
                                { style: { color: 'red' } },
                                'Oops! Voc\xEA esqueceu de escolher uma op\xE7\xE3o.'
                            ) : null
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: 'submit-demo-modal' },
                            _react2.default.createElement(
                                _Button2.default,
                                { type: 'submit', className: 'new-submit new-button' },
                                this.props.submitButtonText
                            )
                        ),
                        this.props.formHeroStyle && _react2.default.createElement(
                            'div',
                            { className: 'form-hero-footer' },
                            _react2.default.createElement(
                                'span',
                                null,
                                'Especialista dedicado'
                            ),
                            _react2.default.createElement('span', { className: 'form-hero-footer__dot', 'aria-hidden': 'true' }),
                            _react2.default.createElement(
                                'span',
                                null,
                                'Demonstra\xE7\xE3o personalizada'
                            )
                        ),
                        this.props.showTrialLink && _react2.default.createElement(
                            'div',
                            { className: 'trial-link-wrapper' },
                            _react2.default.createElement(
                                'span',
                                { className: 'trial-link-text' },
                                'ou '
                            ),
                            _react2.default.createElement(
                                'a',
                                {
                                    href: 'https://app.mercos.com/cadastro/',
                                    className: 'trial-link',
                                    onClick: function onClick(e) {
                                        e.preventDefault();
                                        (0, _Utm.redirectWithCookies)('https://app.mercos.com/cadastro/');
                                    }
                                },
                                'Fa\xE7a um teste gr\xE1tis \u203A'
                            )
                        ),
                        (this.props.showForm || this.props.inline) && !this.props.showTrialLink && _react2.default.createElement(
                            'p',
                            { className: 'inline-form-trial-info' },
                            'Teste gr\xE1tis por 7 dias | Sem cobran\xE7a autom\xE1tica'
                        ),
                        this.props.showTrialLink && _react2.default.createElement(
                            'p',
                            { className: 'inline-form-trial-info' },
                            'Teste gr\xE1tis por 7 dias | Sem cobran\xE7a autom\xE1tica'
                        )
                    )
                )
            );
        }
    }, {
        key: 'getCTA',
        value: function getCTA() {
            return _react2.default.createElement(
                _react.Fragment,
                null,
                _react2.default.createElement(
                    'div',
                    { className: 'cta-button-form' },
                    this.getModalButton(),
                    _react2.default.createElement(
                        'p',
                        { className: 'font-light font-12' },
                        'integra\xE7\xE3o com mais de 200 ERPs ',
                        _react2.default.createElement(
                            'span',
                            { className: 'cta-text-separator' },
                            '| '
                        ),
                        'venda 24h por dia, 7 dias por semana ',
                        _react2.default.createElement(
                            'span',
                            { className: 'cta-text-separator' },
                            '| '
                        ),
                        'simples de usar'
                    )
                )
            );
        }
    }, {
        key: 'getModalButton',
        value: function getModalButton() {
            var _this5 = this;

            return _react2.default.createElement(
                _react.Fragment,
                null,
                _react2.default.createElement(
                    'button',
                    {
                        href: '.',
                        className: 'new-button  ' + (this.props.trialAndDemo ? 'button-secondary' : 'button-primary'),
                        onClick: function onClick(e) {
                            return _this5.openDemoModal(e);
                        },
                        title: 'Pe\xE7a uma demonstra\xE7\xE3o aos nossos especialistas.'
                    },
                    this.props.modalButtonText || this.props.children || 'peça uma demonstração'
                ),
                this.props.buttonOnly && _react2.default.createElement(
                    'p',
                    { className: 'button-only-trial-info' },
                    'Teste gr\xE1tis por 7 dias | Sem cobran\xE7a autom\xE1tica'
                )
            );
        }
    }, {
        key: 'getModalLink',
        value: function getModalLink() {
            var _this6 = this;

            return _react2.default.createElement(
                'a',
                {
                    href: '.',
                    className: 'button-txt ' + (this.props.darkBg ? 'button-txt-white' : ''),
                    onClick: function onClick(e) {
                        return _this6.openDemoModal(e);
                    },
                    title: 'Pe\xE7a uma demonstra\xE7\xE3o aos nossos especialistas.'
                },
                this.props.modalButtonText || 'conheça o E-commerce B2B ›'
            );
        }
    }, {
        key: 'getTrialAndDemo',
        value: function getTrialAndDemo() {
            var _this7 = this;

            var demoButtonClass = this.props.invertButtons ? 'button-primary' : 'button-secondary';
            var trialButtonClass = this.props.invertButtons ? 'button-secondary' : 'button-primary';

            return _react2.default.createElement(
                'div',
                { className: 'wrapper-trial-and-demo mobile-only' },
                _react2.default.createElement(
                    'button',
                    {
                        className: 'new-button ' + demoButtonClass + ' ' + (this.props.darkBg ? 'dark-bg' : ''),
                        onClick: function onClick(e) {
                            return _this7.openDemoModal(e);
                        },
                        title: 'Pe\xE7a uma demonstra\xE7\xE3o aos nossos especialistas.'
                    },
                    this.props.modalButtonText || 'peça uma demonstração'
                ),
                _react2.default.createElement(
                    'button',
                    {
                        className: 'new-button ' + trialButtonClass + ' ' + (this.props.darkBg ? 'dark-bg' : ''),
                        onClick: function onClick() {
                            return (0, _Utm.redirectWithCookies)('https://app.mercos.com/cadastro/');
                        },
                        href: '#',
                        title: 'Cadastre-se no Mercos!'
                    },
                    this.props.trialAndDemo
                ),
                this.props.invertButtons && _react2.default.createElement(
                    'p',
                    { className: 'trial-info-text' },
                    'Teste gr\xE1tis por 7 dias | Sem cobran\xE7a autom\xE1tica'
                )
            );
        }
    }, {
        key: 'render',
        value: function render() {
            return _react2.default.createElement(
                _react.Fragment,
                null,
                _react2.default.createElement(
                    'div',
                    { className: 'new-form-wrapper new-form-wrapper-b2b' },
                    this.props.modaLink ? this.getModalLink() : this.props.trialAndDemo ? this.getTrialAndDemo() : this.props.buttonOnly ? this.getModalButton() : this.getCTA(),
                    this.props.showForm && _react2.default.createElement(
                        'div',
                        { className: 'show-full-form' },
                        this.getForm()
                    ),
                    this.state.showDemoModal && this.getDemoModal()
                )
            );
        }
    }]);

    return DemoFormB2B;
}(_react.Component);

DemoFormB2B.propTypes = {
    b2b: _propTypes2.default.bool,
    contaAzul: _propTypes2.default.bool,
    className: _propTypes2.default.string,
    radius: _propTypes2.default.string,
    partnerId: _propTypes2.default.string,
    buttonOnly: _propTypes2.default.bool,
    modalButtonText: _propTypes2.default.string,
    hideTitle: _propTypes2.default.bool,
    submitButtonText: _propTypes2.default.string,
    showTrialLink: _propTypes2.default.bool,
    invertButtons: _propTypes2.default.bool,
    showUsersField: _propTypes2.default.bool,
    formHeroStyle: _propTypes2.default.bool
};
DemoFormB2B.defaultProps = {
    b2b: false,
    contaAzul: false,
    radius: 'half-rounded',
    buttonOnly: false,
    hideTitle: false,
    submitButtonText: 'Solicitar demonstração',
    showTrialLink: false,
    invertButtons: false,
    showUsersField: true,
    formHeroStyle: false
};
exports.default = DemoFormB2B;

/***/ }),

/***/ 555:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
// Constants for Mercos site numbers
// Centralized place to manage all the client numbers and revenue figures

var SITE_CONSTANTS = exports.SITE_CONSTANTS = {
  // Client numbers (updated to 9 mil)
  CLIENTS_COUNT: '9 mil',
  CLIENTS_COUNT_WITH_PLUS: '+9 mil',
  CLIENTS_COUNT_DETAILED: '9.000',
  CLIENTS_COUNT_WITH_COMMA: '9 mil',

  // Revenue (updated to 100 bi)
  ANNUAL_REVENUE: 'R$ 100 BI',
  ANNUAL_REVENUE_LOWERCASE: 'R$ 100 bi',

  // App ratings
  GOOGLE_PLAY_RATING: '4,9',
  GOOGLE_PLAY_REVIEWS: '7 mil avaliações',
  APP_STORE_RATING: '4,8',
  APP_STORE_REVIEWS: '2,8 mil avaliações',
  GOOGLE_BUSINESS_RATING: '4,6',
  GOOGLE_BUSINESS_REVIEWS: '701 avaliações',

  // Other numbers that might be used
  USERS_COUNT: '+52 mil',
  USERS_COUNT_DETAILED: '56.000',
  ERPS_INTEGRATED: '+250',
  ANNUAL_ORDERS: '+ 14 MI'

  // Helper functions to get formatted numbers
};var getClientsCount = exports.getClientsCount = function getClientsCount() {
  var format = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'default';

  switch (format) {
    case 'plus':
      return SITE_CONSTANTS.CLIENTS_COUNT_WITH_PLUS;
    case 'detailed':
      return SITE_CONSTANTS.CLIENTS_COUNT_DETAILED;
    case 'comma':
      return SITE_CONSTANTS.CLIENTS_COUNT_WITH_COMMA;
    default:
      return SITE_CONSTANTS.CLIENTS_COUNT;
  }
};

var getRevenue = exports.getRevenue = function getRevenue() {
  var lowercase = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

  return lowercase ? SITE_CONSTANTS.ANNUAL_REVENUE_LOWERCASE : SITE_CONSTANTS.ANNUAL_REVENUE;
};

/***/ }),

/***/ 560:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(530);

var _classnames2 = _interopRequireDefault(_classnames);

__webpack_require__(534);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Heading4 = function Heading4(_ref) {
    var children = _ref.children,
        center = _ref.center,
        white = _ref.white,
        gray = _ref.gray,
        bottomSpace = _ref.bottomSpace,
        className = _ref.className;
    return _react2.default.createElement(
        'h4',
        { className: (0, _classnames2.default)('heading4', className, center ? 'text-center' : '', white ? 'heading-white' : '', gray ? 'heading-gray' : '', bottomSpace ? 'bottom-space' : '') },
        children
    );
};

exports.default = Heading4;

/***/ }),

/***/ 563:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

var _Picture = __webpack_require__(531);

var _Picture2 = _interopRequireDefault(_Picture);

__webpack_require__(564);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DEFAULT_HELP_ICON = "/images/site/landing-pages/segmentos/help.svg";
var DEFAULT_ARROW_ICON = "/images/site/landing-pages/segmentos/keyboard-arrow-down.svg";

var UnifiedFAQ = function UnifiedFAQ(_ref) {
  var _ref$title = _ref.title,
      title = _ref$title === undefined ? "Perguntas frequentes" : _ref$title,
      subtitle = _ref.subtitle,
      _ref$faqItems = _ref.faqItems,
      faqItems = _ref$faqItems === undefined ? [] : _ref$faqItems,
      _ref$defaultOpenIndex = _ref.defaultOpenIndex,
      defaultOpenIndex = _ref$defaultOpenIndex === undefined ? 0 : _ref$defaultOpenIndex,
      _ref$className = _ref.className,
      className = _ref$className === undefined ? "" : _ref$className,
      titleId = _ref.titleId,
      _ref$titleTag = _ref.titleTag,
      TitleTag = _ref$titleTag === undefined ? "h2" : _ref$titleTag,
      _ref$questionTag = _ref.questionTag,
      QuestionTag = _ref$questionTag === undefined ? "span" : _ref$questionTag,
      _ref$helpIconSrc = _ref.helpIconSrc,
      helpIconSrc = _ref$helpIconSrc === undefined ? DEFAULT_HELP_ICON : _ref$helpIconSrc,
      _ref$arrowIconSrc = _ref.arrowIconSrc,
      arrowIconSrc = _ref$arrowIconSrc === undefined ? DEFAULT_ARROW_ICON : _ref$arrowIconSrc;

  var _useState = (0, _react.useState)(defaultOpenIndex),
      _useState2 = _slicedToArray(_useState, 2),
      activeIndex = _useState2[0],
      setActiveIndex = _useState2[1];

  var headingId = titleId || "faq-title-" + title.toLowerCase().replace(/[^a-z0-9]+/g, "-");

  if (!faqItems.length) {
    return null;
  }

  var toggleItem = function toggleItem(index) {
    setActiveIndex(activeIndex === index ? null : index);
  };

  return _react2.default.createElement(
    "section",
    { className: ("unified-faq faq-section " + className).trim(), "aria-labelledby": headingId },
    _react2.default.createElement(
      "div",
      { className: "faq-content" },
      _react2.default.createElement(
        "div",
        { className: "faq-header" },
        _react2.default.createElement(
          "div",
          { className: "faq-header__icon-wrap" },
          _react2.default.createElement(_Picture2.default, { src: helpIconSrc, alt: "", "aria-hidden": "true" })
        ),
        _react2.default.createElement(
          "div",
          { className: "faq-header__text-col" },
          _react2.default.createElement(
            TitleTag,
            { className: "faq-header__title", id: headingId },
            title
          ),
          subtitle && _react2.default.createElement(
            "div",
            { className: "faq-header__subtitle" },
            subtitle
          )
        )
      ),
      _react2.default.createElement(
        "ul",
        { className: "faq-accordion" },
        faqItems.map(function (item, index) {
          var isOpen = activeIndex === index;
          var answerId = headingId + "-answer-" + (index + 1);

          return _react2.default.createElement(
            "li",
            { className: "faq-item " + (isOpen ? "faq-item--open" : ""), key: item.question },
            _react2.default.createElement(
              "button",
              {
                className: "faq-item__btn",
                type: "button",
                "aria-expanded": isOpen,
                "aria-controls": answerId,
                onClick: function onClick() {
                  return toggleItem(index);
                }
              },
              _react2.default.createElement(
                QuestionTag,
                { className: "faq-item__question" },
                item.question
              ),
              _react2.default.createElement(_Picture2.default, { className: "faq-item__arrow", src: arrowIconSrc, alt: "", "aria-hidden": "true" })
            ),
            _react2.default.createElement(
              "div",
              { className: "faq-item__answer", id: answerId },
              _react2.default.createElement(
                "div",
                { className: "faq-item__answer-inner" },
                typeof item.answer === "string" ? _react2.default.createElement(
                  "p",
                  null,
                  item.answer
                ) : item.answer
              )
            )
          );
        })
      )
    )
  );
};

exports.default = UnifiedFAQ;

/***/ }),

/***/ 564:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 565:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(530);

var _classnames2 = _interopRequireDefault(_classnames);

__webpack_require__(534);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Heading1 = function Heading1(_ref) {
    var children = _ref.children,
        white = _ref.white,
        center = _ref.center,
        className = _ref.className,
        left = _ref.left,
        style = _ref.style,
        purple = _ref.purple,
        black = _ref.black;
    return _react2.default.createElement(
        'h1',
        { style: style,
            className: (0, _classnames2.default)('heading1', className, white && 'heading-white', center && 'text-center', left && 'text-left', purple && 'heading-purple', black && 'heading-black') },
        children
    );
};

exports.default = Heading1;

/***/ }),

/***/ 569:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

var _DemoForm = __webpack_require__(542);

var _DemoForm2 = _interopRequireDefault(_DemoForm);

var _DemoFormB2B = __webpack_require__(554);

var _DemoFormB2B2 = _interopRequireDefault(_DemoFormB2B);

var _Picture = __webpack_require__(531);

var _Picture2 = _interopRequireDefault(_Picture);

__webpack_require__(570);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FinalCTACard = function FinalCTACard(_ref) {
    var title = _ref.title,
        description = _ref.description,
        buttonVariant = _ref.buttonVariant,
        useB2BForm = _ref.useB2BForm,
        useMinimalStyle = _ref.useMinimalStyle,
        useWhatsAppStyle = _ref.useWhatsAppStyle,
        submitButtonText = _ref.submitButtonText,
        modalButtonText = _ref.modalButtonText,
        trialAndDemo = _ref.trialAndDemo,
        showTrialLink = _ref.showTrialLink,
        showTrialInfo = _ref.showTrialInfo,
        _ref$titleTag = _ref.titleTag,
        titleTag = _ref$titleTag === undefined ? 'h4' : _ref$titleTag;

    var TitleTag = titleTag;

    return _react2.default.createElement(
        'div',
        { className: 'final-cta-card-section' },
        _react2.default.createElement(
            'div',
            { className: 'container' },
            _react2.default.createElement(
                'div',
                { className: 'cta-card' },
                _react2.default.createElement(
                    'div',
                    { className: 'cta-content' },
                    _react2.default.createElement(
                        'div',
                        { className: 'cta-text' },
                        _react2.default.createElement(
                            TitleTag,
                            { className: 'cta-title' },
                            title || 'Peça uma demonstração e fale com um de nossos especialistas pelo Whatsapp'
                        ),
                        _react2.default.createElement(
                            'p',
                            null,
                            description || 'Ainda com dúvidas? Clique abaixo, cadastre seus dados e fale diretamente com nosso time de especialistas!'
                        )
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: 'cta-button' },
                        useWhatsAppStyle ? _react2.default.createElement(_DemoForm2.default, {
                            newForm: false,
                            trialButtonOnly: true,
                            modalButtonText: _react2.default.createElement(
                                _react.Fragment,
                                null,
                                _react2.default.createElement(_Picture2.default, { src: '/images/site/whatsapp.png', alt: '\xCDcone do Whatsapp' }),
                                'Falar com especialista'
                            ),
                            className: 'whatsapp-styled-demo'
                        }) : useMinimalStyle ? _react2.default.createElement(_DemoForm2.default, {
                            minimalStyle: true,
                            trialAndDemo: trialAndDemo || 'comece grátis',
                            showForm: true,
                            submitButtonText: submitButtonText || 'Solicitar demonstração',
                            modalButtonText: modalButtonText || 'Peça uma demonstração',
                            showTrialLink: false,
                            className: 'final-cta-form'
                        }) : useB2BForm ? _react2.default.createElement(
                            _react.Fragment,
                            null,
                            _react2.default.createElement(_DemoFormB2B2.default, {
                                trialAndDemo: trialAndDemo || 'comece grátis',
                                showForm: true,
                                submitButtonText: submitButtonText || 'Solicitar demonstração',
                                modalButtonText: modalButtonText || 'Peça uma demonstração',
                                showTrialLink: false
                            }),
                            showTrialInfo && _react2.default.createElement(
                                'p',
                                { className: 'cta-trial-info' },
                                'Teste gr\xE1tis por 7 dias | Sem cobran\xE7a autom\xE1tica'
                            )
                        ) : _react2.default.createElement(_DemoForm2.default, {
                            buttonVariant: buttonVariant || 'inverted-white',
                            textAlign: 'center'
                        })
                    )
                )
            )
        )
    );
};

exports.default = FinalCTACard;

/***/ }),

/***/ 570:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 580:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

var _Picture = __webpack_require__(531);

var _Picture2 = _interopRequireDefault(_Picture);

__webpack_require__(582);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var LazyYouTube = function LazyYouTube(_ref) {
    var videoId = _ref.videoId,
        coverImage = _ref.coverImage,
        title = _ref.title,
        _ref$width = _ref.width,
        width = _ref$width === undefined ? 300 : _ref$width,
        _ref$height = _ref.height,
        height = _ref$height === undefined ? 550 : _ref$height,
        _ref$playerParams = _ref.playerParams,
        playerParams = _ref$playerParams === undefined ? '' : _ref$playerParams,
        _ref$useNoCookie = _ref.useNoCookie,
        useNoCookie = _ref$useNoCookie === undefined ? false : _ref$useNoCookie;

    var _useState = (0, _react.useState)(false),
        _useState2 = _slicedToArray(_useState, 2),
        isLoaded = _useState2[0],
        setIsLoaded = _useState2[1];

    var embedBaseUrl = useNoCookie ? 'https://www.youtube.com/embed/' : 'https://www.youtube.com/embed/';
    var embedParams = ['autoplay=1', playerParams].filter(Boolean).join('&');

    var handleClick = function handleClick() {
        setIsLoaded(true);
        if (typeof window !== 'undefined' && window.dataLayer) {
            window.dataLayer.push({
                event: 'video_play',
                videoId: videoId,
                videoTitle: title || 'YouTube video player',
                videoUrl: '' + embedBaseUrl + videoId
            });
        }
    };

    if (isLoaded) {
        return _react2.default.createElement(
            'div',
            { className: 'lazy-youtube-frame', style: { aspectRatio: width + ' / ' + height } },
            _react2.default.createElement('iframe', {
                className: 'lazy-youtube-embed',
                width: width,
                height: height,
                src: '' + embedBaseUrl + videoId + '?' + embedParams,
                title: title || "YouTube video player",
                frameBorder: '0',
                allow: 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share',
                referrerPolicy: 'strict-origin-when-cross-origin',
                allowFullScreen: true
            })
        );
    }

    return _react2.default.createElement(
        'div',
        { className: 'lazy-youtube-frame', style: { aspectRatio: width + ' / ' + height } },
        _react2.default.createElement(
            'button',
            { className: 'lazy-youtube', onClick: handleClick, 'aria-label': 'Play video: ' + title },
            _react2.default.createElement(_Picture2.default, {
                src: coverImage,
                alt: title || "Video thumbnail",
                className: 'lazy-youtube-cover'
            })
        )
    );
};

exports.default = LazyYouTube;

/***/ }),

/***/ 582:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 583:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(530);

var _classnames2 = _interopRequireDefault(_classnames);

__webpack_require__(534);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Heading2 = function Heading2(_ref) {
    var children = _ref.children,
        white = _ref.white,
        purple = _ref.purple,
        center = _ref.center,
        bottomSpace = _ref.bottomSpace,
        className = _ref.className;
    return _react2.default.createElement(
        'h2',
        { className: (0, _classnames2.default)('heading2', className, white ? 'heading-white' : '', purple ? 'heading-purple' : '', center ? 'text-center' : '', bottomSpace ? 'bottom-space' : '') },
        children
    );
};

exports.default = Heading2;

/***/ }),

/***/ 593:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 594:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

var _LazyYouTube = __webpack_require__(580);

var _LazyYouTube2 = _interopRequireDefault(_LazyYouTube);

var _Picture = __webpack_require__(531);

var _Picture2 = _interopRequireDefault(_Picture);

__webpack_require__(595);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var aiTestimonialsData = [{
    testimonial: _react2.default.createElement(
        _react.Fragment,
        null,
        '"Acabei seguindo o mesmo processo que usava ao adicionar por planilha, porque \xE9 mais c\xF4modo. O mais incr\xEDvel \xE9 que a ferramenta permite alterar a quantidade de uma refer\xEAncia, caso esteja errada, j\xE1 no momento da importa\xE7\xE3o, sem precisar ficar ajustando a planilha v\xE1rias vezes. ',
        _react2.default.createElement(
            'b',
            null,
            'Simplesmente perfeito!'
        ),
        '"'
    ),
    author: "Kaio Azevedo",
    company: "WKF Representações",
    stars: 5
}, {
    testimonial: _react2.default.createElement(
        _react.Fragment,
        null,
        '"Bem legal! Otimiza bastante o tempo para as empresas que recebem muitos pedidos pelo WhatsApp e perdem tempo criando tudo manualmente. Com a IA, \xE9 s\xF3 copiar e colar a mensagem e, se for necess\xE1rio, ajustar algum item. ',
        _react2.default.createElement(
            'b',
            null,
            '\xC9 r\xE1pido, simples e muito eficiente.'
        ),
        '"'
    ),
    author: "Eduardo Woiciechoski",
    company: "WB Distribuidora",
    stars: 5
}, {
    testimonial: _react2.default.createElement(
        _react.Fragment,
        null,
        '"',
        _react2.default.createElement(
            'b',
            null,
            'Tem sido bem \xFAtil mesmo!'
        ),
        ' O que mais notei de diferen\xE7a foi o tempo que tenho economizado. Antes eu ficava muito tempo fazendo pedidos que recebo por e-mail ou whatsapp manualmente, tendo que colocar n\xFAmero exato de cada produto, e agora com a IA isso ficou muito mais r\xE1pido.'
    ),
    author: "Bruno Barbosa",
    company: "Barbosa & Colombi",
    stars: 5
}];

var homeTestimonialsData = [{
    testimonial: _react2.default.createElement(
        _react.Fragment,
        null,
        'Faz\xEDamos v\xE1rias reuni\xF5es presenciais com grandes contas e precis\xE1vamos registrar rapidamente pedidos com muitos itens, em grandes quantidades. Lev\xE1vamos bastante tempo para concluir tudo. Hoje, com o Pedidos com IA, a emiss\xE3o ficou muito mais \xE1gil. O Mercos tem uma tecnologia que realmente facilita nosso dia a dia.'
    ),
    author: "Jéssica Araujo",
    company: "Océane",
    stars: 5,
    img: "jessica-araujo",
    imgAlt: "Jéssica Araujo, Océane"
}, {
    testimonial: _react2.default.createElement(
        _react.Fragment,
        null,
        'A facilidade do cliente fazer os pedidos conosco foi o principal ponto. Ficamos extremamente felizes em saber que nossos clientes, gostam, se adaptam bem e n\xE3o t\xEAm dificuldades. \xC9 tudo muito simples, interativo e f\xE1cil de usar. O sistema \xE9 muito completo e facilita muito a nossa vida!'
    ),
    author: "Alessandro Gonçalves",
    company: "Diretor Comercial da Mels Brushes",
    stars: 5,
    img: "alessandro-goncalves",
    imgAlt: "Alessandro Gonçalves, Diretor Comercial da Mels Brushes"
}, {
    testimonial: _react2.default.createElement(
        _react.Fragment,
        null,
        _react2.default.createElement(
            'b',
            null,
            'Aumento de 20% do faturamento com o e-commerce B2B'
        ),
        _react2.default.createElement('br', null),
        _react2.default.createElement('br', null),
        'Evolu\xEDmos na qualidade dos pedidos, desde a maneira que a gente entrega o pedido pras empresas como na maneira com que a gente gera os pedidos.'
    ),
    author: "Henrique Zompeiro",
    company: "Gerente Financeiro na CorsaBIke",
    stars: 5,
    img: "henrique-zompeiro",
    imgAlt: "Henrique Zompeiro, Gerente Financeiro na CorsaBike"
}];

var TestimonialVideoCards = function (_Component) {
    _inherits(TestimonialVideoCards, _Component);

    function TestimonialVideoCards(props) {
        _classCallCheck(this, TestimonialVideoCards);

        return _possibleConstructorReturn(this, (TestimonialVideoCards.__proto__ || Object.getPrototypeOf(TestimonialVideoCards)).call(this, props));
    }

    _createClass(TestimonialVideoCards, [{
        key: 'getTestimonials',
        value: function getTestimonials() {
            var testimonialList = {
                joseDavidCopelman: {
                    img: "jose-david-copelman",
                    imgAlt: "José David Copelman, Gestor Nacional de Vendas na CROWN",
                    title: "Crescimento de 12% em vendas em 2023",
                    testimonial: _react2.default.createElement(
                        _react.Fragment,
                        null,
                        'Antes do Mercos, eram 3 pessoas exclusivas para lan\xE7ar pedidos. Hoje com os dois sistemas integrados, ',
                        _react2.default.createElement(
                            'strong',
                            null,
                            'ganhamos controle e efici\xEAncia em nossa opera\xE7\xE3o'
                        ),
                        '.'
                    ),
                    author: "José David Copelman",
                    company: "Gestor Nacional de Vendas na CROWN"
                },
                leandroCampos: {
                    img: "leandro-campos",
                    imgAlt: "Leandro Campos, Gestor Comercial e Marketing na Tagima",
                    testimonial: _react2.default.createElement(
                        _react.Fragment,
                        null,
                        'Nossos clientes t\xEAm uma primeira experi\xEAncia positiva, pois o E-commerce B2B \xE9 t\xE3o intuitivo e f\xE1cil de usar quanto o For\xE7a de vendas. O principal ganho foi a velocidade na tratativa de pedidos. Agora, conseguimos processar mais notas por dia e, at\xE9 mesmo, integrar estoque.'
                    ),
                    author: "Leandro Campos",
                    company: "Gestor Comercial e Marketing na Tagima"
                },
                henriqueZompeiroOld: {
                    img: "henrique-zompeiro",
                    imgAlt: "Henrique Zompeiro, Gerente Financeiro na CorsaBike",
                    title: "Aumento de 20% do faturamento com o e-commerce B2B",
                    testimonial: _react2.default.createElement(
                        _react.Fragment,
                        null,
                        'Evolu\xEDmos na qualidade dos pedidos, desde a maneira que a gente entrega o pedido pras empresas como na maneira com que a gente gera os pedidos.'
                    ),
                    author: "Henrique Zompeiro",
                    company: "Gerente Financeiro na CorsaBike",
                    className: "desktop-only"
                },
                allanGomes: {
                    img: "allan-gomes",
                    imgAlt: "Allan Gomes, Sócio proprietário da La Ganexa",
                    title: "O Mercos economizou 2 dias de trabalho mensal que tínhamos antes",
                    testimonial: _react2.default.createElement(
                        _react.Fragment,
                        null,
                        'Al\xE9m de trazer economia de tempo e efici\xEAncia para o nosso processo, tamb\xE9m trouxe mais dinheiro para a La Ganexa.'
                    ),
                    author: "Allan Gomes",
                    company: "Sócio proprietário da La Ganexa"
                },
                felipeAlmeida: {
                    img: "felipe-almeida",
                    imgAlt: "Felipe Almeida, HPrime",
                    testimonial: _react2.default.createElement(
                        _react.Fragment,
                        null,
                        'Hoje, os vendedores est\xE3o muito mais focados na rela\xE7\xE3o com o cliente e em serem especialistas que ajudam na venda e no p\xF3s-venda do que em resolver as min\xFAcias burocr\xE1ticas de uma tabela, por exemplo'
                    ),
                    author: "Felipe Almeida",
                    company: "HPrime"
                },
                alexandreSantos: {
                    img: "alexandre-santos-delicia-lanches",
                    imgAlt: "Alexandre Santos, Delícia Lanches",
                    testimonial: _react2.default.createElement(
                        _react.Fragment,
                        null,
                        'Imagine a nossa felicidade em ganhar produtividade, se adaptar ao mercado e \xE0s tend\xEAncias. N\xE3o tem jeito, quem n\xE3o faz isso perde grandes oportunidades.'
                    ),
                    author: "Alexandre Santos",
                    company: "Delícia Lanches",
                    className: "desktop-only"
                },
                francielMartins: {
                    img: "franciel-martins",
                    imgAlt: "Franciel Martins",
                    testimonial: _react2.default.createElement(
                        _react.Fragment,
                        null,
                        'O Mercos transformou completamente nossa opera\xE7\xE3o de vendas. A facilidade de uso e a integra\xE7\xE3o com nossos sistemas existentes nos permitiu aumentar significativamente nossa produtividade.'
                    ),
                    author: "Franciel Martins",
                    company: "Empresa Demo"
                },
                francielMartins2: {
                    img: "franciel",
                    imgAlt: "Franciel Martins, ZT Representações",
                    testimonial: _react2.default.createElement(
                        _react.Fragment,
                        null,
                        'O Mercos pra gente foi um divisor de \xE1guas na quest\xE3o da opera\xE7\xE3o. Evolu\xEDmos na qualidade dos pedidos, desde a maneira que a gente entrega o pedido pras empresas como na maneira com que a gente gera e monta os pedidos.'
                    ),
                    author: "Franciel Martins",
                    company: "ZT Representações"
                },
                joaoDePauloOliveira: {
                    img: "joao-paulo-oliveira",
                    imgAlt: "João de Paulo Oliveira, Gao Cosméticos",
                    testimonial: _react2.default.createElement(
                        _react.Fragment,
                        null,
                        'Eu pesquisei solu\xE7\xF5es de mercado e decidi contratar Mercos porque a ferramenta al\xE9m de ser f\xE1cil de usar, me oferece tr\xEAs recursos que meu neg\xF3cio precisa: e-commerce B2B, for\xE7a de vendas e indicadores gerenciais'
                    ),
                    author: "João de Paulo Oliveira",
                    company: "Gao Cosméticos"
                }
            };

            // Return testimonials based on props
            if (this.props.tpPage) {
                return [testimonialList.francielMartins2, testimonialList.felipeAlmeida, testimonialList.joaoDePauloOliveira];
            }

            return [testimonialList.leandroCampos, testimonialList.felipeAlmeida, testimonialList.alexandreSantos];
        }
    }, {
        key: 'defaultTestimonials',
        value: function defaultTestimonials() {
            var _props = this.props,
                isAI = _props.isAI,
                isHome = _props.isHome,
                sectionTitle = _props.title,
                descriptionH4 = _props.descriptionH4,
                isAIPage = _props.isAIPage,
                noVideo = _props.noVideo,
                tpPage = _props.tpPage,
                customTestimonialsProp = _props.customTestimonials,
                isDistributor = _props.isDistributor;
            // Prefer explicit customTestimonials passed via props (page-specific overrides)

            var baseTestimonials = isAI ? aiTestimonialsData : isHome ? homeTestimonialsData : [];
            var customTestimonials = Array.isArray(customTestimonialsProp) && customTestimonialsProp.length > 0 ? customTestimonialsProp : tpPage ? this.getTestimonials() : [];
            var testimonialsToRender = customTestimonials.length > 0 ? customTestimonials : baseTestimonials;

            var TitleComponent = isAIPage ? 'h3' : 'h3';
            var containerClass = isDistributor ? 'static-testimonials static-testimonials-distributor' : 'static-testimonials static-testimonials-b2b';

            return _react2.default.createElement(
                'div',
                { className: containerClass },
                _react2.default.createElement(
                    'div',
                    { className: 'testimonials-title ' + (sectionTitle ? 'testimonials-title-picture-second-title' : '') },
                    _react2.default.createElement(
                        'div',
                        { className: 'testimonials-title-slider-btns' },
                        sectionTitle ? _react2.default.createElement(
                            TitleComponent,
                            { className: 'title' },
                            sectionTitle
                        ) : ''
                    )
                ),
                !noVideo && _react2.default.createElement(
                    'div',
                    { className: 'testimonials-videos' },
                    _react2.default.createElement(
                        'div',
                        { className: 'container' },
                        isAIPage ? _react2.default.createElement(
                            _react.Fragment,
                            null,
                            _react2.default.createElement(
                                'div',
                                { className: 'video' },
                                _react2.default.createElement('iframe', { loading: 'lazy', width: '300', height: '550', src: 'https://www.youtube.com/embed/hg8RE2ebBKw', title: 'YouTube video player', frameBorder: '0', allow: 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share', referrerPolicy: 'strict-origin-when-cross-origin', allowFullScreen: true })
                            ),
                            _react2.default.createElement(
                                'div',
                                { className: 'video desktop' },
                                _react2.default.createElement('iframe', { loading: 'lazy', width: '300', height: '550', src: 'https://www.youtube.com/embed/GbkxUaWZYJw', title: 'YouTube video player', frameBorder: '0', allow: 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share', referrerPolicy: 'strict-origin-when-cross-origin', allowFullScreen: true })
                            ),
                            _react2.default.createElement(
                                'div',
                                { className: 'video' },
                                _react2.default.createElement('iframe', { loading: 'lazy', width: '300', height: '550', src: 'https://www.youtube.com/embed/oBLU1_LOL3A', title: 'YouTube video player', frameBorder: '0', allow: 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share', referrerPolicy: 'strict-origin-when-cross-origin', allowFullScreen: true })
                            )
                        ) : isAI ? _react2.default.createElement(
                            _react.Fragment,
                            null,
                            _react2.default.createElement(
                                'div',
                                { className: 'video' },
                                _react2.default.createElement('iframe', { loading: 'lazy', width: '300', height: '550', src: 'https://www.youtube.com/embed/hg8RE2ebBKw', title: 'YouTube video player', frameBorder: '0', allow: 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share', referrerPolicy: 'strict-origin-when-cross-origin', allowFullScreen: true })
                            ),
                            _react2.default.createElement(
                                'div',
                                { className: 'video desktop' },
                                _react2.default.createElement('iframe', { loading: 'lazy', width: '300', height: '550', src: 'https://www.youtube.com/embed/GbkxUaWZYJw', title: 'YouTube video player', frameBorder: '0', allow: 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share', referrerPolicy: 'strict-origin-when-cross-origin', allowFullScreen: true })
                            ),
                            _react2.default.createElement(
                                'div',
                                { className: 'video' },
                                _react2.default.createElement('iframe', { loading: 'lazy', width: '300', height: '550', src: 'https://www.youtube.com/embed/oBLU1_LOL3A', title: 'YouTube video player', frameBorder: '0', allow: 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share', referrerPolicy: 'strict-origin-when-cross-origin', allowFullScreen: true })
                            )
                        ) : isHome ? _react2.default.createElement(
                            _react.Fragment,
                            null,
                            _react2.default.createElement(
                                'div',
                                { className: 'video' },
                                _react2.default.createElement(_LazyYouTube2.default, { videoId: '6qEule4v-b8', coverImage: '/images/site/depoimentos/alessandro-vertical-video.png', title: 'Depoimento Alessandro' })
                            ),
                            _react2.default.createElement(
                                'div',
                                { className: 'video desktop' },
                                _react2.default.createElement(_LazyYouTube2.default, { videoId: 'kF5GQkz6J6w', coverImage: '/images/site/depoimentos/bruno-vertical-video.png', title: 'Depoimento Bruno' })
                            ),
                            _react2.default.createElement(
                                'div',
                                { className: 'video' },
                                _react2.default.createElement(_LazyYouTube2.default, { videoId: '9Z2o648HcBw', coverImage: '/images/site/depoimentos/rafael-vertical-video.png', title: 'Depoimento Rafael' })
                            )
                        ) : _react2.default.createElement(
                            _react.Fragment,
                            null,
                            _react2.default.createElement(
                                'div',
                                { className: 'video' },
                                _react2.default.createElement('iframe', { loading: 'lazy', width: '300', height: '550', src: 'https://www.youtube.com/embed/FHnSkFs8Xmg?si=Nuatrl8SzhFXIDbK&controls=0', title: 'YouTube video player', frameBorder: '0', allow: 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share', referrerPolicy: 'strict-origin-when-cross-origin', allowFullScreen: true })
                            ),
                            _react2.default.createElement(
                                'div',
                                { className: 'video desktop-only' },
                                _react2.default.createElement('iframe', { loading: 'lazy', width: '300', height: '550', src: 'https://www.youtube.com/embed/eFgUXUQdq2M?si=TaKxCao1DPTKKGXa&controls=0', title: 'YouTube video player', frameBorder: '0', allow: 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share', referrerPolicy: 'strict-origin-when-cross-origin', allowFullScreen: true })
                            ),
                            _react2.default.createElement(
                                'div',
                                { className: 'video' },
                                _react2.default.createElement('iframe', { loading: 'lazy', width: '300', height: '550', src: 'https://www.youtube.com/embed/6qEule4v-b8?si=6TnmqyVB8SGDlz-t&controls=0', title: 'YouTube video player', frameBorder: '0', allow: 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share', referrerPolicy: 'strict-origin-when-cross-origin', allowFullScreen: true })
                            )
                        )
                    )
                ),
                testimonialsToRender && testimonialsToRender.length > 0 ? _react2.default.createElement(
                    'div',
                    { className: 'testimonial-cards-container' },
                    testimonialsToRender.map(function (testimonial, index) {
                        return _react2.default.createElement(
                            'div',
                            { key: index, className: 'testimonial-card ' + (testimonial.className || '') },
                            _react2.default.createElement(
                                'div',
                                { className: 'testimonial-card-head' },
                                testimonial.categoryIcon ? _react2.default.createElement(
                                    'div',
                                    { className: 'testimonial-category-badge' },
                                    _react2.default.createElement(
                                        'div',
                                        { className: 'category-icon' },
                                        _react2.default.createElement(_Picture2.default, { src: testimonial.categoryIcon, alt: '' })
                                    ),
                                    _react2.default.createElement(
                                        'span',
                                        { className: 'testimonial-category-text' },
                                        testimonial.categoryText
                                    )
                                ) : _react2.default.createElement(
                                    'span',
                                    { className: 'testimonial-card-stars' },
                                    '★'.repeat(testimonial.stars || 5)
                                )
                            ),
                            testimonial.title && _react2.default.createElement(
                                'p',
                                { className: 'testimonial-card-title' },
                                testimonial.title
                            ),
                            _react2.default.createElement(
                                'p',
                                { className: 'testimonial-card-paragraph' },
                                testimonial.testimonial
                            ),
                            _react2.default.createElement(
                                'div',
                                { className: 'testimonial-card-header' },
                                _react2.default.createElement(
                                    'div',
                                    { className: 'testimonial-card-author-company' },
                                    testimonial.img && _react2.default.createElement(_Picture2.default, { className: 'profile-image', alt: testimonial.imgAlt, width: '50', src: '/images/site/depoimentos/' + testimonial.img + '.png' }),
                                    _react2.default.createElement(
                                        'div',
                                        { className: 'testimonial-author-wrapper' },
                                        _react2.default.createElement(
                                            'p',
                                            { className: 'testimonial-card-author' },
                                            testimonial.author
                                        ),
                                        _react2.default.createElement(
                                            'p',
                                            { className: 'testimonial-card-company' },
                                            testimonial.company
                                        )
                                    )
                                )
                            )
                        );
                    })
                ) : null
            );
        }
    }, {
        key: 'repsTestimonials',
        value: function repsTestimonials() {
            return _react2.default.createElement(
                'div',
                { className: 'static-testimonials' },
                'Reps Testimonials (Not Implemented with AI prop yet)'
            );
        }
    }, {
        key: 'blacknovTestimonials',
        value: function blacknovTestimonials() {
            return _react2.default.createElement(
                'div',
                { className: 'static-testimonials' },
                'Black November Testimonials (Not Implemented with AI prop yet)'
            );
        }
    }, {
        key: 'render',
        value: function render() {
            return _react2.default.createElement(
                _react.Fragment,
                null,
                this.props.reps ? this.repsTestimonials() : this.props.blackNovember ? this.blacknovTestimonials() : this.defaultTestimonials()
            );
        }
    }]);

    return TestimonialVideoCards;
}(_react.Component);

exports.default = TestimonialVideoCards;

/***/ }),

/***/ 595:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 604:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(9);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(530);

var _classnames2 = _interopRequireDefault(_classnames);

var _Picture = __webpack_require__(531);

var _Picture2 = _interopRequireDefault(_Picture);

var _Paragraph = __webpack_require__(543);

var _Paragraph2 = _interopRequireDefault(_Paragraph);

__webpack_require__(629);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SimpleAccordionItem = function SimpleAccordionItem(_ref) {
    var children = _ref.children,
        classes = _ref.classes,
        expand = _ref.expand,
        icon = _ref.icon,
        onClick = _ref.onClick,
        opened = _ref.opened,
        title = _ref.title,
        headerTag = _ref.headerTag;

    var HeaderTag = headerTag || 'span';

    return _react2.default.createElement(
        'div',
        { className: (0, _classnames2.default)('simple-accordion-item', icon && 'hasIcon', opened && 'opened') },
        _react2.default.createElement(
            'div',
            { className: 'simple-accordion-item-title-block', onClick: onClick },
            icon && _react2.default.createElement(
                'div',
                { className: 'icon-container' },
                _react2.default.createElement(_Picture2.default, { src: icon, alt: title, width: 45, height: 45 })
            ),
            _react2.default.createElement(
                'div',
                { className: 'border-accordion' },
                _react2.default.createElement(
                    HeaderTag,
                    { className: (0, _classnames2.default)('always-left', opened && classes && classes.titleOpened, classes && classes.title) },
                    title
                ),
                _react2.default.createElement(
                    'div',
                    { className: (0, _classnames2.default)('accordion-see-more', expand) },
                    !opened && expand === 'text' ? _react2.default.createElement(
                        _Paragraph2.default,
                        { gray: true },
                        'Ver mais'
                    ) : _react2.default.createElement('div', { className: 'arrow-container' })
                )
            )
        ),
        _react2.default.createElement(
            'div',
            { className: (0, _classnames2.default)('accordion-content', opened ? 'accordion-item-opened' : '') },
            children
        )
    );
};

SimpleAccordionItem.defaultProps = {
    classes: {
        titleOpened: 'accordion-title-selected'
    }
};

SimpleAccordionItem.propTypes = {
    children: _propTypes2.default.node,
    classes: _propTypes2.default.object,
    expand: _propTypes2.default.string,
    headerTag: _propTypes2.default.string,
    icon: _propTypes2.default.string,
    opened: _propTypes2.default.bool,
    title: _propTypes2.default.string
};

exports.default = SimpleAccordionItem;

/***/ }),

/***/ 614:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 627:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(9);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(530);

var _classnames2 = _interopRequireDefault(_classnames);

var _SimpleAccordionItem = __webpack_require__(604);

var _SimpleAccordionItem2 = _interopRequireDefault(_SimpleAccordionItem);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var SimpleAccordionContainer = function (_Component) {
    _inherits(SimpleAccordionContainer, _Component);

    function SimpleAccordionContainer(props) {
        _classCallCheck(this, SimpleAccordionContainer);

        var _this = _possibleConstructorReturn(this, (SimpleAccordionContainer.__proto__ || Object.getPrototypeOf(SimpleAccordionContainer)).call(this, props));

        _this.isIndexInList = _this.isIndexInList.bind(_this);
        _this.toggleItem = _this.toggleItem.bind(_this);

        _this.state = {
            openedItems: _this.props.defaultClosed ? [] : [0]
        };
        return _this;
    }

    _createClass(SimpleAccordionContainer, [{
        key: 'toggleItem',
        value: function toggleItem(index, propsFunction) {
            var openedItems = this.state.openedItems;

            if (this.props.collapsable) {
                if (!this.isIndexInList(index)) {
                    this.setState({
                        openedItems: [index]
                    });
                } else {
                    this.setState({
                        openedItems: []
                    });
                }
            } else {
                if (this.isIndexInList(index)) {
                    this.setState({
                        openedItems: openedItems.filter(function (value) {
                            return value != index;
                        })
                    });
                } else {
                    openedItems.push(index);
                    this.setState({
                        openedItems: openedItems
                    });
                }
            }

            propsFunction && propsFunction();
        }
    }, {
        key: 'isIndexInList',
        value: function isIndexInList(index) {
            return this.state.openedItems.includes(index);
        }
    }, {
        key: 'render',
        value: function render() {
            var isIndexInList = this.isIndexInList,
                toggleItem = this.toggleItem,
                expand = this.props.expand,
                openedItems = this.state.openedItems;


            return _react2.default.createElement(
                'div',
                { className: (0, _classnames2.default)('accordion-container', expand) },
                _react2.default.Children.map(this.props.children, function (child, index) {
                    return _react2.default.cloneElement(child, { expand: expand, onClick: function onClick() {
                            return toggleItem(index, child.props.onClick);
                        }, opened: isIndexInList(index), key: 'accordion-clone-item-' + index });
                })
            );
        }
    }]);

    return SimpleAccordionContainer;
}(_react.Component);

SimpleAccordionContainer.defaultProps = {
    expand: 'text'
};

SimpleAccordionContainer.propTypes = {
    children: _propTypes2.default.arrayOf(_SimpleAccordionItem2.default),
    expand: _propTypes2.default.string
};

exports.default = SimpleAccordionContainer;

/***/ }),

/***/ 629:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 640:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

__webpack_require__(641);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DEFAULT_STATS = [{
  value: "R$ 100 bilhões",
  label: _react2.default.createElement(
    _react.Fragment,
    null,
    "anuais movimentados",
    _react2.default.createElement("br", null),
    "atrav\xE9s do Mercos"
  )
}, {
  value: "18.000.000",
  label: _react2.default.createElement(
    _react.Fragment,
    null,
    "de pedidos realizados por",
    _react2.default.createElement("br", null),
    "ano na plataforma"
  )
}, {
  value: "+250",
  label: _react2.default.createElement(
    _react.Fragment,
    null,
    "ERPs",
    _react2.default.createElement("br", null),
    "integrados"
  )
}, {
  value: "56.000",
  label: _react2.default.createElement(
    _react.Fragment,
    null,
    "usu\xE1rios",
    _react2.default.createElement("br", null),
    "ativos"
  )
}, {
  value: "+9.000",
  label: "clientes"
}];

var StatsStripV6 = function StatsStripV6(_ref) {
  var _ref$items = _ref.items,
      items = _ref$items === undefined ? DEFAULT_STATS : _ref$items,
      _ref$className = _ref.className,
      className = _ref$className === undefined ? "" : _ref$className;
  return _react2.default.createElement(
    "div",
    { className: ("stats-strip stats-strip-v6-preview " + className).trim() },
    items.map(function (item, index) {
      return _react2.default.createElement(
        "div",
        { className: "stats-strip-v6-preview__item", key: item.value + "-" + index },
        _react2.default.createElement(
          "p",
          { className: "stats-strip-v6-preview__value" },
          item.value
        ),
        _react2.default.createElement(
          "p",
          { className: "stats-strip-v6-preview__label" },
          item.label
        )
      );
    })
  );
};

exports.default = StatsStripV6;

/***/ }),

/***/ 641:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 642:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

var _Picture = __webpack_require__(531);

var _Picture2 = _interopRequireDefault(_Picture);

__webpack_require__(593);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ClientLogosSlider = function ClientLogosSlider(_ref) {
  var _ref$className = _ref.className,
      className = _ref$className === undefined ? '' : _ref$className,
      _ref$hideHeader = _ref.hideHeader,
      hideHeader = _ref$hideHeader === undefined ? false : _ref$hideHeader;

  var _useState = (0, _react.useState)(false),
      _useState2 = _slicedToArray(_useState, 2),
      shouldLoadLogos = _useState2[0],
      setShouldLoadLogos = _useState2[1];

  var logos = [{
    src: '/images/site/customers/alva-horizontal.png',
    alt: 'Alva',
    webp: '/images/site/customers/alva-horizontal.webp'
  }, {
    src: '/images/site/customers/anasol-horizontal.png',
    alt: 'Anasol',
    webp: '/images/site/customers/anasol-horizontal.webp'
  }, {
    src: '/images/site/customers/baggio-horizontal.png',
    alt: 'Baggio',
    webp: '/images/site/customers/baggio-horizontal.webp'
  }, {
    src: '/images/site/customers/berwanger-horizontal.png',
    alt: 'Berwanger',
    webp: '/images/site/customers/berwanger-horizontal.webp'
  }, {
    src: '/images/site/customers/buffalo-horizontal.png',
    alt: 'Buffalo',
    webp: '/images/site/customers/buffalo-horizontal.webp'
  }, {
    src: '/images/site/customers/cicero-horizontal.png',
    alt: 'Cicero',
    webp: '/images/site/customers/cicero-horizontal.webp'
  }, {
    src: '/images/site/customers/dobro-horizontal.png',
    alt: 'Dobro',
    webp: '/images/site/customers/dobro-horizontal.webp'
  }, {
    src: '/images/site/customers/gelopar-horizontal.png',
    alt: 'Gelopar',
    webp: '/images/site/customers/gelopar-horizontal.webp'
  }, {
    src: '/images/site/customers/herbia-horizontal.png',
    alt: 'Herbia',
    webp: '/images/site/customers/herbia-horizontal.webp'
  }, {
    src: '/images/site/customers/hey-mu-horizontal.png',
    alt: 'Hey Mu',
    webp: '/images/site/customers/hey-mu-horizontal.webp'
  }, {
    src: '/images/site/customers/hprime-horizontal.png',
    alt: 'HPrime',
    webp: '/images/site/customers/hprime-horizontal.webp'
  }, {
    src: '/images/site/customers/keune-horizontal.png',
    alt: 'Keune',
    webp: '/images/site/customers/keune-horizontal.webp'
  }, {
    src: '/images/site/customers/la-ganexa-horizontal.png',
    alt: 'La Ganexa',
    webp: '/images/site/customers/la-ganexa-horizontal.webp'
  }, {
    src: '/images/site/customers/labotrat-horizontal.png',
    alt: 'Labotrat',
    webp: '/images/site/customers/labotrat-horizontal.webp'
  }, {
    src: '/images/site/customers/maped-horizontal.png',
    alt: 'Maped',
    webp: '/images/site/customers/maped-horizontal.webp'
  }, {
    src: '/images/site/customers/mbled-horizontal.png',
    alt: 'MBled',
    webp: '/images/site/customers/mbled-horizontal.webp'
  }, {
    src: '/images/site/customers/mili-horizontal.png',
    alt: 'Mili',
    webp: '/images/site/customers/mili-horizontal.webp'
  }, {
    src: '/images/site/customers/oakberry-horizontal.png',
    alt: 'Oakberry',
    webp: '/images/site/customers/oakberry-horizontal.webp'
  }, {
    src: '/images/site/customers/tagima-horizontal.png',
    alt: 'Tagima',
    webp: '/images/site/customers/tagima-horizontal.webp'
  }];

  (0, _react.useEffect)(function () {
    var timeoutId = window.setTimeout(function () {
      return setShouldLoadLogos(true);
    }, 0);

    return function () {
      return window.clearTimeout(timeoutId);
    };
  }, []);

  var renderLogo = function renderLogo(logo, key) {
    return _react2.default.createElement(
      'div',
      { key: key, className: 'logo-item' },
      _react2.default.createElement(_Picture2.default, {
        src: logo.src,
        alt: logo.alt,
        mobileSrc: logo.webp,
        className: 'logo-image',
        loading: 'lazy',
        decoding: 'async'
      })
    );
  };

  return _react2.default.createElement(
    'div',
    { className: 'client-logos-slider-wrapper ' + className },
    !hideHeader && _react2.default.createElement(
      'p',
      { className: 'slider-header' },
      _react2.default.createElement(
        'b',
        null,
        '+ 9.000'
      ),
      ' empresas confiam na Mercos'
    ),
    _react2.default.createElement(
      'div',
      { className: 'client-logos-slider' },
      _react2.default.createElement(
        'div',
        { className: 'slider-track' },
        shouldLoadLogos && logos.map(function (logo, index) {
          return renderLogo(logo, 'logo-' + index);
        }),
        shouldLoadLogos && logos.map(function (logo, index) {
          return renderLogo(logo, 'logo-duplicate-' + index);
        })
      )
    )
  );
};

exports.default = ClientLogosSlider;

/***/ }),

/***/ 681:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

var _Picture = __webpack_require__(531);

var _Picture2 = _interopRequireDefault(_Picture);

var _AppRatings = __webpack_require__(682);

var _AppRatings2 = _interopRequireDefault(_AppRatings);

__webpack_require__(684);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TABS = [{
  id: 'mercos-ia',
  label: 'Mercos IA',
  icon: '/images/site/icons/ai.svg',
  iconInvert: true,
  overtitle: 'Mercos IA',
  title: 'IA na palma da mão para uma operação mais rápida e inteligente',
  descriptions: [_react2.default.createElement(
    _react.Fragment,
    null,
    'Com o Mercos IA, a intelig\xEAncia artificial trabalha junto com a gest\xE3o e a equipe comercial, ',
    _react2.default.createElement(
      'strong',
      null,
      'no sistema, no aplicativo e pelo WhatsApp'
    ),
    '. Transforme conversas, imagens, PDFs, \xE1udios ou planilhas em pedidos em segundos, reduzindo tarefas manuais e erros operacionais.'
  ), 'Além disso, faça perguntas sobre clientes, vendas e indicadores, gere relatórios personalizados, receba resumos inteligentes de negociações e acompanhe a operação comercial em tempo real.'],
  saibaMaisHref: '/recursos/mercos-ia/',
  image: { src: '/images/site/new-home/v6/tab-mercos-ia.png', alt: 'Conversa no WhatsApp com o Mercos IA, que também atua como assistente de vendas do vendedor, mostrando a criação automática de um orçamento a partir do envio de um arquivo PDF com a lista de pedidos, com link direto para o pedido gerado na plataforma Mercos.' },
  testimonial: {
    quote: _react2.default.createElement(
      _react.Fragment,
      null,
      '\u201CO Mercos IA trouxe mais agilidade para nossa opera\xE7\xE3o comercial. Um pedido que antes demorava cerca de 30 minutos para ser lan\xE7ado agora leva ',
      _react2.default.createElement(
        'strong',
        null,
        '5 minutos'
      ),
      '. Reduzimos em ',
      _react2.default.createElement(
        'strong',
        null,
        'quase 90%'
      ),
      ' o tempo desse processo e ganhamos muito mais produtividade, al\xE9m de consultarmos informa\xE7\xF5es de clientes, pedidos e resultados de forma simples, com uma IA que entende nossa rotina e est\xE1 integrada ao sistema.\u201D'
    ),
    author: 'Thiago Bazzo',
    company: 'Pupee Brinquedos',
    avatar: null
  }
}, {
  id: 'forca-de-vendas',
  label: 'Força de Vendas',
  icon: '/images/site/icons/graph.svg',
  overtitle: 'Força de vendas',
  title: 'Venda com agilidade e automatize o controle da rotina comercial',
  descriptions: [_react2.default.createElement(
    _react.Fragment,
    null,
    'O for\xE7a de vendas Mercos re\xFAne tudo o que sua equipe comercial precisa para vender com efici\xEAncia. A partir dele, conecte CRM, e-commerce B2B, Mercos Pay e integra\xE7\xF5es para ',
    _react2.default.createElement(
      'strong',
      null,
      'centralizar a opera\xE7\xE3o comercial em uma \xFAnica plataforma'
    ),
    '.'
  ), 'Emita pedidos, automatize processos, gerencie estoque, produtos e clientes, acompanhe equipes e use IA para agilizar a rotina. Além disso, acesse mais de 25 relatórios ou crie indicadores personalizados com IA.'],
  saibaMaisHref: '/forca-vendas/',
  image: { src: '/images/site/new-home/v6/tab-forca-de-vendas.png', alt: 'Dashboard da força de vendas do Mercos com criação de pedidos com IA, carteira de clientes, resumo de resultados e indicadores comerciais que automatizam a rotina e aumentam a produtividade da equipe.' },
  testimonial: {
    quote: '"Evoluímos muito a qualidade dos pedidos, desde a emissão até a entrega. Além disso, integramos o Mercos ao nosso ERP e automatizamos nosso fluxo operacional"',
    author: 'Henrique Zompeiro',
    company: 'Gerente Financeiro na Corsa Bike',
    avatar: '/images/site/depoimentos/henrique-zompeiro-corsa-bike.png'
  }
}, {
  id: 'crm',
  label: 'CRM',
  icon: '/images/site/icons/funnel-dark.svg',
  overtitle: 'CRM',
  title: 'Conecte relacionamentos e vendas com um CRM que atua do primeiro pedido ao pós-venda',
  descriptions: ['O CRM de Vendas Mercos vai além do tradicional: organiza lembretes, atividades, cadências de contato e alertas de oportunidades em um funil de vendas prático e eficiente, enquanto atua dentro da negociação.', 'Ele reúne históricos, sugere próximos passos, aplica automaticamente condições comerciais e registra cada interação, garantindo mais agilidade, organização e controle.'],
  saibaMaisHref: '/crm-de-vendas',
  image: { src: '/images/site/new-home/v6/tab-crm.png', alt: 'Funil de vendas do CRM Mercos com etapas Prospecção, Contato, Qualificação, Demostração e Negociação. Exemplo mostra oportunidades como SolarMais (R$ 18.490,00), MaxFrota (R$ 18.340,00) e MaxSocial (R$ 15.000,00), com lembretes, atividades, cadências de contato e alertas de oportunidades organizados automaticamente para maior agilidade e controle na negociação comercial.' },
  testimonial: {
    quote: '"O Mercos transformou o nosso processo comercial. Conseguimos ver quais clientes estão próximos de recomprar, quais estão inativos e onde precisamos expandir, permitindo que o time foque no relacionamento e no crescimento".',
    author: 'Marcos Rogério Scalabrin',
    company: 'Arte Cacau',
    avatar: '/images/site/depoimentos/marcos-rogerio-scalabrin-arte-cacau.png'
  }
}, {
  id: 'ecommerce-b2b',
  label: 'E-commerce B2B',
  icon: '/images/site/icons/cart.svg',
  overtitle: 'E-commerce B2B',
  title: 'Mais produtividade e flexibilidade: um canal de vendas online para pedidos a qualquer hora',
  descriptions: ['O e-commerce B2B é uma loja virtual onde os clientes fazem pedidos online com autonomia, dentro das políticas comerciais da empresa. Ele reduz a dependência do vendedor para pedidos recorrentes e gera demanda mesmo fora do horário comercial.', 'Na prática, isso diminui o retrabalho da equipe, amplia oportunidades e oferece um canal de vendas que funciona 24 horas por dia para novos e antigos compradores.'],
  saibaMaisHref: '/e-commerce-b2b/',
  image: { src: '/images/site/new-home/v6/tab-ecommerce-b2b.png', alt: 'E-commerce B2B Mercos com personalização de cores, promoções, destaques e produtos como arroz, açúcar e óleo, com clientes solicitando acesso, oferecendo mais produtividade, flexibilidade e vendas online 24 horas.' },
  testimonial: {
    quote: '"Com o e-commerce B2B, os vendedores focam muito mais na relação com o cliente, em serem os especialistas que ajudam na venda e no pós-venda, do que em resolver as minúcias burocráticas de uma tabela, por exemplo."',
    author: 'Felipe Almeida',
    company: 'HPrime',
    avatar: '/images/site/depoimentos/felipe-almeida-hprime.png'
  }
}, {
  id: 'aplicativo',
  label: 'Aplicativo',
  icon: '/images/site/icons/smartphone.svg',
  overtitle: 'Aplicativo',
  title: 'O núcleo de vendas do representante: leve seu escritório no bolso e emita pedidos',
  descriptions: ['O aplicativo de vendas é o maior aliado da equipe. É nele que os pedidos são emitidos, mesmo offline, com a ajuda da Inteligência Artificial.', 'Tudo isso com regras comerciais aplicadas automaticamente, enquanto o representante acompanha cada negociação pela tela, sem papel, planilhas ou retrabalhos. Ideal para vendas, práticas, ágeis e com prioridades claras.'],
  saibaMaisHref: '/recursos/aplicativo-vendas-externas/',
  image: { src: '/images/site/new-home/v6/tab-aplicativo.png', alt: 'Aplicativo Mercos para representantes de indústrias e distribuidoras com lista de pedidos (em orçamento, concluídos e faturados), regras comerciais automáticas e emissão de pedidos com ou sem internet, levando o escritório de vendas no bolso.' },
  testimonial: {
    quote: '"Com o Mercos, deixei de ser um representante para ser uma empresa de representação estruturada. Passamos mais profissionalismo aos olhos dos clientes! Centralizamos os pedidos e, com isso, acessamos dados como o tempo desde a última compra, o estoque disponível e os produtos mais vendidos."',
    author: 'Bruno Barbosa',
    company: 'Barbosa & Colombi Representações',
    avatar: '/images/site/depoimentos/bruno-barbosa-colombi.png'
  }
}, {
  id: 'mercos-pay',
  label: 'Mercos Pay',
  icon: '/images/site/icons/card.svg',
  overtitle: 'Mercos Pay',
  title: 'Receba o pagamento dos pedidos direto pelo Mercos com praticidade e segurança',
  descriptions: ['O Mercos Pay é a solução financeira desenvolvida pela Mercos que permite que você receba pagamentos por cartão de crédito, boleto ou Pix.', 'Com ele, os clientes pagam no checkout do e-commerce B2B ou por um link de pagamento gerado pelo representante durante a venda, com cobranças únicas, parceladas, mistas ou até com mais de um cartão. E mais: além das tarifas atrativas, você só paga se receber.'],
  saibaMaisHref: '/mercos-pay/',
  image: { src: '/images/site/new-home/v6/tab-mercos-pay.png', alt: 'Mercos Pay: receba pagamentos de pedidos diretamente no Mercos com praticidade e segurança, aceitando cartão, boleto e Pix, com tarifas atrativas e checkout integrado ao e-commerce B2B.' },
  testimonial: {
    quote: '"Passamos a transacionar 95% do faturamento diretamente pelo sistema com o Mercos Pay, economizando 2 dias de trabalho por mês. Também reduzimos em 10x o tempo de emissão de notas e cobranças com a integração com nosso ERP."',
    author: 'Allan Gomes',
    company: 'La Ganexa',
    avatar: '/images/site/depoimentos/allan-gomes-la-ganexa.png'
  }
}];

var HomeSolutionsTabsV6 = function HomeSolutionsTabsV6() {
  var _useState = (0, _react.useState)(0),
      _useState2 = _slicedToArray(_useState, 2),
      activeIndex = _useState2[0],
      setActiveIndex = _useState2[1];

  var tab = TABS[activeIndex];

  return _react2.default.createElement(
    'div',
    { className: 'home-solutions-tabs-v6' },
    _react2.default.createElement(
      'div',
      { className: 'container' },
      _react2.default.createElement(
        'div',
        { className: 'header' },
        _react2.default.createElement(
          'h3',
          { className: 'title' },
          'A solu\xE7\xE3o mais pr\xE1tica, completa e segura para seu neg\xF3cio'
        ),
        _react2.default.createElement(
          'p',
          { className: 'description' },
          'Quando sua opera\xE7\xE3o comercial est\xE1 em jogo, n\xE3o h\xE1 espa\xE7o para erros.',
          _react2.default.createElement('br', null),
          'Milhares de empresas confiam na tecnologia, anos de experi\xEAncia e suporte dedicado da Mercos'
        )
      ),
      _react2.default.createElement(
        'nav',
        { className: 'tab-nav', role: 'tablist' },
        TABS.map(function (t, i) {
          return _react2.default.createElement(
            'button',
            {
              key: t.id,
              role: 'tab',
              'aria-selected': i === activeIndex,
              className: 'tab-btn' + (i === activeIndex ? ' tab-btn--active' : ''),
              onClick: function onClick() {
                return setActiveIndex(i);
              }
            },
            _react2.default.createElement('img', {
              src: t.icon,
              alt: '',
              className: 'tab-icon' + (t.iconInvert ? ' tab-icon--invert' : '')
            }),
            _react2.default.createElement(
              'span',
              { className: 'tab-label' },
              t.label
            )
          );
        })
      ),
      _react2.default.createElement(
        'div',
        { className: 'tab-content', role: 'tabpanel' },
        _react2.default.createElement(
          'div',
          { className: 'text-col' },
          tab.title ? _react2.default.createElement(
            'h4',
            { className: 'tab-title' },
            _react2.default.createElement(
              'span',
              { className: 'overtitle' },
              tab.overtitle
            ),
            tab.title
          ) : _react2.default.createElement(
            'span',
            { className: 'overtitle' },
            tab.overtitle
          ),
          tab.descriptions.map(function (desc, i) {
            return _react2.default.createElement(
              'p',
              { key: i, className: 'tab-description' },
              desc
            );
          }),
          tab.title && _react2.default.createElement(
            'a',
            { href: tab.saibaMaisHref, className: 'saiba-mais', target: '_blank', rel: 'noreferrer' },
            'saiba mais \u203A'
          ),
          !tab.title && _react2.default.createElement(
            'p',
            { className: 'coming-soon' },
            'Conte\xFAdo em breve.'
          )
        ),
        _react2.default.createElement(
          'div',
          { className: 'image-col' },
          tab.image && _react2.default.createElement(_Picture2.default, {
            loading: 'lazy',
            className: 'tab-image',
            src: tab.image.src,
            alt: tab.image.alt
          })
        )
      ),
      tab.testimonial && _react2.default.createElement(
        'div',
        { className: 'testimonial' },
        _react2.default.createElement(
          'div',
          { className: 'stars' },
          '\u2605\u2605\u2605\u2605\u2605'
        ),
        _react2.default.createElement(
          'p',
          { className: 'quote' },
          tab.testimonial.quote
        ),
        _react2.default.createElement(
          'div',
          { className: 'author' },
          tab.testimonial.avatar && _react2.default.createElement(_Picture2.default, {
            src: tab.testimonial.avatar,
            alt: tab.testimonial.author,
            className: 'author-avatar',
            width: 36,
            height: 36
          }),
          _react2.default.createElement(
            'div',
            { className: 'author-info' },
            _react2.default.createElement(
              'p',
              { className: 'author-name' },
              tab.testimonial.author
            ),
            _react2.default.createElement(
              'p',
              { className: 'author-company' },
              tab.testimonial.company
            )
          )
        )
      ),
      _react2.default.createElement(
        'div',
        { className: 'app-ratings-wrapper' },
        _react2.default.createElement(_AppRatings2.default, { onlyCards: true })
      )
    )
  );
};

exports.default = HomeSolutionsTabsV6;

/***/ }),

/***/ 682:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(9);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Picture = __webpack_require__(531);

var _Picture2 = _interopRequireDefault(_Picture);

var _constants = __webpack_require__(555);

__webpack_require__(683);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var AppRatings = function AppRatings(_ref) {
  var onlyCards = _ref.onlyCards;
  return _react2.default.createElement(
    "div",
    { className: "app-ratings-section-v5" },
    _react2.default.createElement(
      "div",
      { className: "app-ratings-section container" },
      !onlyCards && _react2.default.createElement(
        "div",
        { className: "section-header" },
        _react2.default.createElement(
          "h3",
          { className: "section-title" },
          "A solu\xE7\xE3o mais pr\xE1tica, completa e segura para seu neg\xF3cio"
        ),
        _react2.default.createElement(_Picture2.default, { loading: "lazy", className: "underline-gradient", src: "/images/underline-gradient.png", alt: "" }),
        _react2.default.createElement(
          "h4",
          { className: "section-description" },
          "Quando sua opera\xE7\xE3o comercial est\xE1 em jogo, n\xE3o h\xE1 espa\xE7o para erros. Milhares de empresas confiam na tecnologia, anos de experi\xEAncia e suporte dedicado da Mercos"
        )
      ),
      _react2.default.createElement(
        "div",
        { className: "ratings-wrapper" },
        _react2.default.createElement(
          "div",
          { className: "ia-rating-card" },
          _react2.default.createElement(
            "div",
            { className: "ia-rating-info" },
            _react2.default.createElement(
              "div",
              { className: "ia-rating-score" },
              _react2.default.createElement(
                "span",
                { className: "ia-rating-value" },
                _constants.SITE_CONSTANTS.GOOGLE_PLAY_RATING
              ),
              _react2.default.createElement(
                "span",
                { className: "ia-rating-star-char" },
                "\u2605"
              )
            ),
            _react2.default.createElement(
              "span",
              { className: "ia-rating-reviews-text" },
              _constants.SITE_CONSTANTS.GOOGLE_PLAY_REVIEWS
            )
          ),
          _react2.default.createElement(_Picture2.default, { className: "ia-rating-platform-logo", alt: "Google Play Logo", src: "/images/site/recursos/google-play.png" })
        ),
        _react2.default.createElement(
          "div",
          { className: "ia-rating-card" },
          _react2.default.createElement(
            "div",
            { className: "ia-rating-info" },
            _react2.default.createElement(
              "div",
              { className: "ia-rating-score" },
              _react2.default.createElement(
                "span",
                { className: "ia-rating-value" },
                _constants.SITE_CONSTANTS.APP_STORE_RATING
              ),
              _react2.default.createElement(
                "span",
                { className: "ia-rating-star-char" },
                "\u2605"
              )
            ),
            _react2.default.createElement(
              "span",
              { className: "ia-rating-reviews-text" },
              _constants.SITE_CONSTANTS.APP_STORE_REVIEWS
            )
          ),
          _react2.default.createElement(
            "div",
            { className: "ia-rating-platform-appstore" },
            _react2.default.createElement(_Picture2.default, { className: "ia-rating-platform-logo", alt: "Apple Logo", src: "/images/site/recursos/app-store.png" })
          )
        ),
        _react2.default.createElement(
          "div",
          { className: "ia-rating-card" },
          _react2.default.createElement(
            "div",
            { className: "ia-rating-info" },
            _react2.default.createElement(
              "div",
              { className: "ia-rating-score" },
              _react2.default.createElement(
                "span",
                { className: "ia-rating-value" },
                _constants.SITE_CONSTANTS.GOOGLE_BUSINESS_RATING
              ),
              _react2.default.createElement(
                "span",
                { className: "ia-rating-star-char" },
                "\u2605"
              )
            ),
            _react2.default.createElement(
              "span",
              { className: "ia-rating-reviews-text" },
              _constants.SITE_CONSTANTS.GOOGLE_BUSINESS_REVIEWS
            )
          ),
          _react2.default.createElement(_Picture2.default, { className: "ia-rating-platform-logo", alt: "Google Meu Neg\xF3cio Logo", src: "/images/site/recursos/google-meu-negocio.png" })
        )
      )
    )
  );
};

AppRatings.propTypes = {
  onlyCards: _propTypes2.default.bool
};

AppRatings.defaultProps = {
  onlyCards: false
};

exports.default = AppRatings;

/***/ }),

/***/ 683:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 684:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 685:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(9);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Picture = __webpack_require__(531);

var _Picture2 = _interopRequireDefault(_Picture);

var _SimpleAccordionContainer = __webpack_require__(627);

var _SimpleAccordionContainer2 = _interopRequireDefault(_SimpleAccordionContainer);

var _SimpleAccordionItem = __webpack_require__(604);

var _SimpleAccordionItem2 = _interopRequireDefault(_SimpleAccordionItem);

__webpack_require__(686);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IndustriesAndDistributorsTest = function IndustriesAndDistributorsTest(_ref) {
  var imageSrc = _ref.imageSrc,
      imageAlt = _ref.imageAlt,
      titleTag = _ref.titleTag;

  var TitleTag = titleTag || 'p';

  return _react2.default.createElement(
    "div",
    { className: "industries-distributors-section" },
    _react2.default.createElement(
      "div",
      { className: "container" },
      _react2.default.createElement(
        "div",
        { className: "content-wrapper" },
        _react2.default.createElement(
          "div",
          { className: "features-list" },
          _react2.default.createElement(
            "div",
            { className: "section-header" },
            _react2.default.createElement(
              "p",
              { className: "section-overtitle" },
              "Gest\xE3o alinhada e controle total"
            ),
            _react2.default.createElement(
              TitleTag,
              { className: "section-title" },
              "Ind\xFAstrias e Distribuidoras"
            ),
            _react2.default.createElement(
              "p",
              { className: "section-description" },
              "Sincronize pol\xEDticas comerciais e estoque em tempo real com os vendedores, otimize processos e impulsione as vendas. Tudo isso enquanto integra o Mercos a qualquer ERP"
            )
          ),
          _react2.default.createElement(
            _SimpleAccordionContainer2.default,
            { expand: "arrow", collapsable: true },
            _react2.default.createElement(
              _SimpleAccordionItem2.default,
              { title: "Fim dos erros e retrabalhos" },
              _react2.default.createElement(
                "p",
                null,
                "Gerenciamento de ponta a ponta da opera\xE7\xE3o comercial em um sistema intuitivo, com processos padronizados e sem digita\xE7\xE3o manual"
              )
            ),
            _react2.default.createElement(
              _SimpleAccordionItem2.default,
              { title: "Informa\xE7\xF5es centralizadas" },
              _react2.default.createElement(
                "p",
                null,
                "Indicadores, relat\xF3rios e o cruzamento de dados entre o Mercos e seu ERP, garantindo insights estrat\xE9gicos"
              )
            ),
            _react2.default.createElement(
              _SimpleAccordionItem2.default,
              { title: "Expans\xE3o do seu neg\xF3cio e vendas" },
              _react2.default.createElement(
                "p",
                null,
                "Recursos inteligentes que aumentam a produtividade da equipe, automatizam processos e d\xE3o mais controle para a gest\xE3o focar em crescimento de verdade"
              )
            )
          )
        ),
        _react2.default.createElement(
          "div",
          { className: "main-image" },
          _react2.default.createElement(_Picture2.default, { className: "img", src: imageSrc || "/images/site/new-home/update/ind.png", alt: imageAlt || "Imagem do sistema de vendas Mercos na parte esquerda e inferior da imagem, na versão mobile (app), aparecendo na tela de um celular, com um cliente e informações sobre seu pedido. Também há a versão desktop, no centro ao lado direito da imagem, mostrando a tela inicial do sistema com foco na aba de Indicadores, focando os indicadores Conversão do E-commerce, Carteira de Clientes e Curva ABC de Clientes." })
        )
      ),
      _react2.default.createElement(
        "div",
        { className: "icon-features" },
        _react2.default.createElement(
          "div",
          { className: "icon-feature-item" },
          _react2.default.createElement(
            "div",
            { className: "icon-wrapper" },
            _react2.default.createElement(_Picture2.default, { loading: "lazy", src: "/images/site/icons/tree.png", alt: "ERP Integrado" })
          ),
          _react2.default.createElement(
            "div",
            { className: "icon-feature-content" },
            _react2.default.createElement(
              "p",
              { className: "icon-feature-title" },
              "ERP",
              _react2.default.createElement("br", null),
              "Integrado"
            ),
            _react2.default.createElement(
              "p",
              { className: "icon-feature-description" },
              "Com a integra\xE7\xE3o a qualquer ERP, seu time digita pedidos e informa\xE7\xF5es uma vez s\xF3"
            )
          )
        ),
        _react2.default.createElement(
          "div",
          { className: "icon-feature-item" },
          _react2.default.createElement(
            "div",
            { className: "icon-wrapper" },
            _react2.default.createElement(_Picture2.default, { loading: "lazy", src: "/images/site/icons/person-frame.png", alt: "Portal do Cliente e E-commerce B2B" })
          ),
          _react2.default.createElement(
            "div",
            { className: "icon-feature-content" },
            _react2.default.createElement(
              "p",
              { className: "icon-feature-title" },
              "Portal do Cliente e",
              _react2.default.createElement("br", null),
              "E-commerce B2B"
            ),
            _react2.default.createElement(
              "p",
              { className: "icon-feature-description" },
              "Permita que os clientes fa\xE7am pedidos e acessem hist\xF3ricos e segundas vias de NFs"
            )
          )
        ),
        _react2.default.createElement(
          "div",
          { className: "icon-feature-item" },
          _react2.default.createElement(
            "div",
            { className: "icon-wrapper" },
            _react2.default.createElement(_Picture2.default, { loading: "lazy", src: "/images/site/icons/flag-white.png", alt: "Pol\xEDticas Comerciais" })
          ),
          _react2.default.createElement(
            "div",
            { className: "icon-feature-content" },
            _react2.default.createElement(
              "p",
              { className: "icon-feature-title" },
              "Pol\xEDticas",
              _react2.default.createElement("br", null),
              "Comerciais"
            ),
            _react2.default.createElement(
              "p",
              { className: "icon-feature-description" },
              "Defina regras claras de pre\xE7os, descontos e condi\xE7\xF5es de pagamento, evitando erros"
            )
          )
        ),
        _react2.default.createElement(
          "div",
          { className: "icon-feature-item" },
          _react2.default.createElement(
            "div",
            { className: "icon-wrapper" },
            _react2.default.createElement(_Picture2.default, { loading: "lazy", src: "/images/site/icons/sheet.png", alt: "Controle de produtos em estoque" })
          ),
          _react2.default.createElement(
            "div",
            { className: "icon-feature-content" },
            _react2.default.createElement(
              "p",
              { className: "icon-feature-title" },
              "Controle de produtos em estoque"
            ),
            _react2.default.createElement(
              "p",
              { className: "icon-feature-description" },
              "Controle do estoque em tempo real, evitando vender itens indispon\xEDveis"
            )
          )
        )
      )
    )
  );
};

IndustriesAndDistributorsTest.propTypes = {
  imageSrc: _propTypes2.default.string,
  imageAlt: _propTypes2.default.string,
  titleTag: _propTypes2.default.string
};

IndustriesAndDistributorsTest.defaultProps = {
  imageSrc: null,
  imageAlt: null,
  titleTag: 'p'
};

exports.default = IndustriesAndDistributorsTest;

/***/ }),

/***/ 686:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 687:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(9);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Picture = __webpack_require__(531);

var _Picture2 = _interopRequireDefault(_Picture);

var _SimpleAccordionContainer = __webpack_require__(627);

var _SimpleAccordionContainer2 = _interopRequireDefault(_SimpleAccordionContainer);

var _SimpleAccordionItem = __webpack_require__(604);

var _SimpleAccordionItem2 = _interopRequireDefault(_SimpleAccordionItem);

__webpack_require__(688);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DEFAULT_FEATURE_COPY = [{
    title: 'App de vendas',
    description: 'Emita pedidos de qualquer lugar pelo celular ou tablet, mesmo offline (Android e iOS)'
}, {
    title: 'E-commerce para representantes',
    description: 'Destaque seus produtos por representada, com as condições específicas de cada cliente.'
}, {
    title: 'CRM de vendas',
    description: 'Registre históricos e interações com clientes ativos e inativos, por carteira, pasta ou região'
}, {
    title: 'Agenda e Roteirização',
    description: 'Planeje visitas e organize o tempo de trabalho, otimizando deslocamento e produtividade'
}];

var CommercialReps = function CommercialReps(_ref) {
    var imageSrc = _ref.imageSrc,
        imageAlt = _ref.imageAlt,
        titleTag = _ref.titleTag,
        _ref$featureCopy = _ref.featureCopy,
        featureCopy = _ref$featureCopy === undefined ? DEFAULT_FEATURE_COPY : _ref$featureCopy;

    var TitleTag = titleTag || 'p';
    return _react2.default.createElement(
        'div',
        { className: 'commercial-reps-section' },
        _react2.default.createElement(
            'div',
            { className: 'container' },
            _react2.default.createElement(
                'div',
                { className: 'content-wrapper' },
                _react2.default.createElement(
                    'div',
                    { className: 'main-image' },
                    _react2.default.createElement(_Picture2.default, { src: imageSrc || "/images/site/new-home/update/reps.png", alt: imageAlt || "Representante, homem, mexendo no celular, com imagens saindo da tela mostrando o que ele está visualizando: o indicador Carteira de Clientes e um Pedido emitido pelo Mercos", className: 'img' })
                ),
                _react2.default.createElement(
                    'div',
                    { className: 'features-list' },
                    _react2.default.createElement(
                        'div',
                        { className: 'section-header' },
                        _react2.default.createElement(
                            'p',
                            { className: 'section-overtitle' },
                            'Produtividade e sucesso comercial'
                        ),
                        _react2.default.createElement(
                            TitleTag,
                            { className: 'section-title' },
                            'Representantes Comerciais'
                        ),
                        _react2.default.createElement(
                            'p',
                            { className: 'section-description' },
                            'Emita pedidos (mesmo offline) com o aplicativo para celular, automatize essa emiss\xE3o com o Pedidos com IA, venda online e impulsione suas vendas'
                        )
                    ),
                    _react2.default.createElement(
                        _SimpleAccordionContainer2.default,
                        { expand: 'arrow', collapsable: true },
                        _react2.default.createElement(
                            _SimpleAccordionItem2.default,
                            { title: 'Venda com praticidade e autonomia' },
                            _react2.default.createElement(
                                'p',
                                null,
                                'Importe suas planilhas e emita seu primeiro pedido em poucos minutos, sem depender de ningu\xE9m'
                            )
                        ),
                        _react2.default.createElement(
                            _SimpleAccordionItem2.default,
                            { title: 'Controle todas as suas representadas' },
                            _react2.default.createElement(
                                'p',
                                null,
                                'Tenha o controle total das suas representadas, comiss\xF5es e resultados em uma plataforma pensada para a rotina do representante'
                            )
                        ),
                        _react2.default.createElement(
                            _SimpleAccordionItem2.default,
                            { title: 'Acompanhe informa\xE7\xF5es em tempo real' },
                            _react2.default.createElement(
                                'p',
                                null,
                                'Pedidos, hist\xF3ricos de clientes, visitas e dados estrat\xE9gicos sempre \xE0 m\xE3o, para voc\xEA decidir com agilidade e vender com seguran\xE7a'
                            )
                        )
                    )
                )
            ),
            _react2.default.createElement(
                'div',
                { className: 'icon-features' },
                [{ icon: '/images/site/icons/smartphone.png', alt: 'App de vendas' }, { icon: '/images/site/icons/cart.png', alt: 'E-commerce para representantes' }, { icon: '/images/site/icons/graph-arrow-up.png', alt: 'CRM de vendas' }, { icon: '/images/site/icons/calendar-clock.png', alt: 'Agenda e Roteirização' }].map(function (feature, index) {
                    return _react2.default.createElement(
                        'div',
                        { className: 'icon-feature-item', key: feature.alt },
                        _react2.default.createElement(
                            'div',
                            { className: 'icon-wrapper' },
                            _react2.default.createElement(_Picture2.default, { loading: 'lazy', src: feature.icon, alt: feature.alt })
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: 'icon-feature-content' },
                            _react2.default.createElement(
                                'p',
                                { className: 'icon-feature-title' },
                                featureCopy[index].title
                            ),
                            _react2.default.createElement(
                                'p',
                                { className: 'icon-feature-description' },
                                featureCopy[index].description
                            )
                        )
                    );
                })
            )
        )
    );
};

CommercialReps.propTypes = {
    imageSrc: _propTypes2.default.string,
    imageAlt: _propTypes2.default.string,
    titleTag: _propTypes2.default.string,
    featureCopy: _propTypes2.default.arrayOf(_propTypes2.default.shape({
        title: _propTypes2.default.string,
        description: _propTypes2.default.string
    }))
};

CommercialReps.defaultProps = {
    imageSrc: null,
    imageAlt: null,
    titleTag: 'p',
    featureCopy: DEFAULT_FEATURE_COPY
};

exports.default = CommercialReps;

/***/ }),

/***/ 688:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 689:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

var _TestimonialVideoCards = __webpack_require__(594);

var _TestimonialVideoCards2 = _interopRequireDefault(_TestimonialVideoCards);

__webpack_require__(614);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TestimonialsVideoCardsV5Test = function TestimonialsVideoCardsV5Test(_ref) {
  var customTestimonials = _ref.customTestimonials;
  return _react2.default.createElement(
    'section',
    { className: 'ia-testimonial-section container' },
    _react2.default.createElement(_TestimonialVideoCards2.default, {
      isHome: true,
      isAI: false,
      noVideo: false,
      isDistributor: false,
      customTestimonials: customTestimonials,
      title: _react2.default.createElement(
        'span',
        { className: 'testimonials-v5-title' },
        '+ 9 mil clientes j\xE1 melhoraram sua opera\xE7\xE3o comercial com o Mercos'
      )
    })
  );
};

exports.default = TestimonialsVideoCardsV5Test;

/***/ }),

/***/ 690:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FAQV6_SCHEMA = exports.FAQV6_ITEMS = undefined;

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

var _UnifiedFAQ = __webpack_require__(563);

var _UnifiedFAQ2 = _interopRequireDefault(_UnifiedFAQ);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FAQV6_ITEMS = exports.FAQV6_ITEMS = [{
  question: 'O que é o Mercos?',
  paragraphs: ['O Mercos é um sistema de vendas para indústrias, distribuidoras e representantes comerciais que centraliza toda a operação de vendas em uma única plataforma. Reúne Inteligência Artificial, CRM, força de vendas, automação de pedidos, e-commerce B2B para vendas online, solução de pagamentos, dashboards inteligentes e integração com ERP em um só lugar.', 'Com o Mercos, sua empresa automatiza desde o cadastro de clientes e produtos até a emissão de pedidos, o acompanhamento de indicadores, a gestão da equipe de vendas e as vendas online. Assim, reduz processos manuais, ganha produtividade e toma decisões com base em dados atualizados em tempo real.']
}, {
  question: 'Por que usar o Mercos na minha indústria ou distribuidora?',
  paragraphs: ['O Mercos ajuda empresas a organizar, automatizar e ampliar toda a operação comercial em um só lugar. É possível reduzir erros na emissão de pedidos, automatizar processos, centralizar informações de clientes, produtos e vendedores, acompanhar indicadores em tempo real, integrar o ERP da empresa e oferecer uma experiência de compra online por meio do e-commerce B2B.', 'Além disso, a Mercos IA, a Inteligência Artificial do Mercos, reduz em até 90% o tempo gasto em tarefas que antes eram manuais, como criação de pedidos, geração de relatórios e análise de dados, permitindo que gestores e equipes comerciais foquem em vender mais e tomar decisões estratégicas.']
}, {
  question: 'Como o Mercos ajuda na gestão de pedidos e clientes?',
  paragraphs: ['O Mercos centraliza pedidos, clientes, produtos, tabelas de preços, condições comerciais, histórico de negociações e informações da equipe em um único sistema de vendas.', 'Com isso, vendedores emitem pedidos pelo aplicativo ou pelo sistema online, de forma prática e respeitando as tabelas e políticas comerciais, enquanto gestores acompanham a operação em tempo real. Ambos obtêm informações de clientes com poucos cliques.', 'Os seus clientes, por sua vez, podem realizar compras pelo e-commerce B2B, com regras comerciais integradas ao restante da operação. A plataforma também se integra ao ERP para manter os dados sincronizados entre as áreas comercial, financeira e administrativa.']
}, {
  question: 'O Mercos tem Inteligência Artificial para vendas?',
  paragraphs: ['Sim. A Mercos IA é uma Inteligência Artificial desenvolvida para apoiar gestores e equipes comerciais durante toda a operação de vendas.', 'Com ela, é possível emitir pedidos a partir de conversas no WhatsApp, imagens, PDFs, áudios e documentos, consultar informações sobre clientes, pedidos e indicadores, gerar dashboards e relatórios personalizados, além de receber resumos inteligentes para agilizar atendimentos e tomadas de decisão.']
}, {
  question: 'Como funciona o sistema de vendas Mercos?',
  paragraphs: ['O Mercos funciona na web, no WhatsApp e também em aplicativos para celulares e tablets (Android e iOS), permitindo que equipes comerciais trabalhem no escritório ou em campo.', 'Em uma única plataforma, gestores e vendedores acessam clientes, produtos, pedidos, CRM, indicadores, relatórios, agendas, políticas comerciais e histórico de vendas. O sistema automatiza processos, utiliza Inteligência Artificial para agilizar tarefas, integra-se ao ERP e permite vender tanto por equipes comerciais quanto por meio de um e-commerce B2B totalmente integrado à operação.']
}, {
  question: 'Quem pode usar o Mercos?',
  paragraphs: ['O Mercos foi desenvolvido para indústrias, distribuidoras, importadoras e representantes comerciais que desejam profissionalizar a gestão comercial, automatizar processos e aumentar a produtividade das equipes de vendas.', 'A plataforma atende empresas de diferentes portes e níveis de maturidade, desde operações em crescimento até estruturas comerciais mais complexas, oferecendo recursos para vendas externas, vendas internas, gestão de equipes, relacionamento com clientes e e-commerce B2B para ampliar as vendas digitais.']
}, {
  question: 'Como começar a usar o Mercos?',
  paragraphs: ['Você pode testar o Mercos gratuitamente por 7 dias, sem informar cartão de crédito, ou solicitar uma demonstração com um especialista.', 'Durante esse período, sua empresa conhece todos os recursos da plataforma e recebe orientação para identificar o plano mais adequado ao seu tamanho, estrutura comercial e objetivos de crescimento ao final do período gratuito.']
}, {
  question: 'O que faço se eu precisar de suporte adicional na utilização do Mercos?',
  paragraphs: ['A Mercos é reconhecida por seu suporte e atendimento próximos e de alto padrão, com um tempo de resposta de até 20 segundos em horário comercial, no WhatsApp ou chat, que fica dentro do sistema. Além disso, você pode acessar a Central de Ajuda, onde encontrará materiais e artigos que facilitam o uso do sistema.', 'Também é possível entrar em contato com o time de suporte pelo e-mail contato@mercos.com ou pelo telefone (47) 3481 8050, de segunda a quinta, das 9h às 17h, e sexta-feira, das 9h30 às 17h.']
}];

var FAQV6_SCHEMA = exports.FAQV6_SCHEMA = {
  "@context": "https://schema.org",
  "@type": "FAQPage",
  "mainEntity": [{
    "@type": "Question",
    "name": "O que é o Mercos?",
    "acceptedAnswer": {
      "@type": "Answer",
      "text": "O Mercos é um sistema de vendas para indústrias, distribuidoras e representantes comerciais que centraliza toda a operação de vendas em uma única plataforma. Reunimos Inteligência Artificial, CRM, força de vendas, automação de pedidos, e-commerce B2B para vendas online, solução de pagamentos, dashboards inteligentes e integração com ERP em um só lugar. Com o Mercos, sua empresa automatiza desde o cadastro de clientes e produtos até a emissão de pedidos, acompanhamento de indicadores, gestão da equipe de vendas e vendas online. Assim, reduz processos manuais, ganha produtividade e toma decisões com base em dados atualizados em tempo real."
    }
  }, {
    "@type": "Question",
    "name": "Por que usar o Mercos na minha indústria ou distribuidora?",
    "acceptedAnswer": {
      "@type": "Answer",
      "text": "O Mercos ajuda empresas a organizar, automatizar e ampliar toda a operação comercial em um só lugar. É possível reduzir erros na emissão de pedidos, automatizar processos, centralizar informações de clientes, produtos e vendedores, acompanhar indicadores em tempo real, integrar o ERP da empresa e oferecer uma experiência de compra online por meio do e-commerce B2B. Além disso, a Mercos IA, a Inteligência Artificial do Mercos, diminui em até 90% o tempo gasto em tarefas que antes eram manuais, como criação de pedidos, geração de relatórios e análise de dados, permitindo que gestores e equipes comerciais foquem em vender mais e tomar decisões estratégicas."
    }
  }, {
    "@type": "Question",
    "name": "Como o Mercos ajuda na gestão de pedidos e clientes?",
    "acceptedAnswer": {
      "@type": "Answer",
      "text": "O Mercos centraliza pedidos, clientes, produtos, tabelas de preço, condições comerciais, histórico de negociações e informações da equipe em um único sistema de vendas. Com isso, vendedores emitem pedidos pelo aplicativo ou pelo sistema online, de forma prática e respeitando as tabelas e políticas comerciais, enquanto gestores acompanham a operação em tempo real. Os clientes também podem realizar compras pelo e-commerce B2B com regras comerciais integradas ao restante da operação. A plataforma ainda se integra ao ERP para manter os dados sincronizados entre as áreas comercial, financeira e administrativa."
    }
  }, {
    "@type": "Question",
    "name": "O Mercos tem Inteligência Artificial para vendas?",
    "acceptedAnswer": {
      "@type": "Answer",
      "text": "Sim. A Mercos IA é uma Inteligência Artificial desenvolvida para apoiar gestores e equipes comerciais durante toda a operação de vendas. Com ela, é possível emitir pedidos a partir de conversas no WhatsApp, imagens, PDFs, áudios e documentos, consultar informações sobre clientes, pedidos e indicadores, gerar dashboards e relatórios personalizados, além de receber resumos inteligentes para agilizar atendimentos e tomadas de decisão."
    }
  }, {
    "@type": "Question",
    "name": "Como funciona o sistema de vendas Mercos?",
    "acceptedAnswer": {
      "@type": "Answer",
      "text": "O Mercos funciona na web, no WhatsApp e também em aplicativos para celulares e tablets Android e iOS, permitindo que equipes comerciais trabalhem no escritório ou em campo. Em uma única plataforma, gestores e vendedores acessam clientes, produtos, pedidos, CRM, indicadores, relatórios, agendas, políticas comerciais e histórico de vendas. O sistema automatiza processos, utiliza Inteligência Artificial para agilizar tarefas, integra-se ao ERP e permite vender tanto por equipes comerciais quanto por meio de um e-commerce B2B totalmente integrado à operação."
    }
  }, {
    "@type": "Question",
    "name": "Quem pode usar o Mercos?",
    "acceptedAnswer": {
      "@type": "Answer",
      "text": "O Mercos foi desenvolvido para indústrias, distribuidoras, importadoras e representantes comerciais que desejam profissionalizar a gestão comercial, automatizar processos e aumentar a produtividade das equipes de vendas. A plataforma atende empresas de diferentes portes e níveis de maturidade, desde operações em crescimento até estruturas comerciais mais complexas, oferecendo recursos para vendas externas, vendas internas, gestão de equipes, relacionamento com clientes e e-commerce B2B para ampliar as vendas digitais."
    }
  }, {
    "@type": "Question",
    "name": "Como começar a usar o Mercos?",
    "acceptedAnswer": {
      "@type": "Answer",
      "text": "Você pode testar o Mercos gratuitamente por 7 dias, sem informar cartão de crédito, ou solicitar uma demonstração com um especialista. Durante esse período, sua empresa conhece todos os recursos da plataforma e recebe orientação para identificar o plano mais adequado ao seu tamanho, estrutura comercial e objetivos de crescimento ao final do período gratuito."
    }
  }, {
    "@type": "Question",
    "name": "O que faço se eu precisar de suporte adicional na utilização do Mercos?",
    "acceptedAnswer": {
      "@type": "Answer",
      "text": "A Mercos é reconhecida por seu suporte e atendimento próximos e de alto padrão, com tempo de resposta de até 20 segundos em horário comercial, pelo WhatsApp ou chat dentro do sistema. Além disso, você pode acessar a Central de Ajuda, onde encontrará materiais e artigos que facilitam o uso do sistema. Também é possível entrar em contato com o time de suporte pelo e-mail contato@mercos.com ou pelo telefone (47) 3481 8050, de segunda a quinta, das 9h às 17h, e sexta-feira das 9h30 às 17h."
    }
  }]
};

var FAQV6 = function FAQV6(_ref) {
  var _ref$useSemanticHeadi = _ref.useSemanticHeadings,
      useSemanticHeadings = _ref$useSemanticHeadi === undefined ? false : _ref$useSemanticHeadi;

  var faqItems = FAQV6_ITEMS.map(function (_ref2) {
    var question = _ref2.question,
        paragraphs = _ref2.paragraphs;
    return {
      question: question,
      answer: _react2.default.createElement(
        _react.Fragment,
        null,
        paragraphs.map(function (paragraph, index) {
          return _react2.default.createElement(
            'p',
            { key: index },
            paragraph
          );
        })
      )
    };
  });

  return _react2.default.createElement(_UnifiedFAQ2.default, {
    subtitle: _react2.default.createElement(
      'p',
      null,
      'N\xE3o conhece o sistema de vendas da Mercos? Confira as principais d\xFAvidas que podem surgir.'
    ),
    faqItems: faqItems,
    titleTag: useSemanticHeadings ? 'h2' : 'p',
    questionTag: useSemanticHeadings ? 'h3' : 'span',
    titleId: 'mercos-faq-title'
  });
};

exports.default = FAQV6;

/***/ }),

/***/ 691:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (props) {
  var TitleTag = props.titleTag || 'h2';
  var links = props.links || {};
  var cards = props.cards || defaultCards(links);

  return _react2.default.createElement(
    _react.Fragment,
    null,
    _react2.default.createElement(
      'section',
      { className: 'cards-estrategias-v2' },
      _react2.default.createElement(
        'div',
        { className: 'container section-title' },
        _react2.default.createElement(
          TitleTag,
          { className: 'title' },
          'Confira os diferenciais Mercos'
        )
      ),
      _react2.default.createElement(
        'div',
        { className: 'wrapper' },
        cards.map(function (card, index) {
          return _react2.default.createElement(Card, {
            key: 'estrategia-card-' + index,
            imgSrc: card.imgSrc,
            imgAlt: card.imgAlt,
            title: card.title,
            description: card.description,
            link: card.link
          });
        })
      )
    )
  );
};

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

var _Picture = __webpack_require__(531);

var _Picture2 = _interopRequireDefault(_Picture);

__webpack_require__(692);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Card = function Card(_ref) {
  var imgSrc = _ref.imgSrc,
      imgAlt = _ref.imgAlt,
      title = _ref.title,
      description = _ref.description,
      link = _ref.link;

  var content = _react2.default.createElement(
    _react.Fragment,
    null,
    _react2.default.createElement(_Picture2.default, {
      className: 'new-sales-features-img',
      src: imgSrc,
      alt: imgAlt
    }),
    _react2.default.createElement(
      'div',
      { className: 'card-content' },
      _react2.default.createElement(
        'h4',
        { className: 'card-title' },
        title
      ),
      _react2.default.createElement(
        'p',
        { className: 'card-description' },
        description
      )
    )
  );

  if (link) {
    return _react2.default.createElement(
      'div',
      { className: 'card' },
      _react2.default.createElement(
        'a',
        { href: link, className: 'card-link-wrapper' },
        content
      )
    );
  }

  return _react2.default.createElement(
    'div',
    { className: 'card' },
    content
  );
};

var defaultCards = function defaultCards(links) {
  return [{
    imgSrc: "/images/site/new-home/update/indicadores.png",
    imgAlt: 'Imagem de alguns exemplos de indicadores em um sistema de vendas. Em foco, é possível ver "Análise por Regiões do Brasil", "Positivação de Clientes", "Curva ABC de Clientes" e "Carteira de Clientes", todas disponíveis na aba "Indicadores" do Mercos',
    title: "+ 25 indicadores e relatórios",
    description: "Acompanhe o desempenho da equipe, as metas e a situação das carteiras em tempo real",
    link: links.card1
  }, {
    imgSrc: "/images/site/new-home/update/suporte.png",
    imgAlt: 'Imagem do chat em tempo real do sistema de vendas, mostrando a pergunta "Olá, estou com uma dúvida, pode me ajudar?" e a resposta "Claro! Como posso lhe ajudar?"',
    title: _react2.default.createElement(
      _react.Fragment,
      null,
      'Suporte',
      _react2.default.createElement('br', null),
      ' em tempo real'
    ),
    description: _react2.default.createElement(
      _react.Fragment,
      null,
      'Respondemos a toda sua equipe ',
      _react2.default.createElement(
        'b',
        null,
        'em at\xE9 20 segundos'
      ),
      ' no chat ou WhatsApp em hor\xE1rio comercial'
    )
  }, {
    imgSrc: "/images/site/new-home/update/apoio.png",
    imgAlt: "",
    title: _react2.default.createElement(
      _react.Fragment,
      null,
      'Apoio integral para',
      _react2.default.createElement('br', null),
      '  sua equipe de TI'
    ),
    description: "Equipe profissional e preparada para tirar dúvidas do time de TI"
  }, {
    imgSrc: "/images/site/new-home/update/e-commerce.png",
    imgAlt: 'Imagem do E-commerce B2B Mercos com Videochamada, mostrando um site que vende canecas B2B, ou seja, para outras empresas. É possível ver uma caneca preta com a base bege, uma outra caneca preta com o topo cinza e uma jarra preta com cabo bege à venda, para que os clientes comprem diretamente do site, com o vendedor podendo acompanhar de perto, por vídeo',
    title: _react2.default.createElement(
      _react.Fragment,
      null,
      'E-commerce B2B',
      _react2.default.createElement('br', null),
      ' integrado ao For\xE7a de Vendas'
    ),
    description: "Clientes compram online com autonomia, condições personalizadas, informações atualizadas e histórico integrado",
    link: links.card4
  }, {
    imgSrc: "/images/site/new-home/update/mercos-pay.png",
    imgAlt: 'Imagem de um pedido feito na solução de pagamentos Mercos Pay. É possível ver que o comprador montou um carrinho, passou pela etapa de entrega e agora está na etapa de pagamento. A imagem mostra um pagamento sendo feito por boleto bancário, com quantidade de parcelas e detalhes do parcelamento.',
    title: "Mercos Pay",
    description: "A solução de pagamentos da Mercos permite recebimentos por cartão, boleto, link de pagamento ou Pix, direto do sistema",
    link: links.card5
  }, {
    imgSrc: "/images/site/new-home/update/solucoes-ia.png",
    imgAlt: 'Homem de óculos sorrindo e olhando para o celular, feliz por atender o cliente com as soluções com IA da Mercos. Ao seu lado aparece, com zoom na tela, a conversa que ele está tendo com um cliente, que envia: "Oi! Preciso fazer uma reposição. Posso mandar os itens aqui?". Ele responde "Claro!".',
    title: "Soluções com IA",
    description: "Nossas soluções com IA sugerem produtos com base no histórico do cliente e transformam mensagens em pedidos em segundos",
    link: links.card6
  }];
};

/***/ }),

/***/ 692:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 693:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(9);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(530);

var _classnames2 = _interopRequireDefault(_classnames);

var _Heading = __webpack_require__(565);

var _Heading2 = _interopRequireDefault(_Heading);

var _Heading3 = __webpack_require__(583);

var _Heading4 = _interopRequireDefault(_Heading3);

var _Heading5 = __webpack_require__(560);

var _Heading6 = _interopRequireDefault(_Heading5);

var _Paragraph = __webpack_require__(543);

var _Paragraph2 = _interopRequireDefault(_Paragraph);

__webpack_require__(694);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CompoundTitle = function CompoundTitle(_ref) {
    var children = _ref.children,
        className = _ref.className,
        center = _ref.center,
        mainTitle = _ref.mainTitle,
        overtitle = _ref.overtitle,
        right = _ref.right,
        small = _ref.small,
        white = _ref.white,
        purple = _ref.purple,
        purpleBar = _ref.purpleBar,
        tag = _ref.tag;
    return _react2.default.createElement(
        'div',
        { className: (0, _classnames2.default)(className, 'compound-title-container', white ? 'white' : '', center ? 'center' : '', right ? 'right' : '', purpleBar ? 'purpleBar' : '', purple && 'purple') },
        overtitle ? _react2.default.createElement(
            _Paragraph2.default,
            { className: 'overtitle' },
            overtitle
        ) : '',
        tag ? _react2.default.createElement(tag, { className: 'title heading2' }, children) : small ? _react2.default.createElement(
            _Heading6.default,
            { className: 'title' },
            children
        ) : mainTitle ? _react2.default.createElement(
            _Heading2.default,
            { className: 'title' },
            children
        ) : _react2.default.createElement(
            _Heading4.default,
            { className: 'title' },
            children
        )
    );
};

CompoundTitle.propTypes = {
    overtitle: _propTypes2.default.string
};

exports.default = CompoundTitle;

/***/ }),

/***/ 694:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 695:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ })

});


// WEBPACK FOOTER //
// templates/src/containers/site/NewHomev6.jsx.e312b615.js